<template>
  <div>
    <div
      :key="mainKey"
      class="container"
      id="main-task-window"
      v-if="false"
      :style="
        mode == 'reply-email'
          ? { height: '645px', top: '8px' }
          : { height: '934px', top: '0px' }
      "
    >
      <div class="row main-row">
        <div :class="classObject">
          <div class="row">
            <div class="col-md-12 top-buttons-row">
              <button
                class="btn btn-warning top-five-tags-btn"
                v-for="tag in topFiveTags"
                :key="tag.category.id"
                @click="addTagFromTopFiveTags(tag.category)"
              >
                #{{ tag.category.cat_type
                }}<span>&nbsp;|&nbsp;{{ tag.count }}</span>
              </button>
              <button
                class="btn btn-primary top-three-users-btn"
                v-for="user in topThreeUsers"
                :key="user.user.id"
                @click="addTagFromTopThreeUsers(user.user)"
              >
                @{{ user.user.full_name
                }}<span>&nbsp;|&nbsp;{{ user.count }}</span>
              </button>
            </div>
          </div>
          <div class="row" :class="classObjectFirstRowLeftSide">
            <div class="col-md-12 editor-bar">
              <div class="row text-editor-bar">
                <div class="col-md-12 editor-col">
                  <!--                <div-->
                  <!--                  class="row first-row-editor-col"-->
                  <!--                  v-if="mode !== 'reply-email'"-->
                  <!--                >-->
                  <!--                  <button-->
                  <!--                    class="btn btn-info btn-bar-btn btn-sm btn-block"-->
                  <!--                    @click.prevent="extend25"-->
                  <!--                    v-if="task"-->
                  <!--                  >-->
                  <!--                    EXTEND TASK +24h-->
                  <!--                  </button>-->
                  <!--                  <hr v-if="!task" style="margin-top: 15px;" />-->
                  <!--                </div>-->
                  <div class="row second-row-editor-col">
                    <div class="tabs-container">
                      <ul class="style-nav style2 sub-task-nav editor-nav">
                        <li
                          v-for="tab in editorTabs"
                          :key="tab.id"
                          :class="{ active: selectedEditorTab === tab.alias }"
                          @click="
                            () => {
                              selectedEditorTab = tab.alias;

                            }
                          "
                          :style="
                            // mode == 'reply'
                            mode == 'reply' &&
                            tab.alias == 'CAL' &&
                            checkIfReciverNotCreator()
                              ? { cursor: 'no-drop', pointerEvents: 'none' }
                              : null
                          "
                        >
                          {{
                            tab.alias === "REPLY"
                              ? transferUsers.length > 0
                                ? "Transfer to"
                                : tab.name.toUpperCase()
                              : tab.name.toUpperCase()
                          }}
                          {{
                            tab.alias === "REPLY"
                              ? transferUsers.length > 0
                                ? transferUsers[0][0].full_name
                                : ""
                              : ""
                          }}
                          <!--                        // : replyOpponent-->

                          <!--                        {{ // tab.alias === "REPLY" ? replyOpponent : "" }}-->
                          <TaskClock
                            class="add-task-timer"
                            :forceStopTimer="forceStopTimer"
                            :mode="mode"
                            v-if="!task && tab.alias === 'MT'"
                            @setAddNewTaskTimeDuration="
                              setAddNewTaskTimeDuration
                            "
                          ></TaskClock>
                          <span
                            v-if="
                              tab.alias !== 'MT' &&
                                tab.alias !== 'CAL' &&
                                tab.alias !== 'TASK' &&
                                tab.alias !== 'REPLY' &&
                                tab.alias !== 'LOG'
                            "
                            @click.stop="deleteEditorTab(tab)"
                          >
                            x
                          </span>
                        </li>

                        <div
                          class="sub-task-sub-menu"
                          v-if="subTasks.length < 4 && mode !== 'reply-email'"
                        >
                          <!--                        THIS IS A SECTION OF SUB TASKS-->

                          <!--                        <task-connect-menu-->
                          <!--                          @sendConnectedTaskId="setSelectedConnTaskId"-->
                          <!--                          :subTask="true"-->
                          <!--                          @addSubTaskTab="addSubTaskTab"-->
                          <!--                          :connectedTasks="newTask.selectedConnTaskId"-->
                          <!--                          v-if="!task || task.main_id !== null"-->
                          <!--                        ></task-connect-menu>-->
                        </div>
                      </ul>
                      <div class="styleCardContent padding editor-tabs">
                        <div
                          class="task-tab"
                          v-show="selectedEditorTab === 'CAL'"
                        >
                          <div id="calendar" class=" tab-pane active">
                            <calendar-component
                              :mode="mode"
                              :activeDate="activeDate"
                              v-on:changeModeToEdit="editWindowMode($event)"
                              :estTime="estTime"
                            />
                          </div>
                        </div>
                        <div
                          class="task-tab reply-editor-disabled"
                          v-show="selectedEditorTab === 'TASK'"
                          v-if="task"
                        >
                          <div class="tabs-container">
                            <ul class="style-nav style2 sub-task-user-nav">
                              <li
                                v-for="tab in taskSubTabs"
                                :key="tab.id"
                                :class="{
                                  active: selectedTaskSubTab === tab.alias
                                }"
                                @click="
                                  () => {
                                    selectedTaskSubTab = tab.alias;
                                  }
                                "
                              >
                                {{ tab.name.toUpperCase() }}
                              </li>
                            </ul>
                            <div class="styleCardContent  editor-tabs">
                              <div
                                class="task-tab"
                                v-show="selectedTaskSubTab === 'MT'"
                              >
                                <div class="tab-pane active">
                                  <vue-editor
                                    id="edit-task-editor"
                                    :disabled="isEditorDisabled"
                                    useCustomImageHandler
                                    @image-added="handleImageAdded"
                                    v-model="updatedTask.content"
                                    :editorOptions="replyEditorSettings"
                                    v-if="mode === 'reply'"
                                    :key="componentKeyEditor"
                                  />
                                  <vue-editor
                                    id="email-editor"
                                    v-if="mode === 'reply-email'"
                                    :disabled="isEditorDisabled"
                                    useCustomImageHandler
                                    @image-added="handleImageAdded"
                                    v-model="task.content"
                                    :editorOptions="replyEditorSettings"
                                  />
                                </div>
                              </div>
                              <div
                                class="task-tab"
                                v-if="task.sub_task_assignment.length > 0"
                              >
                                <div
                                  class="tab-pane active"
                                  v-for="(subTask, idx) in subTasks.subTasks"
                                  v-show="
                                    selectedTaskSubTab === `ST-${idx + 2}`
                                  "
                                  :key="idx"
                                >
                                  <!--                                <div class="tab-pane active"-->

                                  <!--                                     v-for="(subTask, idx) in task.sub_task_assignment"-->
                                  <!--                                     v-show="selectedTaskSubTab === `ST-${idx+2}`"-->

                                  <!--                                     :key="idx"-->

                                  <!--                                >-->
                                  <vue-editor
                                    :disabled="isEditorDisabled"
                                    useCustomImageHandler
                                    @image-added="handleImageAdded"
                                    v-model="subTask.content"
                                    :editorOptions="replyEditorSettings"
                                  />
                                </div>
                              </div>
                            </div>

                            <!--transfer mode-->
                          </div>
                        </div>
                        <div
                          class="task-tab reply-editor-disabled"
                          v-show="selectedEditorTab === 'ADD TO TASK'"
                          v-if="task"
                        >
                          <div class="tabs-container">
                            <ul class="style-nav style2 sub-task-user-nav">
                              <li
                                v-for="tab in taskSubTabs"
                                :key="tab.id"
                                :class="{
                                  active: selectedTaskSubTab === tab.alias
                                }"
                                @click="
                                  () => {
                                    selectedTaskSubTab = tab.alias;
                                  }
                                "
                              >
                                {{ tab.name.toUpperCase() }}
                              </li>
                            </ul>
                            <div class="styleCardContent  editor-tabs">
                              <div
                                class="task-tab"
                                v-show="selectedTaskSubTab === 'MT'"
                              >
                                <div class="tab-pane active">
                                  <vue-editor
                                    id="add-to-task-editor"
                                    :disabled="isEditorDisabled"
                                    useCustomImageHandler
                                    @image-added="handleImageAdded"
                                    v-model="additionToTaskContent"
                                    :editorOptions="replyEditorSettings"
                                    v-if="mode === 'reply'"
                                    :key="componentKeyEditor"
                                  />
                                </div>
                              </div>
                              <div
                                class="task-tab"
                                v-if="task.sub_task_assignment.length > 0"
                              >
                                <div
                                  class="tab-pane active"
                                  v-for="(subTask, idx) in subTasks.subTasks"
                                  v-show="
                                    selectedTaskSubTab === `ST-${idx + 2}`
                                  "
                                  :key="idx"
                                >
                                  <!--                                <div class="tab-pane active"-->

                                  <!--                                     v-for="(subTask, idx) in task.sub_task_assignment"-->
                                  <!--                                     v-show="selectedTaskSubTab === `ST-${idx+2}`"-->

                                  <!--                                     :key="idx"-->

                                  <!--                                >-->
                                  <vue-editor
                                    :disabled="isEditorDisabled"
                                    useCustomImageHandler
                                    @image-added="handleImageAdded"
                                    v-model="subTask.content"
                                    :editorOptions="replyEditorSettings"
                                  />
                                </div>
                              </div>
                            </div>

                            <!--transfer mode-->
                          </div>
                        </div>
                        <div
                          class="task-tab"
                          v-show="selectedEditorTab === 'REPLY'"
                          v-if="task"
                        >
                          <MainTaskWindowReply
                            :selectedReplyIdToUpdate="selectedReplyIdToUpdate"
                            :replyUsers="replyUsers"
                            :taskUsersTalking="taskUsersTalking"
                            :editorSettings="editorSettings"
                            :task="task"
                            :handleImageAdded="handleImageAdded"
                            :hashValues="hashValues"
                            :categoriesOfTask="newTask.cat_arr"
                            ref="replyWindow"
                            :assign-reply-to="assignReplyTo"
                            :replyContent="replyTaskTextFromLocal"
                            @creatorHasConfirmedTheTask="creatorConfirmedTask"
                            @taskRepliesForCheck="sendTaskreplies"
                            @addedTagFromReply="componentKeyTags += 1"
                            :selectedMainTab="tabForReply"
                            @setReplyContent="setReplyContent"
                            @clear_sets="clearReplySets"
                            :mode="mode"
                            :notApprovedStarRating="notApprovedStarRating"
                          />
                        </div>
                        <div
                          class="task-tab log-tab"
                          v-show="selectedEditorTab === 'LOG'"
                          v-if="task"
                        >
                          <TaskLogMainTaskWindow :task="task" />
                        </div>
                        <div
                          class="task-tab"
                          v-show="selectedEditorTab === 'MT'"
                        >
                          <div id="editor" class="tab-pane active">
                            <vue-editor
                              useCustomImageHandler
                              @image-added="handleImageAdded"
                              v-model="taskTextFromLocal"
                              :editorOptions="editorSettings"
                              id="new-task-editor"
                              ref="editor"
                              :key="componentKeyEditor"
                              :placeholder="addNewTaskEditorPlaceholder"
                            />
                          </div>
                        </div>

                        <div
                          v-for="subTask in subTasks"
                          class="tab-pane active"
                          v-show="selectedEditorTab === subTask.subTaskTab"
                          :key="subTask.subTaskId"
                        >
                          <vue-editor
                            useCustomImageHandler
                            @image-added="handleImageAdded"
                            :editorOptions="editorSettings"
                            v-model="subTask.subTaskContent"
                            ref="editor"
                          />
                        </div>
                      </div>
                    </div>
                    <!--                  <label class="checkbox-container">-->
                    <!--                    <input-->
                    <!--                      type="checkbox"-->
                    <!--                      @change="changeTaskPrivacy($event)"-->
                    <!--                    />-->
                    <!--                    <span class="checkmark"></span>-->
                    <!--                    : Private-->
                    <!--                  </label>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row tabs-timedate-container date-bar"
            v-if="mode !== 'reply-email'"
            :class="{
              // frozen: mode == 'reply'
              frozen: ifTimeFrameDisabled
            }"
          >
            <div class="col-md-1 col-position">
              <SelectTaskPosition
                @setTaskDateFromSelectPosition="setTaskDateFromSelectPosition"
                @changeNewTaskPosition="changeNewTaskPosition"
                :time-duration="newTask.timeQuantity"
                :user-related-tasks="newTask.userRelatedTasks"
                :primary-user="newTask.primaryUser"
                :assigned-users="newTask.taskUser"
              />
            </div>
            <div class="col-md-10 col-date">
              <TaskDateTime
                @changeTaskSubType="changeTaskSubType"
                v-on:setTaskDate="setTaskDate"
                v-on:changeActiveTaskTab="changeActiveTaskTab"
                v-on:changeActiveDateForCalendar="changeActiveDateForCalendar"
                @addEstTimeTag="addEstTimeTag"
                :repeat-type-options="
                  taskDictionaries.general.task_repeat_types
                "
                :task="task"
                :taskDate="taskDate"
                :key="keyDateTimeComponent"
                :changeEstTimeTitle="changeEstTimeTitle"
                :selectedEditorTab="selectedEditorTab"
                :taskType="newTask.taskType"
                :taskSubType="newTask.taskSubType"
                @outLineTaskDateTime="outline = true"
                @reapetOption="selectRepeatOption"
                :class="{
                  frozen: ifTimeFrameDisabled
                  // frozen: allowTimeFrameByUserRole()
                }"
              />
            </div>
            <div
              class="col-md-1 extend24"
              v-if="task && this.auth.user.id === this.getOriginalCreator()"
            >
              <button
                class="btn btn-primary "
                @click.prevent="extend25"
                v-if="task && mode !== 'reply-email'"
              >
                +24h
              </button>
            </div>
          </div>
          <div class="row buttons-row">
            <div class="col-md-12 buttons-bar">
              <TaskMainWindowButtonsBar
                @setMeetingLocation="setMeetingLocation"
                :replyTaskTextFromLocal="replyTaskTextFromLocal"
                @setRepOpt="setRepOtp"
                :repeat-type-options="
                  taskDictionaries.general.task_repeat_types
                "
                @clearDelay="clearDelay"
                :taskDelayed="taskDelayed"
                :ifInSaveDelayCondition="saveDelayCondition"
                @cancelDelayTask="cancelDelayTask"
                @star-rating="setStarRating"
                :syntheticCheckUser="updatedTask.userIn"
                :repeatOptionsObj="repeatOptionsObj"
                :showUpdateReplyBtn="showUpdateReplyBtn"
                :replyUsers="replyUsers"
                :taskUserSubStatus="taskUserSubStatus"
                :task="task"
                :mode="mode"
                :notApprovedStarRating="notApprovedStarRating"
                :taskInCheckProgress="taskInCheckProgress"
                :creatorHasConfirmedTheTask="creatorHasConfirmedTheTask"
                v-on:addNewTask="addNewTask"
                :newTask="newTask"
                :taskTextFromLocal="taskTextFromLocal"
                v-on:getMyTasks="getMyTasks"
                v-on:changeTransferMode="changeTransferMode"
                v-on:editTask="editTask"
                v-on:addToTask="addToTask"
                v-on:delayTask="delayTask"
                v-on:cancelEditTask="cancelEditTask"
                v-on:saveEditedTask="saveEditedTask"
                v-on:saveAddons="saveAddons"
                v-on:saveDelay="saveDelay"
                v-on:replyTask="replyTaskFromMain"
                @updateReply="updateReplyTaskFromMain"
                @cancelEditReply="cancelEditReply"
                v-on:renewTask="renewTask"
                v-on:taskToJunk="updateTaskStatus"
                :canTransfer="canTransferPlusContent()"
                @checkMe="checkMe"
                @syntheticCheck="syntheticCheck"
                @cancelCheck="cancelCheckFromMain"
                @replyEndTask="replyEndTaskFromMain"
                @IHaveSeenThatTaskIsConfirmed="taskIsConfirmed"
                :taskReplyForCheck="repliesSendToButtons"
                :transferUsers="transferUsers"
                :selectedTaskTab="selectedTaskTab"
                @emitAddNewSubTasks="addNewSubTasks"
                @approvedByCreator="approvedByCreator"
              />
            </div>
          </div>
          <div class="row categories-bar">
            <div class="col-md-5 first-col-categories-bar">
              <div
                class="row"
                :class="{
                  frozen: taskInCheckProgress
                }"
              >
                <div
                  class="col-md-12 categories-col"
                  :class="{ frozen: mode == 'reply-email' }"
                >
                  <div class="tabs-container">
                    <ul class="style-nav style2 sub-task-category-nav">
                      <li
                        v-for="tab in categoryTabs"
                        :key="tab.id"
                        :class="{ active: selectedCategoryTab === tab.alias }"
                        @click="
                          () => {
                            selectedCategoryTab = tab.alias;
                          }
                        "
                      >
                        {{ tab.name.toUpperCase() }}
                      </li>
                    </ul>
                    <div class="styleCardContent padding editor-tabs">
                      <div
                        class="task-tab"
                        v-show="
                          selectedCategoryTab === 'MT' ||
                            selectedCategoryTab === 'ADD TO TASK'
                        "
                      >
                        <SubCategoryTagsInput
                          @changeTitle="updateTitle"
                          :categoriesOfTask="newTask.cat_arr"
                          :key="componentKeyTags"
                        />
                      </div>
                      <div
                        v-for="subTask in subTasks"
                        class="tab-pane active"
                        v-show="selectedCategoryTab === subTask.subTaskTab"
                        :key="subTask.subTaskId"
                      >
                        <SubCategoryTagsInput
                          @changeTitle="
                            updateSubCategories($event, subTask.subTaskId)
                          "
                          :categoriesOfTask="subTask.subTaskCategory"
                          :key="componentKeyTags"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!--              <div class="col-md-2">-->
                <!--                &lt;!&ndash;                <label class="checkbox-container mb0mt10" title="high priority">&ndash;&gt;-->
                <!--                &lt;!&ndash;                  <input type="checkbox" v-model="priority"/>&ndash;&gt;-->
                <!--                &lt;!&ndash;                  <span class="checkmark"></span>&ndash;&gt;-->
                <!--                &lt;!&ndash;                  :hp&ndash;&gt;-->
                <!--                &lt;!&ndash;                </label>&ndash;&gt;-->
                <!--                &lt;!&ndash;                <label class="checkbox-container mb0mt10" title="Company meeting">&ndash;&gt;-->
                <!--                &lt;!&ndash;                  <input type="checkbox"/>&ndash;&gt;-->
                <!--                &lt;!&ndash;                  <span class="checkmark"></span>&ndash;&gt;-->
                <!--                &lt;!&ndash;                  :cm&ndash;&gt;-->
                <!--                &lt;!&ndash;                </label>&ndash;&gt;-->

                <!--                &lt;!&ndash;     <div class="col-md-2" v-if="mode !=='reply-email'">-->
                <!--                <label class="checkbox-container mb0mt10" title="high priority">-->
                <!--                  <input type="checkbox" v-model="priority"/>-->
                <!--                  <span class="checkmark"></span>-->
                <!--                  :hp-->
                <!--                </label>-->
                <!--                <label class="checkbox-container mb0mt10" title="Company meeting">-->
                <!--                  <input type="checkbox"/>-->
                <!--                  <span class="checkmark"></span>-->
                <!--                  :cm-->
                <!--                </label> &ndash;&gt;-->

                <!--                &lt;!&ndash;                <label class="checkbox-container mb0mt10" title="Outline">&ndash;&gt;-->
                <!--                &lt;!&ndash;                  <input type="checkbox" v-model="outline" />&ndash;&gt;-->
                <!--                &lt;!&ndash;                  <span class="checkmark"></span>&ndash;&gt;-->
                <!--                &lt;!&ndash;                  :ol&ndash;&gt;-->
                <!--                &lt;!&ndash;                </label>&ndash;&gt;-->
                <!--                <label class="checkbox-container mb0mt10" title="Announcement">-->
                <!--                  <input type="checkbox" />-->
                <!--                  <span class="checkmark"></span>-->
                <!--                  :an-->
                <!--                </label>-->
                <!--                <label-->
                <!--                  class="checkbox-container mb0mt10"-->
                <!--                  title="Repeated Meeting"-->
                <!--                >-->
                <!--                  <input type="checkbox" />-->
                <!--                  <span class="checkmark"></span>-->
                <!--                  :rm-->
                <!--                </label>-->
                <!--              </div>-->
                <!--              <div class="col-md-3 alert alert-info">-->
                <!--&lt;!&ndash;                <div class="row main-tab">&ndash;&gt;-->
                <!--&lt;!&ndash;                  <div class="col-md-12">&ndash;&gt;-->
                <!--&lt;!&ndash;                    {{ selectedTaskTab.toUpperCase() }}&ndash;&gt;-->
                <!--&lt;!&ndash;                  </div>&ndash;&gt;-->
                <!--&lt;!&ndash;                </div>&ndash;&gt;-->
                <!--              </div>-->
              </div>
            </div>
            <div
              class="col-md-7"
              v-if="mode !== 'reply-email'"
              :class="{
                frozen: taskInCheckProgress
              }"
            >
              <p>
                <span
                  v-if="
                    mode === 'reply' &&
                      checkUserPermissionForStartTimer() &&
                      this.task.task_type.id !== 2
                  "
                  style="color: red"
                  >{{ copyTimer }}</span
                ><span v-if="mode === 'reply'"
                  >&nbsp;&nbsp;Task id:#{{ task.id }}</span
                >
              </p>
              <!--                    <TaskClock-->
              <!--                      :mode="mode"-->
              <!--                      :task_id="task.id"-->
              <!--                      :class="task.id"-->
              <!--                      :forceStopTimer="forceStopTimer"-->
              <!--                      :user_id="task.user_status.user_id"-->
              <!--                      :times_arr="task.task_time_duration"-->
              <!--                      v-if="task"-->
              <!--                      @updated="fetchTasks"-->
              <!--                      :selectedMainTab="selectedTab"-->
              <!--                    ></TaskClock>-->
              <!--              <TaskClock-->
              <!--                class="add-task-timer"-->
              <!--                :forceStopTimer="forceStopTimer"-->
              <!--                :mode="mode"-->
              <!--                v-if="!task"-->
              <!--                @setAddNewTaskTimeDuration="setAddNewTaskTimeDuration"-->
              <!--              ></TaskClock>-->
              <span v-if="!task">&nbsp;&nbsp;Task id:#{{ newTaskId }}</span>
              <TimerLog v-if="task" :task="task" />
            </div>
          </div>
        </div>
        <div
          class="col-md-3 users-select-bar"
          v-if="mode !== 'reply-email'"
          :class="{
            frozen: taskInCheckProgress
          }"
        >
          <TaskUsersSelectMainWindow
            :ifInSaveDelayCondition="saveDelayCondition"
            :taskUsersTalkingUsersArray="taskUsersTalkingUsersArray"
            :replyUsers="replyUsers"
            :mode="mode"
            @changeTaskUser="changeTaskUser"
            @changeReplyUser="changeReplyUser"
            @userRelatedTasks="getUserRelatedTasks"
            v-on:setTaskUser="setTaskUser"
            :editMode="editMode"
            :transferMode="transferMode"
            :task="task"
            @taskIsEmail="setEmail"
            :transferUsers="transferUsers"
            :topFive="topFive"
            :taskUserStars="newTask.taskUser"
            @getTaskReadOnly="setTaskReadOnly"
            :countActiveUsersTasks="countActiveUsersTasks"
            @usersForTransfer="usersForTransfer"
            :usersTabs="mode == 'reply' ? usersTabs : usersTabs"
            :subTasks="subTasks"
            :selectedUserTab="
              selectedEditorTab == 'CAL' ||
              selectedEditorTab == 'TASK' ||
              selectedEditorTab == 'REPLY' ||
              selectedEditorTab == 'LOG'
                ? 'MT'
                : selectedEditorTab
            "
          />
        </div>
      </div>
      <div class="task-content-preview" v-if="mode == 'reply'">
        <div
          class="f-item replies-preview"
          id="replies-preview"
          v-click-outside="removeActiveClassReply"
          v-if="replies.length > 0"
          :key="keyTaskRepliesPreview"
        >
          <!--        -->
          <!--        :class="{-->
          <!--        frozen:-->
          <!--        taskInCheckProgress &&-->
          <!--        taskUserSubStatus != 'Finish it' &&-->
          <!--        taskUserSubStatus != 'Approved'-->
          <!--        }"-->
          <div :class="'reply-container-big'">
            <table class="table-sm table-bordered replies-table">
              <tbody>
                <template
                  :id="'selectUser-' + record.user.id"
                  v-for="(record, idx) in replies"
                >
                  <tr :key="record.id + 1">
                    <td
                      @click="editReply(record, idx)"
                      class="td-content ql-editor reply-content-td-item"
                      :class="
                        record.reply_by === auth.user.id && idx === 0
                          ? 'pointer'
                          : ''
                      "
                      v-html="record.content"
                      colspan="7"
                    ></td>
                  </tr>
                  <!--                <a :key="record.id + 1" class="edit-reply-btn">X</a>-->
                  <tr :key="record.id">
                    <td class="td-date">{{ record.updated_at | shortDate }}</td>
                    <td class="td-time">{{ record.updated_at | shortTime }}</td>

                    <template>
                      <td class="td-from">{{ record.user.full_name }}</td>
                      <td class="td-to">
                        {{ getUserReplyTo(record.reply_assignment) }}
                      </td>
                      <!--                    <td class="td-to">{{ getUserReplyTo(record.reply_by) }}</td>-->
                    </template>

                    <!--                  <template v-if="selectedTaskTab == 'waiting'">-->
                    <!--                    <td class="td-to">-->
                    <!--                      {{ getUserReplyTo(record.reply_assignment) }}-->
                    <!--                    </td>-->
                    <!--                    <td class="td-from">{{ record.user.full_name }}</td>-->
                    <!--                  </template>-->
                    <td class="td-process">
                      {{ getTaskSubStatusByUser(record.reply_by) }}
                    </td>
                    <td class="td-timer">
                      {{ getTimeReply(record.created_at) }}
                    </td>
                  </tr>
                </template>
              </tbody>
              <tfoot>
                <tr class="bg-primary">
                  <th scope="col">Date</th>
                  <th scope="col">Time</th>
                  <template>
                    <th scope="col">From</th>
                    <th scope="col">To</th>
                  </template>
                  <!--                <template v-if="selectedTaskTab == 'waiting'">-->
                  <!--                  <th scope="col">To</th>-->
                  <!--                  <th scope="col">From</th>-->
                  <!--                </template>-->
                  <th scope="col">Process</th>
                  <th scope="col">Time</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <div
          class="f-item task-preview"
          id="task-preview"
          v-click-outside="removeActiveClass"
        >
          <!--        <div class="addon-preview-wrapper" v-for="(addon, idx) in additionsToTask"  :key="idx">-->
          <!--        <vue-editor-->

          <!--                id="task-addon-preview-editor"-->
          <!--                :disabled="true"-->
          <!--                useCustomImageHandler-->
          <!--                @image-added="handleImageAdded"-->
          <!--                :v-model="addon"-->
          <!--                :editorOptions="taskPreviewEditorSettings"-->
          <!--                class="addon-preview"-->
          <!--        />-->
          <!--        </div>-->
          <p
            v-for="(addon, idx) in additionsToTask"
            :key="idx"
            v-html="addon"
            class="addon-preview ql-editor"
          ></p>
          <div v-if="additionsToTask.length > 0" class="addon-separator"></div>
          <vue-editor
            id="task-preview-editor"
            :disabled="true"
            useCustomImageHandler
            @image-added="handleImageAdded"
            v-model="task.content"
            :editorOptions="taskPreviewEditorSettings"
          />
          <!--        <div v-html="task.content"></div>-->
        </div>
      </div>

      <TaskVideoRec
        class="forRec"
        v-if="turnOnRec"
        @videoRec="sendRec"
        @closeRec="closeRecDiv"
      ></TaskVideoRec>
      <div class="loader-upload" v-if="requestUploadStatusBusy">
        <loader :size="'33px'"></loader>
      </div>
    </div>
    <div
      :key="mainKey"
      class="container"
      id="main-task-window-reply-new"
      v-if="mode === 'reply'"
    >
      <div class="row main-reply-window">
        <div class="col-md-4">
          <div
            class="row new-reply-left-side-first-row"
            :class="{
              frozen: taskInCheckProgress
            }"
          >
            <div
              class="col-md-12 categories-col"
              :class="{ frozen: mode == 'reply-email' }"
            >
              <div class="tabs-container">
                <ul class="style-nav style2 sub-task-category-nav">
                  <li
                    v-for="tab in categoryTabs"
                    :key="tab.id"
                    :class="{ active: selectedCategoryTab === tab.alias }"
                    @click="
                      () => {
                        selectedCategoryTab = tab.alias;
                      }
                    "
                  >
                    {{ tab.name.toUpperCase() }}
                  </li>
                </ul>
                <div class="styleCardContent padding editor-tabs">
                  <div
                    class="task-tab"
                    v-show="
                      selectedCategoryTab === 'MT' ||
                        selectedCategoryTab === 'ADD TO TASK'
                    "
                  >
                    <SubCategoryTagsInput
                      @changeTitle="updateTitle"
                      :categoriesOfTask="newTask.cat_arr"
                      :key="componentKeyTags"
                    />
                  </div>
                  <div
                    v-for="subTask in subTasks"
                    class="tab-pane active"
                    v-show="selectedCategoryTab === subTask.subTaskTab"
                    :key="subTask.subTaskId"
                  >
                    <SubCategoryTagsInput
                      @changeTitle="
                        updateSubCategories($event, subTask.subTaskId)
                      "
                      :categoriesOfTask="subTask.subTaskCategory"
                      :key="componentKeyTags"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row new-reply-left-side-second-row">
            <div
              class="col-md-12"
              v-if="mode !== 'reply-email'"
              :class="{
                frozen: taskInCheckProgress
              }"
            >
              <TaskUsersSelectMainWindow
                :taskUsersTalkingUsersArray="taskUsersTalkingUsersArray"
                :replyUsers="replyUsers"
                :mode="mode"
                @changeTaskUser="changeTaskUser"
                @changeReplyUser="changeReplyUser"
                @userRelatedTasks="getUserRelatedTasks"
                v-on:setTaskUser="setTaskUser"
                :editMode="editMode"
                :transferMode="transferMode"
                :task="task"
                @taskIsEmail="setEmail"
                :transferUsers="transferUsers"
                :topFive="topFive"
                :taskUserStars="newTask.taskUser"
                @getTaskReadOnly="setTaskReadOnly"
                :countActiveUsersTasks="countActiveUsersTasks"
                @usersForTransfer="usersForTransfer"
                :usersTabs="mode == 'reply' ? usersTabs : usersTabs"
                :subTasks="subTasks"
                :selectedUserTab="
                  selectedEditorTab == 'CAL' ||
                  selectedEditorTab == 'TASK' ||
                  selectedEditorTab == 'REPLY' ||
                  selectedEditorTab == 'LOG'
                    ? 'MT'
                    : selectedEditorTab
                "
              />
            </div>
          </div>
          <div class="row new-reply-left-side-third-row">
            <div
              class="col-md-12"
              v-if="mode !== 'reply-email'"
              :class="{
                frozen: taskInCheckProgress
              }"
            >
              <p>
                <span
                  v-if="
                    mode === 'reply' &&
                      checkUserPermissionForStartTimer() &&
                      this.task.task_type.id !== 2
                  "
                  style="color: red"
                  >{{ copyTimer }}</span
                ><span
                  v-tooltip.top="{
                  content: 'Copied!',
                   show: isTooltipCopyActive,
                   autoHide: false,
                   trigger: 'manual'
                  }"
                  class="btn copy-button"
                  style="cursor: pointer;border:none"
                  @click="copyStringToClipboard('#'+task.id)"
                  > Task id:#{{ task.id }}<i class="btn fas fa-copy"></i></span
                >
              </p>
              <!--                    <TaskClock-->
              <!--                      :mode="mode"-->
              <!--                      :task_id="task.id"-->
              <!--                      :class="task.id"-->
              <!--                      :forceStopTimer="forceStopTimer"-->
              <!--                      :user_id="task.user_status.user_id"-->
              <!--                      :times_arr="task.task_time_duration"-->
              <!--                      v-if="task"-->
              <!--                      @updated="fetchTasks"-->
              <!--                      :selectedMainTab="selectedTab"-->
              <!--                    ></TaskClock>-->
              <!--              <TaskClock-->
              <!--                class="add-task-timer"-->
              <!--                :forceStopTimer="forceStopTimer"-->
              <!--                :mode="mode"-->
              <!--                v-if="!task"-->
              <!--                @setAddNewTaskTimeDuration="setAddNewTaskTimeDuration"-->
              <!--              ></TaskClock>-->
              <span v-if="!task">&nbsp;&nbsp;Task id:#{{ newTaskId }}</span>
              <TimerLog v-if="task" :task="task" />
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="row new-reply-right-side-first-row">
            <div
              class="f-item replies-preview"
              v-if="replies.length > 0"
              :key="keyTaskRepliesPreview"
              id="replies-preview"
              v-click-outside="removeActiveClassReply"
            >
              <!--        -->
              <!--        :class="{-->
              <!--        frozen:-->
              <!--        taskInCheckProgress &&-->
              <!--        taskUserSubStatus != 'Finish it' &&-->
              <!--        taskUserSubStatus != 'Approved'-->
              <!--        }"-->
              <div :class="'reply-container-big'">
                <table class="table-sm table-bordered replies-table">
                  <tbody>
                    <template
                      :id="'selectUser-' + record.user.id"
                      v-for="(record, idx) in replies"
                    >
                      <tr
                        :class="{
                          'bg-light-gr': idx % 2 == 0
                        }"
                        :key="record.id + 1"
                      >
                        <td
                          @click="editReply(record, idx)"
                          class="td-content ql-editor reply-content-td-item"
                          :class="
                            record.reply_by === auth.user.id && idx === 0
                              ? 'pointer'
                              : ''
                          "
                          v-html="record.content"
                          colspan="7"
                        ></td>
                      </tr>
                      <!--                <a :key="record.id + 1" class="edit-reply-btn">X</a>-->
                      <tr
                        :class="{
                          'bg-light-gr': idx % 2 == 0
                        }"
                        :key="record.id"
                      >
                        <td class="td-date">
                          {{ record.updated_at | shortDate }}
                        </td>
                        <td class="td-time">
                          {{ record.updated_at | shortTime }}
                        </td>

                        <template>
                          <td class="td-from">{{ record.user.full_name }}</td>
                          <td class="td-to">
                            {{ getUserReplyTo(record.reply_assignment) }}
                          </td>
                          <!--                    <td class="td-to">{{ getUserReplyTo(record.reply_by) }}</td>-->
                        </template>

                        <!--                  <template v-if="selectedTaskTab == 'waiting'">-->
                        <!--                    <td class="td-to">-->
                        <!--                      {{ getUserReplyTo(record.reply_assignment) }}-->
                        <!--                    </td>-->
                        <!--                    <td class="td-from">{{ record.user.full_name }}</td>-->
                        <!--                  </template>-->
                        <td class="td-process">
                          {{ getTaskSubStatusByUser(record.reply_by) }}
                        </td>
                        <td class="td-timer">
                          {{ getTimeReply(record.created_at) }}
                        </td>
                      </tr>
                    </template>
                  </tbody>
                  <tfoot>
                    <tr class="bg-primary">
                      <th scope="col">Date</th>
                      <th scope="col">Time</th>
                      <template>
                        <th scope="col">From</th>
                        <th scope="col">To</th>
                      </template>
                      <!--                <template v-if="selectedTaskTab == 'waiting'">-->
                      <!--                  <th scope="col">To</th>-->
                      <!--                  <th scope="col">From</th>-->
                      <!--                </template>-->
                      <th scope="col">Process</th>
                      <th scope="col">Time</th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div class="row new-reply-right-side-second-row">
            <div class="row top-btns-row-new">
              <div class="col-md-12 top-buttons-row">
                <button
                  class="btn btn-warning top-five-tags-btn"
                  v-for="tag in topFiveTags"
                  :key="tag.category.id"
                  @click="addTagFromTopFiveTags(tag.category)"
                >
                  #{{ tag.category.cat_type
                  }}<span>&nbsp;|&nbsp;{{ tag.count }}</span>
                </button>
                <button
                  class="btn btn-primary top-three-users-btn"
                  v-for="user in topThreeUsers"
                  :key="user.user.id"
                  @click="addTagFromTopThreeUsers(user.user)"
                >
                  @{{ user.user.full_name
                  }}<span>&nbsp;|&nbsp;{{ user.count }}</span>
                </button>
              </div>
            </div>
            <div class="row" :class="classObjectFirstRowLeftSide">
              <div class="col-md-12 editor-bar">
                <div class="row text-editor-bar">
                  <div class="col-md-12 editor-col">
                    <!--                <div-->
                    <!--                  class="row first-row-editor-col"-->
                    <!--                  v-if="mode !== 'reply-email'"-->
                    <!--                >-->
                    <!--                  <button-->
                    <!--                    class="btn btn-info btn-bar-btn btn-sm btn-block"-->
                    <!--                    @click.prevent="extend25"-->
                    <!--                    v-if="task"-->
                    <!--                  >-->
                    <!--                    EXTEND TASK +24h-->
                    <!--                  </button>-->
                    <!--                  <hr v-if="!task" style="margin-top: 15px;" />-->
                    <!--                </div>-->
                    <div class="row second-row-editor-col">
                      <div class="tabs-container-new">
                        <ul class="style-nav style2 sub-task-nav editor-nav">
                          <li
                            v-for="tab in editorTabs"
                            :key="tab.id"
                            :class="{ active: selectedEditorTab === tab.alias }"
                            @click="
                              () => {
                                selectedEditorTab = tab.alias;
                              }
                            "
                            :style="
                              // mode == 'reply'
                              mode == 'reply' &&
                              tab.alias == 'CAL' &&
                              checkIfReciverNotCreator()
                                ? { cursor: 'no-drop', pointerEvents: 'none' }
                                : null
                            "
                          >
                            {{
                              tab.alias === "REPLY"
                                ? transferUsers.length > 0
                                  ? "Transfer to"
                                  : tab.name.toUpperCase()
                                : tab.name.toUpperCase()
                            }}
                            {{
                              tab.alias === "REPLY"
                                ? transferUsers.length > 0
                                  ? transferUsers[0][0].full_name
                                  : ""
                                : ""
                            }}
                            <!--                        // : replyOpponent-->

                            <!--                        {{ // tab.alias === "REPLY" ? replyOpponent : "" }}-->
                            <TaskClock
                              class="add-task-timer"
                              :forceStopTimer="forceStopTimer"
                              :mode="mode"
                              v-if="!task && tab.alias === 'MT'"
                              @setAddNewTaskTimeDuration="
                                setAddNewTaskTimeDuration
                              "
                            ></TaskClock>
                            <span
                              v-if="
                                tab.alias !== 'MT' &&
                                  tab.alias !== 'CAL' &&
                                  tab.alias !== 'TASK' &&
                                  tab.alias !== 'REPLY' &&
                                  tab.alias !== 'LOG'
                              "
                              @click.stop="deleteEditorTab(tab)"
                            >
                              x
                            </span>
                          </li>

                          <div
                            class="sub-task-sub-menu"
                            v-if="subTasks.length < 4 && mode !== 'reply-email'"
                          >
                            <!--                        THIS IS A SECTION OF SUB TASKS-->

                            <!--                        <task-connect-menu-->
                            <!--                          @sendConnectedTaskId="setSelectedConnTaskId"-->
                            <!--                          :subTask="true"-->
                            <!--                          @addSubTaskTab="addSubTaskTab"-->
                            <!--                          :connectedTasks="newTask.selectedConnTaskId"-->
                            <!--                          v-if="!task || task.main_id !== null"-->
                            <!--                        ></task-connect-menu>-->
                          </div>
                        </ul>
                        <div class="styleCardContent padding editor-tabs">
                          <div
                            class="task-tab"
                            v-show="selectedEditorTab === 'CAL'"
                          >
                            <div id="calendar-reply" class=" tab-pane active">
                              <calendar-component
                                :mode="mode"
                                :activeDate="activeDate"
                                v-on:changeModeToEdit="editWindowMode($event)"
                                :estTime="estTime"
                              />
                            </div>
                          </div>
                          <div
                            class="task-tab reply-editor-disabled"
                            v-show="selectedEditorTab === 'TASK'"
                            v-if="task"
                          >
                            <div class="tabs-container">
                              <ul
                                class="style-nav style2 sub-task-user-nav-new"
                              >
                                <li
                                  v-for="tab in taskSubTabs"
                                  :key="tab.id"
                                  :class="{
                                    active: selectedTaskSubTab === tab.alias
                                  }"
                                  @click="
                                    () => {
                                      selectedTaskSubTab = tab.alias;
                                    }
                                  "
                                >
                                  {{ tab.name.toUpperCase() }}
                                </li>
                              </ul>
                              <div class="styleCardContent  editor-tabs">
                                <div
                                  class="task-tab"
                                  v-show="selectedTaskSubTab === 'MT'"
                                >
                                  <div class="tab-pane active">
                                    <vue-editor
                                      id="edit-task-editor"
                                      :disabled="isEditorDisabled"
                                      useCustomImageHandler
                                      @image-added="handleImageAdded"
                                      v-model="updatedTask.content"
                                      :editorOptions="replyEditorSettings"
                                      v-if="mode === 'reply'"
                                      :key="componentKeyEditor"
                                    />
                                    <vue-editor
                                      id="email-editor"
                                      v-if="mode === 'reply-email'"
                                      :disabled="isEditorDisabled"
                                      useCustomImageHandler
                                      @image-added="handleImageAdded"
                                      v-model="task.content"
                                      :editorOptions="replyEditorSettings"
                                    />
                                  </div>
                                </div>
                                <div
                                  class="task-tab"
                                  v-if="task.sub_task_assignment.length > 0"
                                >
                                  <div
                                    class="tab-pane active"
                                    v-for="(subTask, idx) in subTasks.subTasks"
                                    v-show="
                                      selectedTaskSubTab === `ST-${idx + 2}`
                                    "
                                    :key="idx"
                                  >
                                    <!--                                <div class="tab-pane active"-->

                                    <!--                                     v-for="(subTask, idx) in task.sub_task_assignment"-->
                                    <!--                                     v-show="selectedTaskSubTab === `ST-${idx+2}`"-->

                                    <!--                                     :key="idx"-->

                                    <!--                                >-->
                                    <vue-editor
                                      :disabled="isEditorDisabled"
                                      useCustomImageHandler
                                      @image-added="handleImageAdded"
                                      v-model="subTask.content"
                                      :editorOptions="replyEditorSettings"
                                    />
                                  </div>
                                </div>
                              </div>

                              <!--transfer mode-->
                            </div>
                          </div>
                          <div
                            class="task-tab reply-editor-disabled"
                            v-show="selectedEditorTab === 'ADD TO TASK'"
                            v-if="task"
                          >
                            <div class="tabs-container">
                              <ul
                                class="style-nav style2 sub-task-user-nav-new"
                              >
                                <li
                                  v-for="tab in taskSubTabs"
                                  :key="tab.id"
                                  :class="{
                                    active: selectedTaskSubTab === tab.alias
                                  }"
                                  @click="
                                    () => {
                                      selectedTaskSubTab = tab.alias;
                                    }
                                  "
                                >
                                  {{ tab.name.toUpperCase() }}
                                </li>
                              </ul>
                              <div class="styleCardContent  editor-tabs">
                                <div
                                  class="task-tab"
                                  v-show="selectedTaskSubTab === 'MT'"
                                >
                                  <div class="tab-pane active">
                                    <vue-editor
                                      id="add-to-task-editor"
                                      :disabled="isEditorDisabled"
                                      useCustomImageHandler
                                      @image-added="handleImageAdded"
                                      v-model="additionToTaskContent"
                                      :editorOptions="replyEditorSettings"
                                      v-if="mode === 'reply'"
                                      :key="componentKeyEditor"
                                    />
                                  </div>
                                </div>
                                <div
                                  class="task-tab"
                                  v-if="task.sub_task_assignment.length > 0"
                                >
                                  <div
                                    class="tab-pane active"
                                    v-for="(subTask, idx) in subTasks.subTasks"
                                    v-show="
                                      selectedTaskSubTab === `ST-${idx + 2}`
                                    "
                                    :key="idx"
                                  >
                                    <!--                                <div class="tab-pane active"-->

                                    <!--                                     v-for="(subTask, idx) in task.sub_task_assignment"-->
                                    <!--                                     v-show="selectedTaskSubTab === `ST-${idx+2}`"-->

                                    <!--                                     :key="idx"-->

                                    <!--                                >-->
                                    <vue-editor
                                      :disabled="isEditorDisabled"
                                      useCustomImageHandler
                                      @image-added="handleImageAdded"
                                      v-model="subTask.content"
                                      :editorOptions="replyEditorSettings"
                                    />
                                  </div>
                                </div>
                              </div>

                              <!--transfer mode-->
                            </div>
                          </div>
                          <div
                            class="task-tab"
                            v-show="selectedEditorTab === 'REPLY'"
                            v-if="task"
                          >
                            <MainTaskWindowReply
                              :selectedReplyIdToUpdate="selectedReplyIdToUpdate"
                              :replyUsers="replyUsers"
                              :taskUsersTalking="taskUsersTalking"
                              :editorSettings="editorSettings"
                              :task="task"
                              :handleImageAdded="handleImageAdded"
                              :hashValues="hashValues"
                              :categoriesOfTask="newTask.cat_arr"
                              ref="replyWindow"
                              :assign-reply-to="assignReplyTo"
                              :replyContent="replyTaskTextFromLocal"
                              @creatorHasConfirmedTheTask="creatorConfirmedTask"
                              @taskRepliesForCheck="sendTaskreplies"
                              @addedTagFromReply="componentKeyTags += 1"
                              :selectedMainTab="tabForReply"
                              @setReplyContent="setReplyContent"
                              @clear_sets="clearReplySets"
                              :mode="mode"
                              :notApprovedStarRating="notApprovedStarRating"
                            />
                          </div>
                          <div
                            class="task-tab log-tab-new"
                            v-show="selectedEditorTab === 'LOG'"
                            v-if="task"
                          >
                            <TaskLogMainTaskWindow :task="task" />
                          </div>
                          <div
                            class="task-tab"
                            v-show="selectedEditorTab === 'MT'"
                          >
                            <div id="editor" class="tab-pane active">
                              <vue-editor
                                useCustomImageHandler
                                @image-added="handleImageAdded"
                                v-model="taskTextFromLocal"
                                :editorOptions="editorSettings"
                                id="new-task-editor"
                                ref="editor"
                                :key="componentKeyEditor"
                                :placeholder="addNewTaskEditorPlaceholder"
                              />
                            </div>
                          </div>
                          <div
                            v-for="subTask in subTasks"
                            class="tab-pane active"
                            v-show="selectedEditorTab === subTask.subTaskTab"
                            :key="subTask.subTaskId"
                          >
                            <vue-editor
                              useCustomImageHandler
                              @image-added="handleImageAdded"
                              :editorOptions="editorSettings"
                              v-model="subTask.subTaskContent"
                              ref="editor"
                            />
                          </div>
                        </div>
                      </div>
                      <!--                  <label class="checkbox-container">-->
                      <!--                    <input-->
                      <!--                      type="checkbox"-->
                      <!--                      @change="changeTaskPrivacy($event)"-->
                      <!--                    />-->
                      <!--                    <span class="checkmark"></span>-->
                      <!--                    : Private-->
                      <!--                  </label>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row tabs-timedate-container date-bar"
              v-if="mode !== 'reply-email'"
              :class="{
                // frozen: mode == 'reply'
                // frozen: ifTimeFrameDisabled
              }"
            >
              <div class="col-md-1 col-position">
                <SelectTaskPosition
                  @setTaskDateFromSelectPosition="setTaskDateFromSelectPosition"
                  @changeNewTaskPosition="changeNewTaskPosition"
                  :time-duration="newTask.timeQuantity"
                  :user-related-tasks="newTask.userRelatedTasks"
                  :primary-user="newTask.primaryUser"
                  :assigned-users="newTask.taskUser"
                />
              </div>
              <div class="col-md-10 col-date">
                <TaskDateTime
                  :taskSubType="newTask.taskSubType"
                  @changeTaskSubType="changeTaskSubType"
                  :taskType="newTask.taskType"
                  :ifTimeFrameDisabled="ifTimeFrameDisabled"
                  v-on:setTaskDate="setTaskDate"
                  v-on:changeActiveTaskTab="changeActiveTaskTab"
                  v-on:changeActiveDateForCalendar="changeActiveDateForCalendar"
                  @addEstTimeTag="addEstTimeTag"
                  :repeat-type-options="
                    taskDictionaries.general.task_repeat_types
                  "
                  :task="task"
                  :taskDate="taskDate"
                  :key="keyDateTimeComponent"
                  :changeEstTimeTitle="changeEstTimeTitle"
                  :selectedEditorTab="selectedEditorTab"
                  @outLineTaskDateTime="outline = true"
                  @reapetOption="selectRepeatOption"
                  :class="{
                    // frozen: ifTimeFrameDisabled
                    // frozen: allowTimeFrameByUserRole()
                  }"
                />
              </div>
              <div
                class="col-md-1 extend24"
                v-if="task && this.auth.user.id === this.getOriginalCreator()"
              >
                <button
                  class="btn btn-primary "
                  @click.prevent="extend25"
                  v-if="task && mode !== 'reply-email'"
                >
                  +24h
                </button>
              </div>
            </div>
            <div class="row buttons-row">
              <div class="col-md-12 buttons-bar">
                <TaskMainWindowButtonsBar
                    v-on:changeActiveTaskTab="changeActiveTaskTab"

                    @setMeetingLocation="setMeetingLocation"
                  :replyTaskTextFromLocal="replyTaskTextFromLocal"
                  @setRepOpt="setRepOtp"
                  :repeat-type-options="
                    taskDictionaries.general.task_repeat_types
                  "
                  :taskDelayed="taskDelayed"
                  @clearDelay="clearDelay"
                  :ifInSaveDelayCondition="saveDelayCondition"
                  @cancelDelayTask="cancelDelayTask"
                  @star-rating="setStarRating"
                  :syntheticCheckUser="updatedTask.userIn"
                  :repeatOptionsObj="repeatOptionsObj"
                  :showUpdateReplyBtn="showUpdateReplyBtn"
                  :replyUsers="replyUsers"
                  :taskUserSubStatus="taskUserSubStatus"
                  :task="task"
                  :mode="mode"
                  :notApprovedStarRating="notApprovedStarRating"
                  :taskInCheckProgress="taskInCheckProgress"
                  :creatorHasConfirmedTheTask="creatorHasConfirmedTheTask"
                  v-on:addNewTask="addNewTask"
                  :newTask="newTask"
                  :taskTextFromLocal="taskTextFromLocal"
                  v-on:getMyTasks="getMyTasks"
                  v-on:changeTransferMode="changeTransferMode"
                  v-on:editTask="editTask"
                  v-on:addToTask="addToTask"
                  v-on:delayTask="delayTask"
                  v-on:cancelEditTask="cancelEditTask"
                  v-on:saveEditedTask="saveEditedTask"
                  v-on:saveAddons="saveAddons"
                  v-on:saveDelay="saveDelay"
                  v-on:replyTask="replyTaskFromMain"
                  @updateReply="updateReplyTaskFromMain"
                  @cancelEditReply="cancelEditReply"
                  v-on:renewTask="renewTask"
                  v-on:taskToJunk="updateTaskStatus"
                  :canTransfer="canTransferPlusContent()"
                  @checkMe="checkMe"
                  @syntheticCheck="syntheticCheck"
                  @cancelCheck="cancelCheckFromMain"
                  @replyEndTask="replyEndTaskFromMain"
                  @IHaveSeenThatTaskIsConfirmed="taskIsConfirmed"
                  :taskReplyForCheck="repliesSendToButtons"
                  :transferUsers="transferUsers"
                  :selectedTaskTab="selectedTaskTab"
                  @emitAddNewSubTasks="addNewSubTasks"
                  @approvedByCreator="approvedByCreator"
                />
              </div>
            </div>
          </div>
          <div class="row new-reply-right-side-third-row">
            <div
              class="f-item task-preview"
              id="task-preview"
              v-click-outside="removeActiveClass"
            >
              <!--        <div class="addon-preview-wrapper" v-for="(addon, idx) in additionsToTask"  :key="idx">-->
              <!--        <vue-editor-->

              <!--                id="task-addon-preview-editor"-->
              <!--                :disabled="true"-->
              <!--                useCustomImageHandler-->
              <!--                @image-added="handleImageAdded"-->
              <!--                :v-model="addon"-->
              <!--                :editorOptions="taskPreviewEditorSettings"-->
              <!--                class="addon-preview"-->
              <!--        />-->
              <!--        </div>-->
              <p
                v-for="(addon, idx) in additionsToTask"
                :key="idx"
                v-html="addon"
                class="addon-preview ql-editor"
              ></p>
              <div
                v-if="additionsToTask.length > 0"
                class="addon-separator"
              ></div>
              <vue-editor
                  v-if="false"
                id="task-preview-editor"
                :disabled="true"
                useCustomImageHandler
                @image-added="handleImageAdded"
                v-model="task.content"
                :editorOptions="taskPreviewEditorSettings"
              />

                      <div id="task-preview" class="task-preview-div">
                        <TaskPreview :content="task.content"/>
                      </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loader-upload" v-if="requestUploadStatusBusy">
        <loader :size="'33px'"></loader>
      </div>
    </div>
    <div
      :key="mainKey"
      class="container"
      id="main-task-window-add-new"
      v-if="mode === 'add'"
    >
      <div class="row main-add-window">
        <div class="col-md-4">
          <div class="row new-add-left-side-first-row">
            <TaskProjectSelect @selectProject="joinTaskToProject" />
          </div>
          <div class="row new-add-left-side-second-row">
            <div
              class="col-md-12"
              v-if="mode !== 'reply-email'"
              :class="{
                frozen: taskInCheckProgress
              }"
            >
              <TaskUsersSelectMainWindow
                :taskUsersTalkingUsersArray="taskUsersTalkingUsersArray"
                :replyUsers="replyUsers"
                :mode="mode"
                @changeTaskUser="changeTaskUser"
                @changeReplyUser="changeReplyUser"
                @userRelatedTasks="getUserRelatedTasks"
                v-on:setTaskUser="setTaskUser"
                :editMode="editMode"
                :transferMode="transferMode"
                :task="task"
                @taskIsEmail="setEmail"
                :transferUsers="transferUsers"
                :topFive="topFive"
                :taskUserStars="newTask.taskUser"
                @getTaskReadOnly="setTaskReadOnly"
                :countActiveUsersTasks="countActiveUsersTasks"
                @usersForTransfer="usersForTransfer"
                :usersTabs="mode == 'reply' ? usersTabs : usersTabs"
                :subTasks="subTasks"
                :selectedUserTab="
                  selectedEditorTab == 'CAL' ||
                  selectedEditorTab == 'TASK' ||
                  selectedEditorTab == 'REPLY' ||
                  selectedEditorTab == 'LOG'
                    ? 'MT'
                    : selectedEditorTab
                "
              />
            </div>
          </div>
          <div class="row new-add-left-side-third-row">
            <div
              class="col-md-12"
              v-if="mode !== 'reply-email'"
              :class="{
                frozen: taskInCheckProgress
              }"
            >
              <!--              <TaskClock-->
              <!--                class="add-task-timer"-->
              <!--                :forceStopTimer="forceStopTimer"-->
              <!--                :mode="mode"-->
              <!--                v-if="!task"-->
              <!--                @setAddNewTaskTimeDuration="setAddNewTaskTimeDuration"-->
              <!--              ></TaskClock>-->
              <span
                  v-tooltip.top="{
                  content: 'Copied!',
                   show: isTooltipCopyActive,
                   autoHide: false,
                   trigger: 'manual'
                  }"
                  class="btn copy-button"
                  style="cursor: pointer;border:none"
                  @click="copyStringToClipboard(`#${newTaskId}`)" v-if="!task">Task id:#{{ newTaskId }}
                <i class="fas fa-copy"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="row new-add-right-side-second-row">
            <div class="row top-btns-row-new">
              <div class="col-md-12 top-buttons-row">
                <button
                  class="btn btn-warning top-five-tags-btn"
                  v-for="tag in topFiveTags"
                  :key="tag.category.id"
                  @click="addTagFromTopFiveTags(tag.category)"
                >
                  #{{ tag.category.cat_type
                  }}<span>&nbsp;|&nbsp;{{ tag.count }}</span>
                </button>
                <button
                  class="btn btn-primary top-three-users-btn"
                  v-for="user in topThreeUsers"
                  :key="user.user.id"
                  @click="addTagFromTopThreeUsers(user.user)"
                >
                  @{{ user.user.full_name
                  }}<span>&nbsp;|&nbsp;{{ user.count }}</span>
                </button>
              </div>
            </div>
            <div
              class="row new-add-left-side-first-row"
              :class="{
                frozen: taskInCheckProgress
              }"
            >
              <div
                class="col-md-12 categories-col"
                :class="{ frozen: mode == 'reply-email' }"
              >
                <div class="tabs-container">
                  <ul class="style-nav style2 sub-task-category-nav">
                    <li
                      v-for="tab in categoryTabs"
                      :key="tab.id"
                      :class="{ active: selectedCategoryTab === tab.alias }"
                      @click="
                        () => {
                          selectedCategoryTab = tab.alias;
                        }
                      "
                    >
                      {{ tab.name.toUpperCase() }}
                    </li>
                  </ul>
                  <div class="styleCardContent padding editor-tabs">
                    <div
                      class="task-tab"
                      v-show="
                        selectedCategoryTab === 'MT' ||
                          selectedCategoryTab === 'ADD TO TASK'
                      "
                    >
                      <SubCategoryTagsInput
                        @changeTitle="updateTitle"
                        :categoriesOfTask="newTask.cat_arr"
                        :key="componentKeyTags"
                      />
                    </div>
                    <div
                      v-for="subTask in subTasks"
                      class="tab-pane active"
                      v-show="selectedCategoryTab === subTask.subTaskTab"
                      :key="subTask.subTaskId"
                    >
                      <SubCategoryTagsInput
                        @changeTitle="
                          updateSubCategories($event, subTask.subTaskId)
                        "
                        :categoriesOfTask="subTask.subTaskCategory"
                        :key="componentKeyTags"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" :class="classObjectFirstRowLeftSide">
              <div class="col-md-12 editor-bar">
                <div class="row text-editor-bar">
                  <div class="col-md-12 editor-col">
                    <!--                <div-->
                    <!--                  class="row first-row-editor-col"-->
                    <!--                  v-if="mode !== 'reply-email'"-->
                    <!--                >-->
                    <!--                  <button-->
                    <!--                    class="btn btn-info btn-bar-btn btn-sm btn-block"-->
                    <!--                    @click.prevent="extend25"-->
                    <!--                    v-if="task"-->
                    <!--                  >-->
                    <!--                    EXTEND TASK +24h-->
                    <!--                  </button>-->
                    <!--                  <hr v-if="!task" style="margin-top: 15px;" />-->
                    <!--                </div>-->
                    <div class="row second-row-editor-col">
                      <div class="tabs-container-new">
                        <ul class="style-nav style2 sub-task-nav editor-nav">
                          <li
                            v-for="tab in editorTabs"
                            :key="tab.id"
                            :class="{ active: selectedEditorTab === tab.alias }"
                            @click="
                              () => {
                                selectedEditorTab = tab.alias;
                              }
                            "
                            :style="
                              // mode == 'reply'
                              mode == 'reply' &&
                              tab.alias == 'CAL' &&
                              checkIfReciverNotCreator()
                                ? { cursor: 'no-drop', pointerEvents: 'none' }
                                : null
                            "
                          >
                            {{
                              tab.alias === "REPLY"
                                ? transferUsers.length > 0
                                  ? "Transfer to"
                                  : tab.name.toUpperCase()
                                : tab.name.toUpperCase()
                            }}
                            {{
                              tab.alias === "REPLY"
                                ? transferUsers.length > 0
                                  ? transferUsers[0][0].full_name
                                  : ""
                                : ""
                            }}
                            <!--                        // : replyOpponent-->

                            <!--                        {{ // tab.alias === "REPLY" ? replyOpponent : "" }}-->
                            <TaskClock
                              class="add-task-timer"
                              :forceStopTimer="forceStopTimer"
                              :mode="mode"
                              v-if="!task && tab.alias === 'MT'"
                              @setAddNewTaskTimeDuration="
                                setAddNewTaskTimeDuration
                              "
                            ></TaskClock>
                            <span
                              v-if="
                                tab.alias !== 'MT' &&
                                  tab.alias !== 'CAL' &&
                                  tab.alias !== 'TASK' &&
                                  tab.alias !== 'REPLY' &&
                                  tab.alias !== 'LOG'
                              "
                              @click.stop="deleteEditorTab(tab)"
                            >
                              x
                            </span>
                          </li>

                          <div
                            class="sub-task-sub-menu"
                            v-if="subTasks.length < 4 && mode !== 'reply-email'"
                          >
                            <!--                        THIS IS A SECTION OF SUB TASKS-->

                            <!--                        <task-connect-menu-->
                            <!--                          @sendConnectedTaskId="setSelectedConnTaskId"-->
                            <!--                          :subTask="true"-->
                            <!--                          @addSubTaskTab="addSubTaskTab"-->
                            <!--                          :connectedTasks="newTask.selectedConnTaskId"-->
                            <!--                          v-if="!task || task.main_id !== null"-->
                            <!--                        ></task-connect-menu>-->
                          </div>
                        </ul>
                        <div class="styleCardContent padding editor-tabs">
                          <div
                            class="task-tab"
                            v-show="selectedEditorTab === 'CAL'"
                          >
                            <div id="calendar" class=" tab-pane active">
                              <calendar-component
                                :mode="mode"
                                :activeDate="activeDate"
                                v-on:changeModeToEdit="editWindowMode($event)"
                                :estTime="estTime"
                              />
                            </div>
                          </div>
                          <div
                            class="task-tab reply-editor-disabled"
                            v-show="selectedEditorTab === 'TASK'"
                            v-if="task"
                          >
                            <div class="tabs-container">
                              <ul
                                class="style-nav style2 sub-task-user-nav-new"
                              >
                                <li
                                  v-for="tab in taskSubTabs"
                                  :key="tab.id"
                                  :class="{
                                    active: selectedTaskSubTab === tab.alias
                                  }"
                                  @click="
                                    () => {
                                      selectedTaskSubTab = tab.alias;
                                    }
                                  "
                                >
                                  {{ tab.name.toUpperCase() }}
                                </li>
                              </ul>
                              <div class="styleCardContent  editor-tabs">
                                <div
                                  class="task-tab"
                                  v-show="selectedTaskSubTab === 'MT'"
                                >
                                  <div class="tab-pane active">
                                    <vue-editor
                                      id="edit-task-editor"
                                      :disabled="isEditorDisabled"
                                      useCustomImageHandler
                                      @image-added="handleImageAdded"
                                      v-model="updatedTask.content"
                                      :editorOptions="replyEditorSettings"
                                      v-if="mode === 'reply'"
                                      :key="componentKeyEditor"
                                    />
                                    <vue-editor
                                      id="email-editor"
                                      v-if="mode === 'reply-email'"
                                      :disabled="isEditorDisabled"
                                      useCustomImageHandler
                                      @image-added="handleImageAdded"
                                      v-model="task.content"
                                      :editorOptions="replyEditorSettings"
                                    />
                                  </div>
                                </div>
                                <div
                                  class="task-tab"
                                  v-if="task.sub_task_assignment.length > 0"
                                >
                                  <div
                                    class="tab-pane active"
                                    v-for="(subTask, idx) in subTasks.subTasks"
                                    v-show="
                                      selectedTaskSubTab === `ST-${idx + 2}`
                                    "
                                    :key="idx"
                                  >
                                    <!--                                <div class="tab-pane active"-->

                                    <!--                                     v-for="(subTask, idx) in task.sub_task_assignment"-->
                                    <!--                                     v-show="selectedTaskSubTab === `ST-${idx+2}`"-->

                                    <!--                                     :key="idx"-->

                                    <!--                                >-->
                                    <vue-editor
                                      :disabled="isEditorDisabled"
                                      useCustomImageHandler
                                      @image-added="handleImageAdded"
                                      v-model="subTask.content"
                                      :editorOptions="replyEditorSettings"
                                    />
                                  </div>
                                </div>
                              </div>

                              <!--transfer mode-->
                            </div>
                          </div>
                          <div
                            class="task-tab reply-editor-disabled"
                            v-show="selectedEditorTab === 'ADD TO TASK'"
                            v-if="task"
                          >
                            <div class="tabs-container">
                              <ul
                                class="style-nav style2 sub-task-user-nav-new"
                              >
                                <li
                                  v-for="tab in taskSubTabs"
                                  :key="tab.id"
                                  :class="{
                                    active: selectedTaskSubTab === tab.alias
                                  }"
                                  @click="
                                    () => {
                                      selectedTaskSubTab = tab.alias;
                                    }
                                  "
                                >
                                  {{ tab.name.toUpperCase() }}
                                </li>
                              </ul>
                              <div class="styleCardContent  editor-tabs">
                                <div
                                  class="task-tab"
                                  v-show="selectedTaskSubTab === 'MT'"
                                >
                                  <div class="tab-pane active">
                                    <vue-editor
                                      id="add-to-task-editor"
                                      :disabled="isEditorDisabled"
                                      useCustomImageHandler
                                      @image-added="handleImageAdded"
                                      v-model="additionToTaskContent"
                                      :editorOptions="replyEditorSettings"
                                      v-if="mode === 'reply'"
                                      :key="componentKeyEditor"
                                    />
                                  </div>
                                </div>
                                <div
                                  class="task-tab"
                                  v-if="task.sub_task_assignment.length > 0"
                                >
                                  <div
                                    class="tab-pane active"
                                    v-for="(subTask, idx) in subTasks.subTasks"
                                    v-show="
                                      selectedTaskSubTab === `ST-${idx + 2}`
                                    "
                                    :key="idx"
                                  >
                                    <!--                                <div class="tab-pane active"-->

                                    <!--                                     v-for="(subTask, idx) in task.sub_task_assignment"-->
                                    <!--                                     v-show="selectedTaskSubTab === `ST-${idx+2}`"-->

                                    <!--                                     :key="idx"-->

                                    <!--                                >-->
                                    <vue-editor
                                      :disabled="isEditorDisabled"
                                      useCustomImageHandler
                                      @image-added="handleImageAdded"
                                      v-model="subTask.content"
                                      :editorOptions="replyEditorSettings"
                                    />
                                  </div>
                                </div>
                              </div>

                              <!--transfer mode-->
                            </div>
                          </div>
                          <div
                            class="task-tab"
                            v-show="selectedEditorTab === 'REPLY'"
                            v-if="task"
                          >
                            <MainTaskWindowReply
                              :selectedReplyIdToUpdate="selectedReplyIdToUpdate"
                              :replyUsers="replyUsers"
                              :taskUsersTalking="taskUsersTalking"
                              :editorSettings="editorSettings"
                              :task="task"
                              :handleImageAdded="handleImageAdded"
                              :hashValues="hashValues"
                              :categoriesOfTask="newTask.cat_arr"
                              ref="replyWindow"
                              :assign-reply-to="assignReplyTo"
                              :replyContent="replyTaskTextFromLocal"
                              @creatorHasConfirmedTheTask="creatorConfirmedTask"
                              @taskRepliesForCheck="sendTaskreplies"
                              @addedTagFromReply="componentKeyTags += 1"
                              :selectedMainTab="tabForReply"
                              @setReplyContent="setReplyContent"
                              @clear_sets="clearReplySets"
                              :mode="mode"
                              :notApprovedStarRating="notApprovedStarRating"
                            />
                          </div>
                          <div
                            class="task-tab log-tab-new"
                            v-show="selectedEditorTab === 'LOG'"
                            v-if="task"
                          >
                            <TaskLogMainTaskWindow :task="task" />
                          </div>
                          <div
                            class="task-tab"
                            v-show="selectedEditorTab === 'MT'"
                          >
<!--                              kobi-->
                            <div id="editor" class="tab-pane active">
                              <button
                                  :class="{'btn-success': this.newTask.taskUser.length>0}"
                                  @click="handleEditorDropdown('@')"
                                  class="btn">{{this.newTask.taskUser.length>0? 'V':'@'}}
                              </button>
                              <button
                                  :class="{'btn-success': this.newTask.cat_arr.length>0}"
                                  @click="handleEditorDropdown('#')"
                                  class="btn">{{this.newTask.cat_arr.length>0? 'V':'#'}}
                              </button>
                              <button
                                  :class="{'btn-success': this.isTextContent}"
                                  @click="handleEditorDropdown('TXT')"
                                  class="btn">{{this.isTextContent? 'V':'TXT'}}
                              </button>
                              <vue-editor
                                useCustomImageHandler
                                @image-added="handleImageAdded"
                                v-model="taskTextFromLocal"
                                :editorOptions="editorSettings"
                                id="new-add-task-editor"
                                ref="editor"
                                :key="componentKeyEditor"
                                :placeholder="addNewTaskEditorPlaceholder"
                              />
                            </div>
                          </div>

                          <div
                            v-for="subTask in subTasks"
                            class="tab-pane active"
                            v-show="selectedEditorTab === subTask.subTaskTab"
                            :key="subTask.subTaskId"
                          >
                            <vue-editor
                              useCustomImageHandler
                              @image-added="handleImageAdded"
                              :editorOptions="editorSettings"
                              v-model="subTask.subTaskContent"
                              ref="editor"
                            />
                          </div>
                        </div>
                      </div>
                      <!--                  <label class="checkbox-container">-->
                      <!--                    <input-->
                      <!--                      type="checkbox"-->
                      <!--                      @change="changeTaskPrivacy($event)"-->
                      <!--                    />-->
                      <!--                    <span class="checkmark"></span>-->
                      <!--                    : Private-->
                      <!--                  </label>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row tabs-timedate-container date-bar"
              v-if="mode !== 'reply-email' && newTask.taskType.id !== 7"
              :class="{
                // frozen: mode == 'reply'
                frozen: ifTimeFrameDisabled || newTask.taskType.id === 7
              }"
            >
              <div class="col-md-1 col-position">
                <SelectTaskPosition
                  @setTaskDateFromSelectPosition="setTaskDateFromSelectPosition"
                  @changeNewTaskPosition="changeNewTaskPosition"
                  :time-duration="newTask.timeQuantity"
                  :user-related-tasks="newTask.userRelatedTasks"
                  :primary-user="newTask.primaryUser"
                  :assigned-users="newTask.taskUser"
                />
              </div>
              <div class="col-md-10 col-date">
                <TaskDateTime
                  :taskSubType="newTask.taskSubType"
                  @changeTaskSubType="changeTaskSubType"
                  :taskType="newTask.taskType"
                  @changeTaskType="setTaskType"
                  v-on:setTaskDate="setTaskDate"
                  v-on:changeActiveTaskTab="changeActiveTaskTab"
                  v-on:changeActiveDateForCalendar="changeActiveDateForCalendar"
                  @addEstTimeTag="addEstTimeTag"
                  :repeat-type-options="
                    taskDictionaries.general.task_repeat_types
                  "
                  :task="task"
                  :taskDate="taskDate"
                  :key="keyDateTimeComponent"
                  :changeEstTimeTitle="changeEstTimeTitle"
                  :selectedEditorTab="selectedEditorTab"
                  @outLineTaskDateTime="outline = true"
                  @reapetOption="selectRepeatOption"
                  :class="{
                    frozen: ifTimeFrameDisabled
                    // frozen: allowTimeFrameByUserRole()
                  }"
                />
              </div>
              <div
                class="col-md-1 extend24"
                v-if="task && this.auth.user.id === this.getOriginalCreator()"
              >
                <button
                  class="btn btn-primary "
                  @click.prevent="extend25"
                  v-if="task && mode !== 'reply-email'"
                >
                  +24h
                </button>
              </div>
            </div>
            <div class="row buttons-row">
              <div class="col-md-12 buttons-bar">
                <TaskMainWindowButtonsBar
                  @setMeetingLocation="setMeetingLocation"
                  :replyTaskTextFromLocal="replyTaskTextFromLocal"
                  @setRepOpt="setRepOtp"
                  :repeat-type-options="
                    taskDictionaries.general.task_repeat_types
                  "
                  :taskDelayed="taskDelayed"
                  @clearDelay="clearDelay"
                  :ifInSaveDelayCondition="saveDelayCondition"
                  @cancelDelayTask="cancelDelayTask"
                  @star-rating="setStarRating"
                  :syntheticCheckUser="updatedTask.userIn"
                  :repeatOptionsObj="repeatOptionsObj"
                  :showUpdateReplyBtn="showUpdateReplyBtn"
                  :replyUsers="replyUsers"
                  :taskUserSubStatus="taskUserSubStatus"
                  :task="task"
                  :mode="mode"
                  :notApprovedStarRating="notApprovedStarRating"
                  :taskInCheckProgress="taskInCheckProgress"
                  :creatorHasConfirmedTheTask="creatorHasConfirmedTheTask"
                  v-on:addNewTask="addNewTask"
                  :newTask="newTask"
                  :taskTextFromLocal="taskTextFromLocal"
                  v-on:getMyTasks="getMyTasks"
                  v-on:changeTransferMode="changeTransferMode"
                  v-on:editTask="editTask"
                  v-on:addToTask="addToTask"
                  v-on:delayTask="delayTask"
                  v-on:cancelEditTask="cancelEditTask"
                  v-on:saveEditedTask="saveEditedTask"
                  v-on:saveAddons="saveAddons"
                  v-on:saveDelay="saveDelay"
                  v-on:replyTask="replyTaskFromMain"
                  @updateReply="updateReplyTaskFromMain"
                  @cancelEditReply="cancelEditReply"
                  v-on:renewTask="renewTask"
                  v-on:taskToJunk="updateTaskStatus"
                  :canTransfer="canTransferPlusContent()"
                  @checkMe="checkMe"
                  @syntheticCheck="syntheticCheck"
                  @cancelCheck="cancelCheckFromMain"
                  @replyEndTask="replyEndTaskFromMain"
                  @IHaveSeenThatTaskIsConfirmed="taskIsConfirmed"
                  :taskReplyForCheck="repliesSendToButtons"
                  :transferUsers="transferUsers"
                  :selectedTaskTab="selectedTaskTab"
                  @emitAddNewSubTasks="addNewSubTasks"
                  @approvedByCreator="approvedByCreator"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :key="mainKey"
      class=""
      id="main-task-window-reply-email-new"
      v-if="mode === 'reply-email'"
    >
      <div class="row main-add-window">
        <div class="col-md-12">
          <div class="row" :class="classObjectFirstRowLeftSide">
            <div class="col-md-12 editor-bar">
              <div class="row text-editor-bar">
                <div class="col-md-12 editor-col">
                  <!--                <div-->
                  <!--                  class="row first-row-editor-col"-->
                  <!--                  v-if="mode !== 'reply-email'"-->
                  <!--                >-->
                  <!--                  <button-->
                  <!--                    class="btn btn-info btn-bar-btn btn-sm btn-block"-->
                  <!--                    @click.prevent="extend25"-->
                  <!--                    v-if="task"-->
                  <!--                  >-->
                  <!--                    EXTEND TASK +24h-->
                  <!--                  </button>-->
                  <!--                  <hr v-if="!task" style="margin-top: 15px;" />-->
                  <!--                </div>-->
                  <div class="row second-row-editor-col">
                    <div class="tabs-container-new">
                      <ul class="style-nav style2 sub-task-nav editor-nav">
                        <li
                          v-for="tab in editorTabs"
                          :key="tab.id"
                          :class="{ active: selectedEditorTab === tab.alias }"
                          @click="
                            () => {
                              selectedEditorTab = tab.alias;
                            }
                          "
                          :style="
                            // mode == 'reply'
                            mode == 'reply' &&
                            tab.alias == 'CAL' &&
                            checkIfReciverNotCreator()
                              ? { cursor: 'no-drop', pointerEvents: 'none' }
                              : null
                          "
                        >
                          {{
                            tab.alias === "REPLY"
                              ? transferUsers.length > 0
                                ? "Transfer to"
                                : tab.name.toUpperCase()
                              : tab.name.toUpperCase()
                          }}
                          {{
                            tab.alias === "REPLY"
                              ? transferUsers.length > 0
                                ? transferUsers[0][0].full_name
                                : ""
                              : ""
                          }}
                          <TaskClock
                            class="add-task-timer"
                            :forceStopTimer="forceStopTimer"
                            :mode="mode"
                            v-if="!task && tab.alias === 'MT'"
                            @setAddNewTaskTimeDuration="
                              setAddNewTaskTimeDuration
                            "
                          ></TaskClock>
                          <!--                        // : replyOpponent-->

                          <!--                        {{ // tab.alias === "REPLY" ? replyOpponent : "" }}-->
                          <span
                            v-if="
                              tab.alias !== 'MT' &&
                                tab.alias !== 'CAL' &&
                                tab.alias !== 'TASK' &&
                                tab.alias !== 'REPLY' &&
                                tab.alias !== 'LOG'
                            "
                            @click.stop="deleteEditorTab(tab)"
                          >
                            x
                          </span>
                        </li>

                        <div
                          class="sub-task-sub-menu"
                          v-if="subTasks.length < 4 && mode !== 'reply-email'"
                        >
                          <!--                        THIS IS A SECTION OF SUB TASKS-->

                          <!--                        <task-connect-menu-->
                          <!--                          @sendConnectedTaskId="setSelectedConnTaskId"-->
                          <!--                          :subTask="true"-->
                          <!--                          @addSubTaskTab="addSubTaskTab"-->
                          <!--                          :connectedTasks="newTask.selectedConnTaskId"-->
                          <!--                          v-if="!task || task.main_id !== null"-->
                          <!--                        ></task-connect-menu>-->
                        </div>
                      </ul>
                      <div class="styleCardContent padding editor-tabs">
                        <div
                          class="task-tab"
                          v-show="selectedEditorTab === 'CAL'"
                        >
                          <div id="calendar" class=" tab-pane active">
                            <calendar-component
                              :mode="mode"
                              :activeDate="activeDate"
                              v-on:changeModeToEdit="editWindowMode($event)"
                              :estTime="estTime"
                            />
                          </div>
                        </div>
                        <div
                          class="task-tab reply-editor-disabled"
                          v-show="selectedEditorTab === 'TASK'"
                          v-if="task"
                        >
                          <div class="tabs-container">
                            <ul class="style-nav style2 sub-task-user-nav-new">
                              <li
                                v-for="tab in taskSubTabs"
                                :key="tab.id"
                                :class="{
                                  active: selectedTaskSubTab === tab.alias
                                }"
                                @click="
                                  () => {
                                    selectedTaskSubTab = tab.alias;
                                  }
                                "
                              >
                                {{ tab.name.toUpperCase() }}
                              </li>
                            </ul>
                            <div class="styleCardContent  editor-tabs">
                              <div
                                class="task-tab"
                                v-show="selectedTaskSubTab === 'MT'"
                              >
                                <div class="tab-pane active">
                                  <vue-editor
                                    id="edit-task-editor"
                                    :disabled="isEditorDisabled"
                                    useCustomImageHandler
                                    @image-added="handleImageAdded"
                                    v-model="updatedTask.content"
                                    :editorOptions="replyEditorSettings"
                                    v-if="mode === 'reply'"
                                    :key="componentKeyEditor"
                                  />
                                  <vue-editor
                                    id="email-editor"
                                    v-if="mode === 'reply-email'"
                                    :disabled="isEditorDisabled"
                                    useCustomImageHandler
                                    @image-added="handleImageAdded"
                                    v-model="task.content"
                                    :editorOptions="replyEditorSettings"
                                  />
                                </div>
                              </div>
                              <div
                                class="task-tab"
                                v-if="task.sub_task_assignment.length > 0"
                              >
                                <div
                                  class="tab-pane active"
                                  v-for="(subTask, idx) in subTasks.subTasks"
                                  v-show="
                                    selectedTaskSubTab === `ST-${idx + 2}`
                                  "
                                  :key="idx"
                                >
                                  <!--                                <div class="tab-pane active"-->

                                  <!--                                     v-for="(subTask, idx) in task.sub_task_assignment"-->
                                  <!--                                     v-show="selectedTaskSubTab === `ST-${idx+2}`"-->

                                  <!--                                     :key="idx"-->

                                  <!--                                >-->
                                  <vue-editor
                                    :disabled="isEditorDisabled"
                                    useCustomImageHandler
                                    @image-added="handleImageAdded"
                                    v-model="subTask.content"
                                    :editorOptions="replyEditorSettings"
                                  />
                                </div>
                              </div>
                            </div>

                            <!--transfer mode-->
                          </div>
                        </div>
                        <div
                          class="task-tab reply-editor-disabled"
                          v-show="selectedEditorTab === 'ADD TO TASK'"
                          v-if="task"
                        >
                          <div class="tabs-container">
                            <ul class="style-nav style2 sub-task-user-nav-new">
                              <li
                                v-for="tab in taskSubTabs"
                                :key="tab.id"
                                :class="{
                                  active: selectedTaskSubTab === tab.alias
                                }"
                                @click="
                                  () => {
                                    selectedTaskSubTab = tab.alias;
                                  }
                                "
                              >
                                {{ tab.name.toUpperCase() }}
                              </li>
                            </ul>
                            <div class="styleCardContent  editor-tabs">
                              <div
                                class="task-tab"
                                v-show="selectedTaskSubTab === 'MT'"
                              >
                                <div class="tab-pane active">
                                  <vue-editor
                                    id="add-to-task-editor"
                                    :disabled="isEditorDisabled"
                                    useCustomImageHandler
                                    @image-added="handleImageAdded"
                                    v-model="additionToTaskContent"
                                    :editorOptions="replyEditorSettings"
                                    v-if="mode === 'reply'"
                                    :key="componentKeyEditor"
                                  />
                                </div>
                              </div>
                              <div
                                class="task-tab"
                                v-if="task.sub_task_assignment.length > 0"
                              >
                                <div
                                  class="tab-pane active"
                                  v-for="(subTask, idx) in subTasks.subTasks"
                                  v-show="
                                    selectedTaskSubTab === `ST-${idx + 2}`
                                  "
                                  :key="idx"
                                >
                                  <!--                                <div class="tab-pane active"-->

                                  <!--                                     v-for="(subTask, idx) in task.sub_task_assignment"-->
                                  <!--                                     v-show="selectedTaskSubTab === `ST-${idx+2}`"-->

                                  <!--                                     :key="idx"-->

                                  <!--                                >-->
                                  <vue-editor
                                    :disabled="isEditorDisabled"
                                    useCustomImageHandler
                                    @image-added="handleImageAdded"
                                    v-model="subTask.content"
                                    :editorOptions="replyEditorSettings"
                                  />
                                </div>
                              </div>
                            </div>

                            <!--transfer mode-->
                          </div>
                        </div>
                        <div
                          class="task-tab"
                          v-show="selectedEditorTab === 'REPLY'"
                          v-if="task"
                        >
                          <MainTaskWindowReply
                            :selectedReplyIdToUpdate="selectedReplyIdToUpdate"
                            :replyUsers="replyUsers"
                            :taskUsersTalking="taskUsersTalking"
                            :editorSettings="editorSettings"
                            :task="task"
                            :handleImageAdded="handleImageAdded"
                            :hashValues="hashValues"
                            :categoriesOfTask="newTask.cat_arr"
                            ref="replyWindow"
                            :assign-reply-to="assignReplyTo"
                            :replyContent="replyTaskTextFromLocal"
                            @creatorHasConfirmedTheTask="creatorConfirmedTask"
                            @taskRepliesForCheck="sendTaskreplies"
                            @addedTagFromReply="componentKeyTags += 1"
                            :selectedMainTab="tabForReply"
                            @setReplyContent="setReplyContent"
                            @clear_sets="clearReplySets"
                            :mode="mode"
                            :notApprovedStarRating="notApprovedStarRating"
                          />
                        </div>
                        <div
                          class="task-tab log-tab-new"
                          v-show="selectedEditorTab === 'LOG'"
                          v-if="task"
                        >
                          <TaskLogMainTaskWindow :task="task" />
                        </div>
                        <div
                          class="task-tab"
                          v-show="selectedEditorTab === 'MT'"
                        >
                          <div id="editor" class="tab-pane active">
                            <vue-editor
                              useCustomImageHandler
                              @image-added="handleImageAdded"
                              v-model="taskTextFromLocal"
                              :editorOptions="editorSettings"
                              id="new-add-task-editor"
                              ref="editor"
                              :key="componentKeyEditor"
                              :placeholder="addNewTaskEditorPlaceholder"
                            />
                          </div>
                        </div>

                        <div
                          v-for="subTask in subTasks"
                          class="tab-pane active"
                          v-show="selectedEditorTab === subTask.subTaskTab"
                          :key="subTask.subTaskId"
                        >
                          <vue-editor
                            useCustomImageHandler
                            @image-added="handleImageAdded"
                            :editorOptions="editorSettings"
                            v-model="subTask.subTaskContent"
                            ref="editor"
                          />
                        </div>
                      </div>
                    </div>
                    <!--                  <label class="checkbox-container">-->
                    <!--                    <input-->
                    <!--                      type="checkbox"-->
                    <!--                      @change="changeTaskPrivacy($event)"-->
                    <!--                    />-->
                    <!--                    <span class="checkmark"></span>-->
                    <!--                    : Private-->
                    <!--                  </label>-->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row new-reply-email-left-side-first-row"
            :class="{
              frozen: taskInCheckProgress
            }"
          >
            <div
              class="col-md-12 categories-col"
              :class="{ frozen: mode == 'reply-email' }"
            >
              <div class="tabs-container">
                <ul class="style-nav style2 sub-task-category-nav">
                  <li
                    v-for="tab in categoryTabs"
                    :key="tab.id"
                    :class="{ active: selectedCategoryTab === tab.alias }"
                    @click="
                      () => {
                        selectedCategoryTab = tab.alias;
                      }
                    "
                  >
                    {{ tab.name.toUpperCase() }}
                  </li>
                </ul>
                <div class="styleCardContent padding editor-tabs">
                  <div
                    class="task-tab"
                    v-show="
                      selectedCategoryTab === 'MT' ||
                        selectedCategoryTab === 'ADD TO TASK'
                    "
                  >
                    <SubCategoryTagsInput
                      @changeTitle="updateTitle"
                      :categoriesOfTask="newTask.cat_arr"
                      :key="componentKeyTags"
                    />
                  </div>
                  <div
                    v-for="subTask in subTasks"
                    class="tab-pane active"
                    v-show="selectedCategoryTab === subTask.subTaskTab"
                    :key="subTask.subTaskId"
                  >
                    <SubCategoryTagsInput
                      @changeTitle="
                        updateSubCategories($event, subTask.subTaskId)
                      "
                      :categoriesOfTask="subTask.subTaskCategory"
                      :key="componentKeyTags"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row buttons-row">
            <div class="col-md-12 buttons-bar">
              <TaskMainWindowButtonsBar
                @setMeetingLocation="setMeetingLocation"
                :replyTaskTextFromLocal="replyTaskTextFromLocal"
                @setRepOpt="setRepOtp"
                :repeat-type-options="
                  taskDictionaries.general.task_repeat_types
                "
                :taskDelayed="taskDelayed"
                @clearDelay="clearDelay"
                :ifInSaveDelayCondition="saveDelayCondition"
                @cancelDelayTask="cancelDelayTask"
                @star-rating="setStarRating"
                :syntheticCheckUser="updatedTask.userIn"
                :repeatOptionsObj="repeatOptionsObj"
                :showUpdateReplyBtn="showUpdateReplyBtn"
                :replyUsers="replyUsers"
                :taskUserSubStatus="taskUserSubStatus"
                :task="task"
                :mode="mode"
                :notApprovedStarRating="notApprovedStarRating"
                :taskInCheckProgress="taskInCheckProgress"
                :creatorHasConfirmedTheTask="creatorHasConfirmedTheTask"
                v-on:addNewTask="addNewTask"
                :newTask="newTask"
                :taskTextFromLocal="taskTextFromLocal"
                v-on:getMyTasks="getMyTasks"
                v-on:changeTransferMode="changeTransferMode"
                v-on:editTask="editTask"
                v-on:addToTask="addToTask"
                v-on:delayTask="delayTask"
                v-on:cancelEditTask="cancelEditTask"
                v-on:saveEditedTask="saveEditedTask"
                v-on:saveAddons="saveAddons"
                v-on:saveDelay="saveDelay"
                v-on:replyTask="replyTaskFromMain"
                @updateReply="updateReplyTaskFromMain"
                @cancelEditReply="cancelEditReply"
                v-on:renewTask="renewTask"
                v-on:taskToJunk="updateTaskStatus"
                :canTransfer="canTransferPlusContent()"
                @checkMe="checkMe"
                @syntheticCheck="syntheticCheck"
                @cancelCheck="cancelCheckFromMain"
                @replyEndTask="replyEndTaskFromMain"
                @IHaveSeenThatTaskIsConfirmed="taskIsConfirmed"
                :taskReplyForCheck="repliesSendToButtons"
                :transferUsers="transferUsers"
                :selectedTaskTab="selectedTaskTab"
                @emitAddNewSubTasks="addNewSubTasks"
                @approvedByCreator="approvedByCreator"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="imgModal" class="modal">
      <span class="close-img-modal">&times;</span>

      <img class="modal-content" id="img01" />
    </div>
    <div class="loader-upload" v-if="requestUploadStatusBusy">
      <loader :size="'33px'"></loader>
    </div>
  </div>
</template>

<script>
import { VueEditor, Quill } from "vue2-editor";
// import { VueEditor, Quill } from "../components/vue2-editor/";
import ImageResize from "quill-image-resize-vue";
import vClickOutside from "v-click-outside";

// import QuillMention from "quill-mention";
import QuillMention from "./q-mention/src/quill.mention";
import SubCategoryTagsInput from "./SubCategoryTagsInput.component";
import TaskMainWindowButtonsBar from "./TaskMainWindowButtonsBar.component";
import TaskUsersSelectMainWindow from "./TaskUsersSelectMainWindow.component";
import CalendarComponent from "./calendar/CalendarComponent";
import TaskDateTime from "./TaskDateTime.component";
import apiClientCreator from "../../../helpers/api/request";
import moment from "moment";
import { mapGetters, mapState } from "vuex";
import MainTaskWindowReply from "./MainTaskWindowReply.component";
// import TaskTypesMain from "./TaskTypesMain.container";
import TaskClock from "../components/TaskClock.component";
import TaskLogMainTaskWindow from "./TaskLogMainTaskWindow.component";
// import TaskConnectMenu from "./TaskConnectMenu.component";
import SelectTaskPosition from "./SelectTaskPosition.component";
import TimerLog from "./TimerLog.component";
import TaskVideoRec from "../components/TaskVideoRec";
import Loader from "../../../main/misc.main/loader/Loader";
import _ from "lodash";
import { setTopThreeUsersFromLast100 } from "../../../store/tasks.store/mutations";
import SocketEndpoints from "@/mixins/system/SocketEndpoints";
import TaskProjectSelect from "./task_projects/TaskProjectSelect.component";
import TaskPreview from "./TaskPreview.component";

Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/QuillMention", QuillMention);
export default {
  name: "MainTaskWindow",
  components: {
    TaskPreview,
    TaskProjectSelect,
    TimerLog,
    SelectTaskPosition,
    TaskLogMainTaskWindow,
    CalendarComponent,
    MainTaskWindowReply,
    SubCategoryTagsInput,
    // TaskTypesMain,
    TaskDateTime,
    TaskUsersSelectMainWindow,
    TaskMainWindowButtonsBar,
    TaskClock,
    // TaskConnectMenu,
    VueEditor,
    TaskVideoRec,
    Loader
  },
  mixins: [SocketEndpoints],
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("tasks", [
      "activeTimer",
      "taskDictionaries",
      "topThreeUsersFromLast100",
      "topFiveTagsFromLast100",
      "categories"
    ]),

    computedContent() {
      return this.task.main_task_id
        ? this.task.real_task_main_id.content
        : this.task.content;
    }
  },
  props: {
    mode: {
      type: String,
      default() {
        return "";
      }
    },
    task: {
      type: Object,
      required: true
    },
    selectedTaskTab: {
      type: String,
      required: true
    },

    assignReplyTo: {
      type: Array,
      default: () => []
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  created() {},
  data() {
    return {
      isTooltipCopyActive:false,
      isTextContent: false,
      isMentionsAndHashtags:false,
      activeDate: new Date(),
      addNewTaskEditorPlaceholder:
        "Step 1: use @..\n" +
        "\n" +
        "Step 2: use #..\n" +
        "\n" +
        "Step 3: Use APPLY",
      addMode: true,
      additionToTaskContent: `<span style="color: red">${moment().format(
        "DD/MM/YYYY HH:mm"
      )}</span><span style="color: red">Important addition:</span>&nbsp`,
      additionsToTask: [],
      atValues: [],
      badWordsArray: [
        "#",
        "anal",
        "anus",
        "arse",
        "ass",
        "ballsack",
        "balls",
        "bastard",
        "bitch",
        "biatch",
        "bloody",
        "blowjob",
        "bollock",
        "bollok",
        "boner",
        "boob",
        "bugger",
        "bum",
        "butt",
        "buttplug",
        "clitoris",
        "cock",
        "coon",
        "crap",
        "cunt",
        "damn",
        "dick",
        "dildo",
        "dyke",
        "fag",
        "feck",
        "fellate",
        "fellatio",
        "felching",
        "fuck",
        "fudgepacker",
        "flange",
        "goddamn",
        "hell",
        "homo",
        "jizz",
        "knobend",
        "labia",
        "muff",
        "nigger",
        "nigga",
        "jude",
        "penis",
        "piss",
        "poop",
        "prick",
        "pube",
        "pussy",
        "queer",
        "scrotum",
        "sex",
        "shit",
        "sh1t",
        "slut",
        "smegma",
        "spunk",
        "suck",
        "tit",
        "tosser",
        "turd",
        "twat",
        "vagina",
        "wank",
        "whore",
        "wtf"
      ],
      componentKeyEditor: 0,
      categoriesForMention: [],
      categoriesForTopFiveFilter: null,
      copyTimer: "",
      classObject: {
        "col-md-12": this.mode == "reply-email" ? true : false,
        "col-md-9": this.mode == "reply" || this.mode == "add" ? true : false,
        "main-column": true
      },
      classObjectFirstRowLeftSide: {
        "first-row-left-side": this.mode == "add" ? true : false,
        "first-row-left-side-reply": this.mode == "reply" ? true : false
      },
      componentKeyTags: 0, // help to rerender tagify
      countActiveUsersTasks: [],
      creatorHasConfirmedTheTask: false,
      customToolbarReplyEditor: [[]],
      categoryTabs: [],
      // hashtagChar: true,
      // categoryTabs: this.getCategoryTabs(),
      // editorTabs:     this.getEditorTabs()
      changeEstTimeTitle: "",
      editorTabs: [],
      estTime: "",
      estTimeTag: {},
      email: null,
      formatWhitelist: ["bold"],
      editorSettings: {
        modules: {
          toolbar: {
            container: [
              [{ header: [false, 1, 2, 3, 4, 5, 6] }],
              ["bold", "italic", "underline"], // toggled buttons
              [{ align: "" }, { align: "right" }, { align: "justify" }],
              ["blockquote"],
              [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
              [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              ["link", "image", "video"]
              // ["clean"] // remove formatting button
            ],
            handlers: {
              video: () => {
                // just give your custom elements a class like "ql-customThingy" and the handlers will just work
              },
              redo: () => {}
            }
          },
          imageResize: { displaySize: true },
          mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            showDenotationChar: true,
            mentionDenotationChars: [
              " ",
              "@",
              "#",
              "anal",
              "anus",
              "arse",
              "ass",
              "ballsack",
              "balls",
              "bastard",
              "bitch",
              "biatch",
              "bloody",
              "blowjob",
              "bollock",
              "bollok",
              "boner",
              "boob",
              "bugger",
              "bum",
              "butt",
              "buttplug",
              "clitoris",
              "cock",
              "coon",
              "crap",
              "cunt",
              "damn",
              "dick",
              "dildo",
              "dyke",
              "fag",
              "feck",
              "fellate",
              "fellatio",
              "felching",
              "fuck",
              "fudgepacker",
              "flange",
              "goddamn",
              "hell",
              "homo",
              "jizz",
              "knobend",
              "labia",
              "muff",
              "nigger",
              "nigga",
              "jude",
              "penis",
              "piss",
              "poop",
              "prick",
              "pube",
              "pussy",
              "queer",
              "scrotum",
              "sex",
              "shit",
              "sh1t",
              "slut",
              "smegma",
              "spunk",
              "suck",
              "tit",
              "tosser",
              "turd",
              "twat",
              "vagina",
              "wank",
              "whore",
              "wtf"
            ],
            defaultMenuOrientation: "top",
            // offsetTop: 0,
            // offsetLeft:2,
            source: (searchTerm, renderList, mentionChar) => {
              let values;
              // let x = mentionChar.toLowerCase()
              if (mentionChar === "#") {
                values = this.hashValues;
                if (searchTerm.length === 0) {
                  renderList(values, searchTerm);
                } else {
                  const matches = [];
                  for (let i = 0; i < values.length; i++)
                    if (
                      ~values[i].value
                        .toLowerCase()
                        .indexOf(searchTerm.toLowerCase())
                    )
                      matches.push(values[i]);
                  if (matches.length > 0) {
                    renderList(matches, searchTerm);
                  } else {
                    let tempTag = {
                      denotationChar: "#",
                      id: "777",
                      index: "123",
                      value: searchTerm
                    };
                    matches.push(tempTag);
                    renderList(matches, searchTerm);
                  }
                }
              } else if (mentionChar === "@") {
                values = this.atValues;
                if (searchTerm.length === 0) {
                  renderList(values, searchTerm);
                } else {
                  const matches = [];
                  for (let i = 0; i < values.length; i++)
                    if (
                      ~values[i].value
                        .toLowerCase()
                        .indexOf(searchTerm.toLowerCase())
                    )
                      matches.push(values[i]);
                  if (matches.length > 0) {
                    renderList(matches, searchTerm);
                  } else {
                    let tempTag = {
                      denotationChar: "#",
                      id: "777",
                      index: "123",
                      value: searchTerm
                    };
                    matches.push(tempTag);
                    renderList(matches, searchTerm);
                  }
                }
              } else {
                setTimeout(() => {
                  // this.textValidation(this.taskTextFromLocal);
                }, 1000);
                mentionChar = null;
              }
            },
            onOpen: () => {},
            onSelect: async (item, insertItem) => {
              if (item.denotationChar === "#") {
                if (item.value === "OUTLINE") {
                  this.setOutlineTask(item.value);
                }
                if (item.value === "COMP. EVENT") {
                  this.setOutlineTask(item.value);
                }
                if (item.value === "OPEN SHIFT") {
                  this.setOutlineTask(item.value);
                  this.repeatOptionsObj.option = 9;
                }
                if (item.value === "ANNOUNCEMENT") {
                  this.setOutlineTask(item.value);
                  this.repeatOptionsObj.option = 8;
                }
                await this.addNewTagFromEditor(item.value);

                insertItem(item);
                let tempCategory = this.categoriesForMention.filter(
                  category => {
                    return category.value == item.value;
                  }
                );
                // if (this.selectedEditorTab == "MT" ||this.selectedEditorTab == "TASK") {
                if (
                  !this.newTask.cat_arr.some(category => {
                    //          checks if category already in array
                    return category.value == tempCategory[0].value;
                  })
                ) {
                  this.newTask.cat_arr.push(tempCategory[0]); // insert category from editor to new task object
                }
                // } else {
                //   this.subTasks.forEach(subTask => {
                //     if (this.selectedEditorTab == subTask.subTaskTab) {
                //       if (
                //         !subTask.subTaskCategory.some(category => {
                //           //          checks if category already in array
                //           return category.value == tempCategory[0].value;
                //         })
                //       ) {
                //         subTask.subTaskCategory.push(tempCategory[0]);
                //       }
                //     }
                //   });
                // }
                this.componentKeyTags += 1;
              } else if (item.denotationChar === "@") {
                insertItem(item);
                let selectedUser = this.salesPersonList.find(
                  user => user.id == item.id
                );
                this.newTask.taskUser.push(selectedUser);

                // let subTask_id = this.selectedEditorTab.substr(
                //   this.selectedEditorTab.length - 1
                // );
                // let subTaskUser = await this.salesPersonList.find(user => {
                //   return user.full_name == item.value;
                // });

                // this.subTasks[
                //   `subTask_${subTask_id}`
                // ].subTaskUserAssignment.push(subTaskUser);
              }
            }
          }
        }
      },
      errors: {},
      editMode: false,
      forceStopTimer: false,
      fileMaxSize: 4194304,
      hashValues: [],
      saveDelayCondition: false,
      isEditorDisabled: true,
      ifTimeFrameDisabled: true,
      keyDateTimeComponent: 0,
      keyTaskRepliesPreview: 0,
      loaderIsBusy: false,
      mainKey: 1,
      newTaskId: null,
      newTask: {
        project_id: undefined,
        location: undefined,
        taskText: "",
        taskType: {
          id: 1,
          title: "Task",
          type: "TASK"
        },
        taskSubType: {
          id: 1,
          title: "Task"
        },
        addingTaskSpentTime: null,
        // cat_arr: this.task ? this.task.categories : [],
        cat_arr: [],

        taskUser: [],
        userRelatedTasks: [],
        primaryUser: null,
        taskGroup: [],
        taskPriority: {
          id: 2,
          type: "LOW",
          title: "Low Priority"
        },
        myTasks: [],
        position: null,
        showNewTaskTextEditor: false,
        showNewTaskOptionsEditor: false,
        showNewTaskUsersEditor: false,
        selectedConnTaskId: [],
        showAddTaskConn: false,
        // taskDateTime: null, /// EDN

        taskDateTime: {
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          startTime: moment().format("YYYY-MM-DD"),
          endTime: moment().format("YYYY-MM-DD")
        },
        timeQuantity: 24
      },
      notApprovedStarRating: null,
      privateTask: false,
      updatedTask: {
        location: this.task ? this.task.location : "",
        content: this.task ? this.task.content : "",
        userIn: [],
        userOut: [],
        taskText: "",
        taskSubType: this.task
          ? this.task.task_sub_type
          : {
              id: 1,
              title: "Task"
            },
        taskType: this.task
          ? this.task.task_type
          : {
              id: 1,
              title: "Task",
              type: "TASK"
            },
        addingTaskSpentTime: null,
        cat_arr: [],

        taskUser: this.task ? this.task.task_assignment : [],
        taskGroup: [],
        taskPriority: this.task
          ? this.task.priority_type
          : {
              id: 2,
              type: "LOW",
              title: "Low Priority"
            },
        myTasks: [],
        position: null,
        showNewTaskTextEditor: false,
        showNewTaskOptionsEditor: false,
        showNewTaskUsersEditor: false,
        selectedConnTaskId: [],
        showAddTaskConn: false,
        // taskDateTime: null, /// EDN
        taskDateTime: {
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          startTime: moment().format("YYYY-MM-DD"),
          endTime: moment().format("YYYY-MM-DD")
        },
        timeQuantity: this.task ? this.task.time_quantity : 24
      },
      outline: false,
      oldEstTime: "",
      priority: false,
      // replyOpponent:this.getReplyOpponent(),
      replies: [],
      replyUsers: [],
      replyOpponent: "",
      repliesSendToButtons: [],
      requestUploadStatusBusy: false,
      replyMode: false,
      // replyTaskTextFromLocal: this.task ? this.task.content : "",
      replyTaskTextFromLocal: "",
      showUpdateReplyBtn: false,
      taskUserSubStatus: "",
      taskUsersTalking: [],
      taskUsersTalkingUsersArray: [],
      taskDelayed: false,
      taskDate: {
        // startDate: moment().format("YYYY-MM-DD"),
        startDate: this.task
          ? moment(this.task.start_time).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        endDate: this.task
          ? moment(this.task.end_time).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        startTime: this.task
          ? this.getTimeFromTask(this.task.start_time)
          : this.getStartTime(),
        endTime: this.task
          ? this.getTimeFromTask(this.task.end_time)
          : this.getEndTime()
      },
      toolbarOptions: {
        container: [
          [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          ["bold", "italic", "underline"], // toggled buttons
          [{ align: "" }, { align: "right" }, { align: "justify" }],
          ["blockquote"],
          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
          // [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          ["link", "image", "video"]
          // ["clean"] // remove formatting button
        ],
        handlers: {
          video: () => {
            // just give your custom elements a class like "ql-customThingy" and the handlers will just work
          },
          redo: () => {}
        }
      },
      topThreeUsers: [],
      topFiveTags: [],
      replyEditorSettings: {
        modules: {
          toolbar: {
            container: [
              [{ header: [false, 1, 2, 3, 4, 5, 6] }],
              ["bold", "italic", "underline"], // toggled buttons
              [{ align: "" }, { align: "right" }, { align: "justify" }],
              ["blockquote"],
              [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
              // [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              ["link", "image", "video"]
              // ["clean"] // remove formatting button
            ],
            handlers: {
              video: () => {
                // just give your custom elements a class like "ql-customThingy" and the handlers will just work
              },
              redo: () => {}
            }
          },
          imageResize: { displaySize: true },
          mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: [
              " ",
              "#",
              "anal",
              "anus",
              "arse",
              "ass",
              "ballsack",
              "balls",
              "bastard",
              "bitch",
              "biatch",
              "bloody",
              "blowjob",
              "bollock",
              "bollok",
              "boner",
              "boob",
              "bugger",
              "bum",
              "butt",
              "buttplug",
              "clitoris",
              "cock",
              "coon",
              "crap",
              "cunt",
              "damn",
              "dick",
              "dildo",
              "dyke",
              "fag",
              "feck",
              "fellate",
              "fellatio",
              "felching",
              "fuck",
              "fudgepacker",
              "flange",
              "goddamn",
              "hell",
              "homo",
              "jizz",
              "knobend",
              "labia",
              "muff",
              "nigger",
              "nigga",
              "jude",
              "penis",
              "piss",
              "poop",
              "prick",
              "pube",
              "pussy",
              "queer",
              "scrotum",
              "sex",
              "shit",
              "sh1t",
              "slut",
              "smegma",
              "spunk",
              "suck",
              "tit",
              "tosser",
              "turd",
              "twat",
              "vagina",
              "wank",
              "whore",
              "wtf"
            ],
            defaultMenuOrientation: "top",
            // offsetTop: 0,
            // offsetLeft:2,
            source: (searchTerm, renderList, mentionChar) => {
              let values;
              // let x = mentionChar.toLowerCase()
              if (mentionChar === "#") {
                values = this.hashValues;
                if (searchTerm.length === 0) {
                  renderList(values, searchTerm);
                } else {
                  const matches = [];
                  for (let i = 0; i < values.length; i++)
                    if (
                      ~values[i].value
                        .toLowerCase()
                        .indexOf(searchTerm.toLowerCase())
                    )
                      matches.push(values[i]);
                  if (matches.length > 0) {
                    renderList(matches, searchTerm);
                  } else {
                    let tempTag = {
                      denotationChar: "#",
                      id: "777",
                      index: "123",
                      value: searchTerm
                    };
                    matches.push(tempTag);
                    renderList(matches, searchTerm);
                  }
                }
              } else if (mentionChar === " ") {
              } else {
                setTimeout(() => {
                  // this.textValidation(this.taskTextFromLocal);
                }, 1000);
                mentionChar = null;
              }
            },
            onOpen: () => {},
            onSelect: async (item, insertItem) => {
              await this.addNewTagFromEditor(item.value);
              if (item.denotationChar === "#") {
                insertItem(item);
                let tempCategory = this.categoriesForMention.filter(
                  category => {
                    return category.value == item.value;
                  }
                );
                // if (this.selectedEditorTab == "MT" ||this.selectedEditorTab == "TASK") {
                if (
                  !this.newTask.cat_arr.some(category => {
                    //          checks if category already in array
                    return category.value == tempCategory[0].value;
                  })
                ) {
                  this.newTask.cat_arr.push(tempCategory[0]); // insert category from editor to new task object
                }
                // } else {
                //   this.subTasks.forEach(subTask => {
                //     if (this.selectedEditorTab == subTask.subTaskTab) {
                //       if (
                //         !subTask.subTaskCategory.some(category => {
                //           //          checks if category already in array
                //           return category.value == tempCategory[0].value;
                //         })
                //       ) {
                //         subTask.subTaskCategory.push(tempCategory[0]);
                //       }
                //     }
                //   });
                // }
                this.componentKeyTags += 1;
              } else if (item.denotationChar === "@") {
                insertItem(item);
                let subTask_id = this.selectedEditorTab.substr(
                  this.selectedEditorTab.length - 1
                );
                let subTaskUser = await this.salesPersonList.find(user => {
                  return user.full_name == item.value;
                });

                // this.subTasks[
                //   `subTask_${subTask_id}`
                // ].subTaskUserAssignment.push(subTaskUser);
              }
            }
          }
        },
        disabled: true
      },
      taskPreviewEditorSettings: {
        theme: "bubble",

        modules: {
          toolbar: {
            container: [
              // [{ header: [false, 1, 2, 3, 4, 5, 6] }],
              // ["bold", "italic", "underline"], // toggled buttons
              // [{ align: "" }, { align: "right" }, { align: "justify" }],
              // ["blockquote"],
              // [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
              // [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
              // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              // ["link", "image", "video"]
              // ["clean"] // remove formatting button
            ],
            handlers: {
              video: () => {
                // just give your custom elements a class like "ql-customThingy" and the handlers will just work
              },
              redo: () => {}
            }
          },
          // imageResize: { displaySize: true },
          mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: [
              " ",
              "#",
              "anal",
              "anus",
              "arse",
              "ass",
              "ballsack",
              "balls",
              "bastard",
              "bitch",
              "biatch",
              "bloody",
              "blowjob",
              "bollock",
              "bollok",
              "boner",
              "boob",
              "bugger",
              "bum",
              "butt",
              "buttplug",
              "clitoris",
              "cock",
              "coon",
              "crap",
              "cunt",
              "damn",
              "dick",
              "dildo",
              "dyke",
              "fag",
              "feck",
              "fellate",
              "fellatio",
              "felching",
              "fuck",
              "fudgepacker",
              "flange",
              "goddamn",
              "hell",
              "homo",
              "jizz",
              "knobend",
              "labia",
              "muff",
              "nigger",
              "nigga",
              "jude",
              "penis",
              "piss",
              "poop",
              "prick",
              "pube",
              "pussy",
              "queer",
              "scrotum",
              "sex",
              "shit",
              "sh1t",
              "slut",
              "smegma",
              "spunk",
              "suck",
              "tit",
              "tosser",
              "turd",
              "twat",
              "vagina",
              "wank",
              "whore",
              "wtf"
            ],
            defaultMenuOrientation: "top",
            // offsetTop: 0,
            // offsetLeft:2,
            source: (searchTerm, renderList, mentionChar) => {
              let values;
              // let x = mentionChar.toLowerCase()
              if (mentionChar === "#") {
                values = this.hashValues;
                if (searchTerm.length === 0) {
                  renderList(values, searchTerm);
                } else {
                  const matches = [];
                  for (let i = 0; i < values.length; i++)
                    if (
                      ~values[i].value
                        .toLowerCase()
                        .indexOf(searchTerm.toLowerCase())
                    )
                      matches.push(values[i]);
                  if (matches.length > 0) {
                    renderList(matches, searchTerm);
                  } else {
                    let tempTag = {
                      denotationChar: "#",
                      id: "777",
                      index: "123",
                      value: searchTerm
                    };
                    matches.push(tempTag);
                    renderList(matches, searchTerm);
                  }
                }
              } else if (mentionChar === " ") {
              } else {
                setTimeout(() => {
                  // this.textValidation(this.taskTextFromLocal);
                }, 1000);
                mentionChar = null;
              }
            },
            onOpen: () => {},
            onSelect: async (item, insertItem) => {
              await this.addNewTagFromEditor(item.value);
              if (item.denotationChar === "#") {
                insertItem(item);
                let tempCategory = this.categoriesForMention.filter(
                  category => {
                    return category.value == item.value;
                  }
                );
                // if (this.selectedEditorTab == "MT" ||this.selectedEditorTab == "TASK") {
                if (
                  !this.newTask.cat_arr.some(category => {
                    //          checks if category already in array
                    return category.value == tempCategory[0].value;
                  })
                ) {
                  this.newTask.cat_arr.push(tempCategory[0]); // insert category from editor to new task object
                }
                // } else {
                //   this.subTasks.forEach(subTask => {
                //     if (this.selectedEditorTab == subTask.subTaskTab) {
                //       if (
                //         !subTask.subTaskCategory.some(category => {
                //           //          checks if category already in array
                //           return category.value == tempCategory[0].value;
                //         })
                //       ) {
                //         subTask.subTaskCategory.push(tempCategory[0]);
                //       }
                //     }
                //   });
                // }
                this.componentKeyTags += 1;
              } else if (item.denotationChar === "@") {
                insertItem(item);
                let subTask_id = this.selectedEditorTab.substr(
                  this.selectedEditorTab.length - 1
                );
                let subTaskUser = await this.salesPersonList.find(user => {
                  return user.full_name == item.value;
                });

                // this.subTasks[
                //   `subTask_${subTask_id}`
                // ].subTaskUserAssignment.push(subTaskUser);
              }
            }
          }
        },
        disabled: true
      },
      subTasks: [],
      selectedEditorTab: "",
      // selectedEditorTab: this.mode == "add" ? "MT" : "TASK",
      selectedReplyIdToUpdate: null,
      selectedTimeDateTab: "MT",
      selectedCategoryTab: "MT",
      selectedUserTab: "MT",
      selectedTaskSubTab: "MT",
      statusUpdated: false,
      taskReadOnly: [],
      topFive: [],
      theRecoredItSelf: "",
      turnOnRec: false,
      taskTextFromLocal: "",
      transferMode: false,
      taskInCheckProgress: false,
      emailSent: false,
      // totalEstTime: this.setTotalEstTime(),
      // totalEstTime: moment.utc(1.08e7).format("HH:mm:ss"),
      // totalEstTime: moment.duration(1, "hour").format("HH:mm:ss"),
      taskTypesForShow: [],
      taskSubTabs: [],
      // taskSubTabs: this.getTabsForSubTask(),
      tasksTabs: this.task
        ? [
            {
              id: 1,
              name: "Calendar",
              alias: "CAL"
            },
            {
              id: 2,
              name: "Task",
              alias: "TASK"
            },
            {
              id: 3,
              name: "Reply",
              alias: "REPLY"
            }
          ]
        : [
            {
              id: 1,
              name: "Calendar",
              alias: "CAL"
            }
          ],
      timeDateTabs: [
        {
          id: 0,
          name: " Select main task date",
          alias: "MT"
        }
      ],
      tabForReply: "",
      transferUsers: [],
      usersTabs: [
        {
          id: 1,
          name: "Main task",
          alias: "MT"
        }
      ],
      userImgSrc: null,
      repeatOptionsObj: {
        option: null
      },
      canTransfer: false
    };
  },
  methods: {

    centerImagesCss(){

    },
    containsAlphaNumeric(str) {
      const len = str.length;
      let asciiCode;
      for (let i = 0; i < len; i++) {
        asciiCode = str.charCodeAt(i);
        if ((asciiCode > 47 && asciiCode < 58) || // numeric (0-9)
            (asciiCode > 64 && asciiCode < 91) || // upper alpha (A-Z)
            (asciiCode > 96 && asciiCode < 123)) { // lower alpha (a-z)
          return true;
        }
      }
      return false;
    },
    removeHtml(tag) {
      return tag.replace(/<\/?[^>]+(>|$)/g, "");
    },
    async handleEditorDropdown(type){
      switch (type){
        case '@':
          this.$refs.editor.quill.insertText(this.$refs.editor.quill.getText().length*2, '@');
          break;
        case '#':
          this.$refs.editor.quill.insertText(this.$refs.editor.quill.getText().length*2, '#');
          break;
        case 'TXT':
          this.$refs.editor.quill.insertText(this.$refs.editor.quill.getText().length*2, '\n');
          break;
        default:
          break;
      }
      this.componentKeyEditor++;
      this.$nextTick(() => {
        this.$refs.editor.quill.focus();
        this.$refs.editor.quill.setSelection(this.$refs.editor.quill.getText().length*2);
      });
    },
    copyStringToClipboard(str){
      let $temp = $("<textarea></textarea>");
      $('body').append($temp);
      $temp.val(str);
      $temp.text($(this).next().text()).select();
      document.execCommand("copy");
      $temp.remove();
      this.isTooltipCopyActive = true;
      setTimeout(()=>{this.isTooltipCopyActive=false},2000);
    },
    // copyTaskNumberToClipboard(input_id) {
    //   let $temp = $("<textarea></textarea>");
    //   $('body').append($temp);
    //   $temp.val('#' + input_id.slice(4));
    //   $temp.text($(this).next().text()).select();
    //   document.execCommand("copy");
    //   $temp.remove();
    //   this.isTooltipCopyActive = true;
    //   setTimeout(()=>{this.isTooltipCopyActive=false},2000);
    // },
    joinTaskToProject(projectId) {
      this.newTask.project_id = projectId;
    },
    async clearDelay() {
      try {
        this.$store.commit("clients/setLoading", true);
        const clearDelayTaskRequest = apiClientCreator(
          `tasks/clear_delay/${this.task.id}`
        );
        await clearDelayTaskRequest.post("");
        // delay_date: this.newTask.taskDateTime

        this.$store.commit("tasks/setFetchTasks", { flag: true });
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task returned successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        this.$emit("closeMainTaskWindow");
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task clear delay " +
            " " +
            " Error Status: " +
            e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },
    setStarRating(rating) {
      this.notApprovedStarRating = rating;
    },
    setOutlineTask(option) {
      if (option == "OUTLINE") {
        this.outline = true;
        this.changeEstTimeTitle = "OUTLINE";
        let data = {
          estTime: "OUTLINE",
          taskDate: {
            endDate: this.newTask.taskDateTime.startDate,
            endTime: this.newTask.taskDateTime.startTime,
            startDate: this.newTask.taskDateTime.startDate,
            startTime: this.newTask.taskDateTime.startTime
          }
        };
        this.taskDate = data.taskDate;
        this.setTaskDate(data);
      } else if (option == "COMP. EVENT") {
        this.outline = true;
        this.changeEstTimeTitle = "COMP. EVENT";
        let data = {
          estTime: "COMP. EVENT",
          taskDate: {
            endDate: this.newTask.taskDateTime.startDate,
            endTime: this.newTask.taskDateTime.startTime,
            startDate: this.newTask.taskDateTime.startDate,
            startTime: this.newTask.taskDateTime.startTime
          }
        };
      } else if (option == "OPEN SHIFT") {
        this.changeEstTimeTitle = "OPEN SHIFT";
        let data = {
          estTime: "OPEN SHIFT",
          taskDate: {
            endDate: this.newTask.taskDateTime.startDate,
            endTime: this.newTask.taskDateTime.startTime,
            startDate: this.newTask.taskDateTime.startDate,
            startTime: this.newTask.taskDateTime.startTime
          }
        };
        this.taskDate = data.taskDate;
        this.setTaskDate(data);
      } else if (option == "ANNOUNCEMENT") {
        this.changeEstTimeTitle = "ANNOUNCEMENT";
        let data = {
          estTime: "ANNOUNCEMENT",
          taskDate: {
            endDate: this.newTask.taskDateTime.startDate,
            endTime: this.newTask.taskDateTime.startTime,
            startDate: this.newTask.taskDateTime.startDate,
            startTime: this.newTask.taskDateTime.startTime
          }
        };
        this.taskDate = data.taskDate;
        this.setTaskDate(data);
      }
    },

    addTagFromTopFiveTags(category) {
      // let tempCat = this.topFiveTagsFromLast100.find(cat=>{
      //   return cat.category.code.id === catId
      // })
      if (category.cat_type === "OUTLINE") {
        this.setOutlineTask(category.cat_type);
      }
      if (category.cat_type === "OPEN SHIFT") {
        this.setOutlineTask(category.cat_type);
        this.repeatOptionsObj.option = 9;
      }
      if (category.cat_type === "ANNOUNCEMENT") {
        this.setOutlineTask(category.cat_type);
        this.repeatOptionsObj.option = 8;
      }
      if (category.cat_type === "COMP. EVENT") {
        this.setOutlineTask(category.cat_type);
      }
      let tempObj = {};
      tempObj.code = category;
      tempObj.value = category.cat_type;

      this.newTask.cat_arr.push(tempObj);
      // this.newTask.cat_arr.push(category)
      // let x = `<span class="mention">#${category.code.cat_type}</span>`
      if (this.mode == "add") {
        this.taskTextFromLocal += `<span class="mention">#${category.cat_type}</span>`;
      } else if (this.mode == "reply") {
        this.replyTaskTextFromLocal += `<span class="mention">#${category.cat_type}</span>`;
      }

      // this.$nextTick(() => {
      //
      //   let init = (html) => {
      //     let delta = this.$refs.editor.quill.clipboard.convert(html);
      //     this.$refs.editor.quill.setContents(delta, 'silent');
      //   }
      //   let html = `<h1>Hello</h1><p>World</p>`;
      //     //   init(html);
      //      // });

      // this.$nextTick(() => {
      //   this.$refs.editor.quill.root.innerHTML += x;
      //   //    this.$refs.editor.quill.root.insertAfter(x);
      // });
      // this.$nextTick(() => {
      //   this.$refs.editor.quill.focus("end");
      // });
      this.componentKeyTags += 1;
    },
    addTagFromTopThreeUsers(user) {
      if (this.mode == "add") {
        if (
          !this.newTask.taskUser.find(item => {
            return item.id === user.id;
          })
        ) {
          this.taskTextFromLocal += `<span class="mention">@${user.full_name}</span>`;
          this.newTask.taskUser.push(user);
        }
      } else if (this.mode == "reply") {
        if (
          !this.updatedTask.taskUser.find(item => {
            return item.id === user.id;
          })
        ) {
          this.replyTaskTextFromLocal += `<span class="mention">@${user.full_name}</span>`;
          this.updatedTask.taskUser.push(user);
        }
      }
    },
    cancelEditReply() {
      this.replyTaskTextFromLocal = "";
      this.showUpdateReplyBtn = false;
      this.selectedReplyIdToUpdate = null;
      // this.mainKey +=1
      // $('.cncl-edit-reply-btn').remove();
    },
    // addCancelUpdateReplyBtn(parent){
    //   $('.cncl-edit-reply-btn').remove();
    //   let cancelBtn = document.createElement("BUTTON");
    //   cancelBtn.className = "cncl-edit-reply-btn";
    //   cancelBtn.style.cssText = 'float:right;';
    //
    //   cancelBtn.onclick =  ()=> {
    //     this.cancelEditReply()
    //     // $('.cncl-edit-reply-btn').remove();
    //     // this.replyTaskTextFromLocal = null
    //     // this.showUpdateReplyBtn = false
    //     // this.selectedReplyIdToUpdate = null
    //     // this.mainKey +=1
    //
    //   };
    //   let textnode = document.createTextNode("X");
    //   cancelBtn.appendChild(textnode);
    //   parent.appendChild(cancelBtn);
    // },
    editReply(reply, idx) {
      if (event.target.tagName == "IMG") {
        let modal = document.getElementById("imgModal");
        let modalImg = document.getElementById("img01");
        modal.style.display = "block";
        modalImg.src = event.target.getAttribute("src");
        let span = document.getElementsByClassName("close-img-modal")[1];
        span.onclick = function() {
          modal.style.display = "none";
        };
      } else {
        if (reply.reply_by === this.auth.user.id && idx === 0) {
          this.replyTaskTextFromLocal = reply.content;
          this.showUpdateReplyBtn = true;
          this.selectedReplyIdToUpdate = reply.id;
        }
      }
    },
    changeReplyUser(val) {
      this.replyUsers = val;
    },
    getTaskUsersTalking() {
      this.task.task_assignment.forEach(item => {
        let userMentionTo = {};
        userMentionTo.id = item.assigned_to.id;
        userMentionTo.value = item.assigned_to.full_name;

        let userMentionBy = {};
        userMentionBy.id = item.assigned_by.id;
        userMentionBy.value = item.assigned_by.full_name;

        if (item.assigned_by.id === this.auth.user.id) {
          if (item.assigned_by.id !== item.assigned_to.id) {
            this.taskUsersTalking.push(userMentionTo);
            this.taskUsersTalkingUsersArray.push(item.assigned_to);
          }
        } else if (item.assigned_by.id !== this.auth.user.id) {
          if (item.assigned_to.id === this.auth.user.id) {
            this.taskUsersTalking.push(userMentionBy);
            this.taskUsersTalkingUsersArray.push(item.assigned_by);
          }
        }
        // if(userMention.id !== this.auth.user.id){
        if (this.task.task_type.id == 2) {
          this.replyUsers = this.taskUsersTalkingUsersArray;
          // console.log(this.replyUsers)
        }

        this.taskUsersTalking = _.uniqBy(this.taskUsersTalking, "id");
        this.taskUsersTalkingUsersArray = _.uniqBy(
          this.taskUsersTalkingUsersArray,
          "id"
        );
        //   this.taskUsersTalking.push(userMention)
        // }
      });

      this.replyUsers.push(this.taskUsersTalkingUsersArray[0]);
    },

    // checkIfShowDateBar() {
    //   if (this.mode == "reply-email") {
    //     return false;
    //   } else if (this.mode == "reply") {
    //     return false;
    //   } else if (this.mode == "add") {
    //     return true;
    //   }
    // },
    async getRepliesForAuthUser() {
      let replies = [];
      await this.task.reply.forEach(item => {
        item.reply_assignment.forEach(repItem => {
          if (repItem.assigned_to.id === this.auth.user.id) {
            replies.push(item);
          }
        });
      });
      // this.task.reply = replies;
      // this.replies = replies;
      this.replies = this.task.reply;
    },
    checkIfTaskInCheckProgress() {
      if (this.auth.user.id !== this.getOriginalCreator()) {
        let isInCheck = this.task.task_check.some(
          user => user.requested_check === this.auth.user.id
        );
        if (
          // (this.auth.user.role === 1 || this.auth.user.role === 2) &&  ///TODO: TO LEV CHECK IT
          // !isInCheck
          this.auth.user.role === 2 &&
          !isInCheck &&
          !this.checkIfThisTaskIsTransferredToMe()
        ) {
          this.taskInCheckProgress = true;
        } else {
          this.taskInCheckProgress = isInCheck;
        }
      }
      // else if (this.auth.user.id === this.getOriginalCreator()) {
      //   let isInCheck = this.task.task_check.some(
      //     user => user.is_checking === this.auth.user.id
      //   );
      //   this.taskInCheckProgress = isInCheck;
      // }
    },
    checkIfThisTaskIsTransferredToMe() {
      if (this.task !== "undefined") {
        return this.task.transfer.some(
          t => t.transfer_to.id === this.auth.user.id
        );
      }
    },
    canTransferPlusContent() {
      return [this.canTransfer, this.replyTaskTextFromLocal];
    },
    getUserReplyTo(replyTo) {
      let korsy = replyTo.find(item => {
        return item.assigned_by != item.assigned_to.id;
      });
      if (korsy) {
        return korsy.assigned_to.full_name;
      }
      // let userTo = " ";
      // this.assignReplyTo.forEach(user => {
      //   if (user.id !== replyTo) {
      //     userTo += user.full_name + " ";
      //   }
      // });
      // return userTo;
    },
    getTimeReply(time) {
      // let duration = moment.duration(moment(this.task.created_at).diff(time));
      let duration = moment.duration(moment(time).diff(this.task.created_at));
      // let hours = duration.asHours();
      let hours = duration.humanize();
      return hours;
    },

    clearReplySets() {
      this.$emit("clear_sets");
    },
    checkIfReciverNotCreator() {
      if (this.auth.user.id !== this.getOriginalCreator()) {
        return true;
      } else {
        return false;
      }
    },
    getReplyOpponent() {
      if (this.task) {
        let replyOppString = "to ";
        let replyOpp = this.assignReplyTo.filter(
          repUser => repUser.id != this.auth.user.id
        );
        replyOpp.forEach(user => {
          replyOppString += user.full_name + " ";
        });
        this.replyOpponent = replyOppString;
      } else {
        this.replyOpponent = "";
      }
    },
    setMeetingLocation(val) {
      this.newTask.location = val;
    },
    setRepOtp(val) {
      // if(val.length > 0){
      this.repeatOptionsObj.option = val;
      // }
    },
    selectRepeatOption(val) {
      this.repeatOptionsObj.option = val.repeatId;
    },

    formatCategories(categories) {
      let subTags = [];
      categories.forEach(tag => {
        subTags.push({
          code: tag.category,
          value: tag.category.cat_type
        });
      });
      this.componentKeyTags += 1;

      return subTags;
    },
    addExistingSubTaskTab() {
      let st = [];

      const creator = this.task.task_assignment.find(
        user => user.assigned_by.id === this.auth.user.id
      );

      const mainUser = this.task.transfer.find(
        user => user.transfer_by.id === this.auth.user.id
      );

      // const isSubTask  = !!this.task.main_task_id;
      const isSubTask = !!this.task.main_task_id;
      const isMainTask = !!this.task.main_id;

      if ((mainUser !== undefined || creator !== undefined) && !isSubTask) {
        st = this.task.sub_tasks;
      } //else if(((mainUser !== undefined || creator !== undefined) && isSubTask )|| !isMainTask ){
      // const subTask = {
      //  adding_task_spent_time: "0",
      //  categories: this.task.categories,
      //  content: this.task.content,
      //  created_at: this.task.created_at,
      //  due_status: this.task.due_status,
      //  end_time: this.task.end_time,
      //  id: this.task.id, ////??????
      //  is_new: 1, ///???????
      //  main_id: this.task.main_id, //??????
      //  main_task_id: 1,
      //  pos: 2, ///????/ must be null is sub task
      //  priority_id: 2, ///????
      //  start_time:this.task.start_time,
      //  status_id: 2, ///????/
      //  sub_task_pos_id: 1,
      //  task_assignment: this.task.task_assignment,
      //  time_quantity: 24,
      //  type_id: 3,
      //  updated_at: this.task.updated_at
      //  }
      //  st.push(subTask)
      else {
        //if(((mainUser !== undefined || creator !== undefined) && !isSubTask &&  isMainTask ) ){
        // alert()
        // st.push(
        //   this.task.sub_tasks.find(
        //     user => user.assigned_to === this.auth.user.id
        //   )
        // );
        const subTask = {
          adding_task_spent_time: "0",
          categories: this.task.categories,
          content: this.task.content,
          created_at: this.task.created_at,
          due_status: this.task.due_status,
          end_time: this.task.end_time,
          id: this.task.id, ////??????
          is_new: 1, ///???????
          main_id: this.task.main_id, //??????
          main_task_id: 1,
          pos: 2, ///????/ must be null is sub task
          priority_id: 2, ///????
          start_time: this.task.start_time,
          status_id: 2, ///????/
          sub_task_pos_id: 1,
          task_assignment: this.task.task_assignment,
          time_quantity: 24,
          type_id: 3,
          updated_at: this.task.updated_at
        };
        st.push(subTask);
      }
      st.forEach(st => {
        let id = this.subTasks.length + 2;
        let suBTaskTab = {
          id: id,
          name: `ST # ${id - 1}`,
          alias: `ST-${id}`
        };
        // if (id < 7) {
        this.editorTabs.push(suBTaskTab);
        this.usersTabs.push(suBTaskTab);
        this.categoryTabs.push(suBTaskTab);
        this.timeDateTabs.push(suBTaskTab);

        // this.subTasks[`subTask_${id - 1}`] = {
        //   subTaskId: id - 1,
        //   subTaskContent: "Sub-task #" + (id - 1),
        //   subTaskUserAssignment: [],
        //   subTaskTab: "ST-" + (id - 1)
        // };
        let subTags = [];
        // st.sub_task_tags.forEach(tag => {
        st.categories.forEach(tag => {
          subTags.push({
            code: tag.category,
            value: tag.category.cat_type
          });
        });

        let stUsers = [];

        if (isSubTask) {
          const subUser = st.task_assignment.find(
            user => user.task_id === st.id
          );
          // st.task_assignment.forEach(user => {
          stUsers.push(subUser.assigned_to);
          //  })
        } else {
          st.task_assignment.forEach(user => {
            if (
              user.assigned_to.id !==
                this.task.task_assignment[0].assigned_by.id &&
              user.assigned_to.id !== this.task.transfer[0].transfer_by.id
            ) {
              stUsers.push(user.assigned_to);
            }
          });
        }

        this.subTasks.push({
          subTaskId: id,
          subTaskContent: st.content,
          // subTaskUserAssignment: [st.user],
          subTaskUserAssignment: stUsers, //stUsers,
          // subTaskCategory: [],
          subTaskCategory: subTags,
          subTaskTab: "ST-" + id,
          subTaskDateTime: this.newTask.taskDateTime,
          subTaskEstTime: null,
          // subTaskDateTime: {
          //   startDate: moment().format("YYYY-MM-DD"),
          //   endDate: moment().format("YYYY-MM-DD"),
          //   startTime: moment().format("YYYY-MM-DD"),
          //   endTime: moment().format("YYYY-MM-DD")
          // },
          connectedTask: null
        });
        this.selectedEditorTab = "ST-" + id;
        this.selectedUserTab = "ST-" + id;
        this.selectedCategoryTab = "ST-" + id;
        this.selectedTimeDateTab = "ST-" + id;
        // }
        // this.showSubTaskSubMenu = false;
      });
    },

    // convertSubTaskUsers(subTasks){
    //   if(subTasks.length > 0){
    //     const users =[]
    //     subTasks.forEach(task=>{
    //        users.push(task.user)
    //       task.users = users
    //     });
    //
    //     subTaskUserAssignment: users
    //
    //     return {subTasks}
    //   }
    //
    //   return [];
    // },
    // comparer(otherArray) {
    //   return current => {
    //     return (
    //       otherArray.filter(other => {
    //         return (
    //           other.id == current.id
    //         );
    //       }).length == 0
    //     );
    //   };
    // },
    getUsersTaskAssignment(task) {
      let tempTaskUsers = [];
      if (task) {
        task.task_assignment.forEach(item => {
          tempTaskUsers.push(item.assigned_to);
        });
      }
      return tempTaskUsers;
      // return tempTaskUsers;
    },
    changeTaskUser(user) {
      this.updatedTask.taskUser = user;
      let oldUsers = this.getUsersTaskAssignment(this.task);
      let newUsers = user;
      let userOut = _.differenceBy(oldUsers, newUsers, "id");
      let userIn = _.differenceBy(newUsers, oldUsers, "id");

      this.updatedTask.userIn = userIn;
      this.updatedTask.userOut = userOut;

      // // let intersection = this.this.task.task_assignment.filter(user => arr2.includes(x));
      // a = [{ value:"4a55eff3-1e0d-4a81-9105-3ddd7521d642", display:"Jamsheer"}, { value:"644838b3-604d-4899-8b78-09e4799f586f", display:"Muhammed"}, { value:"b6ee537a-375c-45bd-b9d4-4dd84a75041d", display:"Ravi"}, { value:"e97339e1-939d-47ab-974c-1b68c9cfb536", display:"Ajmal"},  { value:"a63a6f77-c637-454e-abf2-dfb9b543af6c", display:"Ryan"}]
      // b = [{ value:"4a55eff3-1e0d-4a81-9105-3ddd7521d642", display:"Jamsheer", $$hashKey:"008"}, { value:"644838b3-604d-4899-8b78-09e4799f586f", display:"Muhammed", $$hashKey:"009"}, { value:"b6ee537a-375c-45bd-b9d4-4dd84a75041d", display:"Ravi", $$hashKey:"00A"}, { value:"e97339e1-939d-47ab-974c-1b68c9cfb536", display:"Ajmal", $$hashKey:"00B"}]

      // let onlyInA = this.task.task_assignment.filter(
      //   this.comparer(this.updatedTask.taskUser)
      // );
      // let onlyInB = this.updatedTask.taskUser.filter(
      //   this.comparer(this.task.task_assignment)
      // );
      //   www.txt.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');

      //

      // let result = onlyInA.concat(onlyInB);
    },

    async getUserRelatedTasks(userId) {
      this.newTask.userRelatedTasks = [];
      try {
        if (userId !== null) {
          let apiClient = apiClientCreator(
            `tasks/getTasksForPosition/${userId}`
          );
          let data = { outline: this.outline };
          await apiClient.get("", { params: data }).then(res => {
            this.newTask.userRelatedTasks = res.data;
            this.newTask.primaryUser = userId;
          });
        }
      } catch (e) {}
    },
    getUserTaskSubStatus() {
      if (this.task.taskSubStatus.length) {
        const subStat = this.task.taskSubStatus.find(
          user => user.user_id === this.auth.user.id
        );
        if (subStat && subStat.task_sub_status_type) {
          this.taskUserSubStatus = subStat.task_sub_status_type.title;
        }
      }
    },
    getEndTime(estimate) {
      if (estimate === undefined) {
        // let end = moment(this.taskDate.endTime);
        let end = moment();
        let remainderEnd = end.minute() % 15;
        let dateTimeEnd;
        if (remainderEnd < 7) {
          dateTimeEnd = moment(end)
            .subtract(remainderEnd, "minutes")
            .format();
        } else {
          remainderEnd = 15 - (end.minute() % 15);
          dateTimeEnd = moment(end)
            .add(remainderEnd, "minutes")
            .format();
        }
        return moment(dateTimeEnd)
          .add(3, "hours")
          .format()
          .slice(11, 19);
      } else {
        let end = estimate;
        let remainderEnd = end.minute() % 15;
        let dateTimeEnd;
        if (remainderEnd < 7) {
          dateTimeEnd = moment(end)
            .subtract(remainderEnd, "minutes")
            .format();
        } else {
          remainderEnd = 15 - (end.minute() % 15);
          dateTimeEnd = moment(end)
            .add(remainderEnd, "minutes")
            .format();
        }
        this.taskDate.endTime = moment(dateTimeEnd)
          .format()
          .slice(11, 19);
      }
    },
    getStartTime() {
      let start = moment();
      let remainder = start.minute() % 15;
      let dateTime;
      if (remainder < 7) {
        dateTime = moment(start)
          .subtract(remainder, "minutes")
          .format();
      } else {
        remainder = 15 - (start.minute() % 15);
        dateTime = moment(start)
          .add(remainder, "minutes")
          .format();
      }

      return moment(dateTime)
        .format()
        .slice(11, 19);
    },

    getTimeFromTask(time) {
      let temp = moment(time).format("HH") + ":" + moment(time).format("mm");
      return temp;
    },
    filterSubTaskByUser() {
      if (this.task) {
        const st = [];
        const creator = this.task.task_assignment.find(
          user => user.assigned_by.id === this.auth.user.id
        );
        const mainUser = this.task.transfer.find(
          user => user.transfer_by.id === this.auth.user.id
        );

        if (mainUser !== undefined || creator !== undefined) {
          return { subTasks: this.task.sub_tasks };
        }
        st.push(
          this.task.sub_tasks.find(
            user => user.assigned_to === this.auth.user.id
          )
        );
        return { subTasks: st };
      }
    },

    closeRecDiv() {
      this.$emit("close");
      this.turnOnRec = !this.turnOnRec;
    },
    sendRec(val) {
      this.requestUploadStatusBusy = true;
      let formData = new FormData();
      formData.append("file", val);
      if (val.size <= this.fileMaxSize) {
        this.loaderIsBusy = true;
        apiClientCreator(`tasks/file`)
          .post("", formData)
          .then(result => {
            this.requestUploadStatusBusy = false;

            let url = result.data; // Get url from response
            const vid = `<p><video type="video/mp4" width="240" height="180" controls class="ql-video" src="${url}"></video></p>`;
            $(".ql-editor").append(vid);
            this.theRecoredItSelf = url;
            this.loaderIsBusy = false;
            this.closeRecDiv();
          })
          .catch(err => {});
      } else {
        this.requestUploadStatusBusy = false;

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: `Error uploading file: Max size 4mb `,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
      }
    },

    async addNewSubTasks() {
      this.$store.commit("clients/setLoading", true);
      const apiClient = apiClientCreator(`tasks/sub_task/add/${this.task.id}`);
      await this.subTaskCatIds(this.subTasks);

      let newSubTask = this.subTasks.slice(
        this.task.sub_tasks.length,
        this.subTasks.length
      );

      apiClient.post("", { subTasks: newSubTask }).then(res => {});
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Sub Task Added",
        type: "DONE",
        op: { type: "SYSTEM" }
      });

      this.$emit("closeMainTaskWindow");
      this.$store.commit("clients/setLoading", false);
      this.$store.commit("tasks/setFetchTasks", { flag: true });
    },

    setEmail(email) {
      this.email = email;
    },
    taskIsOutline() {
      if (this.outline) {
        this.newTask.taskType.id = 10;
        this.newTask.taskSubType.id = 3;
        this.newTask.taskSubType.title = "Outline";

        this.updatedTask.taskType.id = 10;
        this.updatedTask.taskSubType.id = 3;
      } else {
        this.newTask.taskType.id = 1;
        // this.newTask.taskSubType.id = 1;
        // this.newTask.taskSubType.title = "Task";
      }
    },
    // getTabsForSubTask() {
    //   if (this.task) {
    //     if (this.task.sub_task_assignment.length > 0) {
    //       let tempId = 1;
    //       let tempTabs = [];
    //       tempTabs.push({ id: tempId, name: "Main task", alias: "MT" });
    //       tempId++;
    //       this.filterSubTaskByUser().subTasks.forEach(subTask => {
    //       // this.filterSubTaskByUser().subTasks.forEach(subTask => {
    //         tempTabs.push({
    //           id: tempId,
    //           name: `SUB-TASK#${tempId}`,
    //           alias: `ST-${tempId}`
    //         });
    //         tempId++;
    //       });
    //       return tempTabs;
    //     }
    //   } else {
    //     return [{ id: 1, name: "Main task", alias: "MT" }];
    //   }
    // },
    getTabsForSubTask() {
      if (this.task) {
        if (this.task.sub_tasks.length > 0) {
          let tempId = 1;
          let tempTabs = [];
          tempTabs.push({ id: tempId, name: "Main task", alias: "MT" });
          tempId++;
          this.task.sub_tasks.forEach(subTask => {
            tempTabs.push({
              id: tempId,
              name: `SUB-TASK#${tempId}`,
              alias: `ST-${tempId}`
            });
            tempId++;
          });
          return tempTabs;
        }
      } else {
        return [{ id: 1, name: "Main task", alias: "MT" }];
      }
    },
    getTaskSubStatusByUser(userId) {
      let userSubStatus = this.task.taskSubStatus.find(item => {
        return item.user_id == userId;
      });
      if (userSubStatus && userSubStatus.task_sub_status_type) {
        return userSubStatus.task_sub_status_type.title;
      } else {
        return "Default";
      }
    },
    // cancelTask() {
    //   this.$store.commit("clients/setLoading", true);
    //
    //   const cancelTask = apiClientCreator(`tasks/cancel_task/${this.task.id}`);
    //   cancelTask.post("").then(res => {
    //     this.$root.$emit("task_competed", this.task.id);
    //   });
    //   this.$store.commit("main/setShowVikiMsg", {
    //     show: true,
    //     msg: "Task cancelled successfully",
    //     type: "DONE",
    //     op: { type: "SYSTEM" }
    //   });
    //   this.$store.commit("clients/setLoading", false);
    //   this.$store.commit("tasks/setFetchTasks", { flag: true });
    // },
    usersForTransfer(transferToThisUser) {
      this.transferUsers = transferToThisUser;
    },
    taskForFuture(type_id) {
      this.newTask.taskType.id = type_id;
    },
    sendTaskreplies(replies) {
      this.repliesSendToButtons = replies;
    },
    setReplyContent(replyContent) {
      this.replyTaskTextFromLocal = replyContent;

      if (Object.keys(this.replyTaskTextFromLocal).length > 0) {
        this.canTransfer = true;
      }
      if (Object.keys(this.replyTaskTextFromLocal).length === 0) {
        this.canTransfer = false;
      }
    },
    creatorConfirmedTask(yesOrNo) {
      this.creatorHasConfirmedTheTask = yesOrNo;
    },
    setSelectedConnTaskId(task) {
      if (this.newTask.selectedConnTaskId.indexOf(task.id) === -1) {
        this.newTask.selectedConnTaskId.push(task.id);
        this.addSubTaskTab();
        this.subTasks[this.subTasks.length - 1].subTaskContent = task.content;
        this.subTasks[this.subTasks.length - 1].connectedTask = task.id;
        let tempCatArr = [];
        task.categories.forEach(catItem => {
          tempCatArr.push({
            code: catItem,
            value: catItem.category.cat_type
          });
        });

        this.subTasks[this.subTasks.length - 1].subTaskCategory = tempCatArr;
        task.task_assignment.forEach(item => {
          this.subTasks[this.subTasks.length - 1].subTaskUserAssignment.push(
            item.assigned_to
          );
        });
      }

      // this.showSubTaskSubMenu = false;
    },
    checkIfTaskIsReadOnly() {
      if (this.task) {
        let readOnly = this.task.task_read_only.some(
          user => user.user_id === this.auth.user.id
        );
        if (readOnly) {
          this.replyTaskTextFromLocal = `<p>Read Only </p>`.concat(
            this.task.content
          );
        }
      }
    },
    setTaskReadOnly(readOnly) {
      this.taskReadOnly = readOnly;
    },
    async getTopFive() {
      let apiClient = apiClientCreator(`tasks/stats/top_five`);
      await apiClient.get("").then(res => {
        let allowedUsers = res.data.filter(user => {
          // return  this.auth.user.role < user.user.role || this.auth.user.role === user.user.role || this.auth.user.role === user.user.role - 1
          return this.allowedUsersByRole(user.user.role);
        });
        let s = allowedUsers.sort(function(a, b) {
          return b.count - a.count;
        });
        this.countActiveUsersTasks = s;

        let topFive = s.slice(0, 5);
        this.topFive = topFive;
      });
    },
    getTopThreeUsersFromLast100(topThreeUsers) {
      // let apiClient = apiClientCreator(`tasks/stats/top_three_users`);
      // await apiClient.get("").then(res => {
      let allowedUsers = topThreeUsers.filter(user => {
        // return  this.auth.user.role < user.user.role || this.auth.user.role === user.user.role || this.auth.user.role === user.user.role - 1
        return this.allowedUsersByRole(user.user.role);
      });
      let s = allowedUsers.sort(function(a, b) {
        return b.count - a.count;
      });
      this.countActiveUsersTasks = s;

      let topThree = s.slice(0, 5);
      this.topThreeUsers = topThree;
      // });
    },
    getTopFiveTagsFromLast100(topFiveTags) {
      // let apiClient = apiClientCreator(`tasks/stats/top_five_tags`);
      // await apiClient.get("").then(res => {
      // let topFiveTags = Object.keys(res.data)
      //   .map(key => ({
      //     cat_id: Number(key),
      //     count: res.data[key]
      //     // user_id: Number(key), session_id: sessionObject[key]
      //   }))
      //   .sort(function(a, b) {
      //     return b.count - a.count;
      //   })
      //   .slice(0, 5);
      // topFiveTags.forEach(catFromTopFive => {
      //   this.categoriesForMention.forEach(category => {
      //     if (category.code.id === catFromTopFive.cat_id) {
      //       // this.topFiveTagsFromLast100.push(category)
      //       catFromTopFive["category"] = category;
      //     }
      //   });
      // });
      topFiveTags.forEach(catFromTopFive => {
        this.categories.forEach(category => {
          if (category.id === catFromTopFive.cat_id) {
            // this.topFiveTagsFromLast100.push(category)
            catFromTopFive["category"] = category;
          }
        });
      });
      this.topFiveTags = topFiveTags;
      // });
    },
    cancelCheckFromMain(whoIsCanceledCheck) {
      this.$store.commit("clients/setLoading", true);

      const addNewClientRequest = apiClientCreator(
        `tasks/cancel_check/${this.task.id}`
      );

      const data = {
        is_canceled_check: whoIsCanceledCheck
      };
      if (this.replyTaskTextFromLocal) {
        // Object.assign(data, { reply_content: this.taskTextFromLocal });
        Object.assign(data, { reply_content: this.replyTaskTextFromLocal });
      }

      addNewClientRequest
        .post("", data)
        .then(res => {
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg: "Check is canceled",
            type: "DONE",
            op: { type: "SYSTEM" }
          });
          this.$store.commit("clients/setLoading", false);
          // this.showReplyTaskText = false;
          this.$emit("closeMainTaskWindow");
          this.$store.commit("tasks/setFetchTasks", { flag: true });
          // this.$root.$emit("change_tab_to_waiting");
        })
        .catch(err => {
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg: "You can not cancel task check",
            type: "ERROR",
            op: { type: "SYSTEM" }
          });

          setTimeout(() => {
            this.$store.commit("main/setShowVikiMsg", {
              show: false,
              id: null,
              msg: "",
              type: "",
              op: {
                type: "",
                clientId: null,
                userId: null
              }
            });
          }, 7000);
        });
    },
    approvedByCreator() {
      this.$store.commit("clients/setLoading", true);

      const creatorApprove = apiClientCreator(
        `tasks/approved_by_creator/${this.task.id}`
      );

      const data = {};
      if (this.replyTaskTextFromLocal) {
        // Object.assign(data, { reply_content: this.taskTextFromLocal });
        Object.assign(data, { reply_content: this.replyTaskTextFromLocal });
      }
      Object.assign(data, { not_approved_rating: this.notApprovedStarRating });

      creatorApprove.post("", data).then(res => {
        this.$emit("clear_sets");
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        // this.$root.$emit("change_tab_to_waiting");
      });
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Creator Approved",
        type: "DONE",
        op: { type: "SYSTEM" }
      });
      this.$store.commit("clients/setLoading", false);
    },

    syntheticCheck(whoIsChecking) {
      this.$store.commit("clients/setLoading", true);
      let ids = [];
      this.updatedTask.userIn.forEach(item => {
        ids.push(item.id);
      });
      const addNewClientRequest = apiClientCreator(
        `tasks/synthetic_check/${this.task.id}`
      );

      const data = {
        is_checking: ids
        // is_checking: whoIsChecking
      };
      if (this.replyTaskTextFromLocal) {
        // Object.assign(data, { reply_content: this.taskTextFromLocal });
        Object.assign(data, {
          reply_content: this.replyTaskTextFromLocal + ", Check Me synthetic"
        });
      }
      addNewClientRequest.post("", data).then(res => {
        this.$root.$emit("task_check_timer_stop", this.task.id);
        this.$emit("closeMainTaskWindow");
        // this.$root.$emit("change_tab_to_waiting");
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Sent To synthetic check",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        // this.showReplyTaskText = false;
        this.$store.commit("tasks/setFetchTasks", { flag: true });
      });
    },
    checkMe(whoTransferred) {
      this.$store.commit("clients/setLoading", true);

      const addNewClientRequest = apiClientCreator(
        `tasks/check/${this.task.id}`
      );

      const data = {
        is_checking: whoTransferred
      };
      if (this.replyTaskTextFromLocal) {
        // Object.assign(data, { reply_content: this.taskTextFromLocal });
        Object.assign(data, {
          reply_content: this.replyTaskTextFromLocal + ", Check Me"
        });
      }

      addNewClientRequest.post("", data).then(res => {
        this.$root.$emit("task_check_timer_stop", this.task.id);
        this.$emit("closeMainTaskWindow");
        // this.$root.$emit("change_tab_to_waiting");
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Sent To Check",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        // this.showReplyTaskText = false;
        this.$store.commit("tasks/setFetchTasks", { flag: true });
      });
    },

    updateTitle(val) {
      if (val.length !== 0) {
        this.newTask.cat_arr = val;
      } else if (val.length === 0) {
        this.newTask.cat_arr = [];
      }
    },
    updateSubCategories(category, subTaskId) {
      this.subTasks.forEach(subTask => {
        if (subTask.subTaskId === subTaskId) {
          subTask.subTaskCategory.push(category);
        }
      });
    },
    setTaskUser(user) {
      this.newTask.taskUser = user.user;
      if (user[0]) {
        this.userImgSrc = user[0].profile_img;
      } else {
        this.userImgSrc = null;
      }
    },
    setEstTime(value) {
      switch (value) {
        case "OUTLINE":
          // this.$emit("reapetOption", this.selectedRepeatOption);
          // this.$emit("outLineTaskDateTime");
          break;
        case "15 minutes":
          return 0.25;
        case "30 minutes":
          return 0.5;
        case "1 hour":
          return 1;
        case "2 hours":
          return 2;
        case "3 hours":
          return 3;
        case "6 hours":
          return 6;
        case "9 hours":
          return 9;
        case "12 hours":
          return 12;
        case "15 hours":
          return 15;
        case "1 day":
          return 24;
        case "2 days":
          return 48;
        case "3 days":
          return 72;
        case "week":
          return 168;
        case "2 weeks":
          return 336;
        case "month":
          return 720;
        case "2 month":
          return 1440;
        case "3 month":
          return 2160;
        case "Half a year":
          return 4320;
        case "9 month":
          return 6480;
        case "Year":
          return 8640;
        case "Year and half":
          return 12960;
        case "2 years":
          return 17280;
        case "3 years":
          return 25920;
        case "5 years":
          return 43200;
        default:
      }
    },
    addEstTimeTag(estTime) {
      let newSubCategory = estTime;
      // let estTimeTag = this.categoriesForMention.find(category => {
      // let estTimeTag = this.categories.find(category => {
      //   return category.value === estTime;
      // });
      let estTimeTag = this.categories.find(category => {
        return category.cat_type === estTime;
      });
      if (estTimeTag === undefined) {
        apiClientCreator(`tasks/category/`)
          .post("", { cat_type: newSubCategory })
          .then(res => {
            let tag = {};
            tag.value = estTime;
            tag.code = res.data;
            this.estTimeTag = tag;
            this.insertEstTimeTagIntoEditor();
          })
          .catch(err => {});
      } else {
        this.estTimeTag = estTimeTag;
        if (
          this.estTimeTag.cat_type !== "3 hours" &&
          this.estTimeTag.cat_type !== "QUESTION"
        ) {
          this.insertEstTimeTagIntoEditor();
        }
        // this.newTask.cat_arr.push(estTimeTag);
      }
      this.oldEstTime = estTime;

      // this.editorSettings.modules.mention.onSelect(this.estTimeTag, this.editorSettings.modules.mention.insertItem)
    },
    insertEstTimeTagIntoEditor() {
      if (
        this.estTimeTag.cat_type !== "OUTLINE" &&
        this.estTimeTag.cat_type !== "ANNOUNCEMENT" &&
        this.estTimeTag.cat_type !== "OPEN SHIFT" &&
        this.estTimeTag.cat_type !== "COMP. EVENT"
      ) {
        let estTagIndex = this.taskTextFromLocal.lastIndexOf(
          "#Estimated time:"
        );
        if (estTagIndex !== -1) {
          let res = this.taskTextFromLocal.replace(
            this.oldEstTime,
            this.estTimeTag.cat_type
          );
          this.taskTextFromLocal = res;
        } else {
          this.taskTextFromLocal += `#Estimated time: ${this.estTimeTag.cat_type}.`;
        }
      } else {
        let estTagIndex = this.taskTextFromLocal.lastIndexOf(
          "#Estimated time:"
        );

        if (estTagIndex !== -1) {
          let res = this.taskTextFromLocal.replace(`${this.oldEstTime}.`, "");
          let res2 = res.replace("#Estimated time:", "");
          this.taskTextFromLocal = res2;
          // this.taskTextFromLocal = this.taskTextFromLocal.substring(
          //   0,
          //   estTagIndex
          // );
        }

        let tempObj = {};
        tempObj.code = this.estTimeTag;
        tempObj.value = this.estTimeTag.cat_type;

        this.newTask.cat_arr.push(tempObj);
        // this.newTask.cat_arr.push(category)
        // let x = `<span class="mention">#${this.estTimeTag.code.cat_type}</span>`
        this.taskTextFromLocal += `<span class="mention">#${this.estTimeTag.cat_type}</span>`;
        // this.$nextTick(() => {
        //
        //   let init = (html) => {
        //     let delta = this.$refs.editor.quill.clipboard.convert(html);
        //     this.$refs.editor.quill.setContents(delta, 'silent');
        //   }
        //   let html = `<h1>Hello</h1><p>World</p>`;
        //     //   init(html);
        //      // });

        // this.$nextTick(() => {
        //   this.$refs.editor.quill.root.innerHTML += x;
        //   //    this.$refs.editor.quill.root.insertAfter(x);
        // });
        // this.$nextTick(() => {
        //   this.$refs.editor.quill.focus("end");
        // });
        this.componentKeyTags += 1;
      }
    },
    setTaskType(type) {
      this.newTask.taskType = type;
    },
    changeTaskSubType(subType) {
      this.newTask.taskSubType = subType;
    },
    setTaskDate(value) {
      if (
        value.estTime != "OUTLINE" &&
          value.estTime != "OPEN SHIFT" &&
          value.estTime != "COMP. EVENT" &&
        value.estTime != "ANNOUNCEMENT"
      ) {
        this.outline = false;
        this.changeEstTimeTitle = false;
      }
      this.newTask.taskDateTime = value.taskDate;
      this.activeDate = value.taskDate.startDate;
      let start = moment(
        value.taskDate.startDate + " " + value.taskDate.startTime
      ).format("YYYY-MM-DD HH:mm");
      let end = moment(
        value.taskDate.endDate + " " + value.taskDate.endTime
      ).format("YYYY-MM-DD HH:mm");
      // this.newTask.timeQuantity = moment
      //   .duration(moment(end).diff(start))
      //   .asHours();

      this.newTask.timeQuantity = this.setEstTime(value.estTime);
      // this.addEstTimeTag(value.estTime)
    },
    setTaskDateFromSelectPosition(value) {
      // this.newTask.taskDateTime = value.taskDate;
      // this.activeDate = value.startDate;

      this.taskDate = value;

      // this.keyDateTimeComponent +=1
    },
    setSubTaskDate(value, subTaskId) {
      this.subTasks.forEach(subTask => {
        if (subTask.subTaskId === subTaskId) {
          subTask.subTaskDateTime = value.taskDate;
          subTask.subTaskEstTime = value.estTime;
        }
      });
    },
    setTotalEstTime() {
      this.subTasks.forEach(subTask => {});
      // let x  = moment
      //         .duration(this.totalEstTime).add(2, "hour")
      // this.totalEstTime = moment
      //         .utc(x.asMilliseconds())
      //         .format("HH:mm:ss");
      // this.setTotalEstTime(value.estTime);
      // let tempTotalEstTime = this.totalEstTime
      //
      // switch (this.estimatedTime) {
      //   case "15 minutes":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       15,
      //       "minutes"
      //     );
      //
      //     break;
      //   case "30 minutes":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       30,
      //       "minutes"
      //     );
      //         break;
      //   case "1 hour":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       60,
      //       "minutes"
      //     );
      //          break;
      //   case "2 hours":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       120,
      //       "minutes"
      //     );
      //        break;
      //   case "3 hours":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       180,
      //       "minutes"
      //     );
      //        break;
      //   case "6 hours":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       6,
      //       "hours"
      //     );
      //          break;
      //   case "9 hours":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       9,
      //       "hours"
      //     );
      //
      //     break;
      //   case "12 hours":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       12,
      //       "hours"
      //     );
      //
      //     break;
      //   case "15 hours":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       15,
      //       "hours"
      //     );
      //     break;
      //   case "1 day":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       1,
      //       "day"
      //     );
      //     break;
      //   case "2 days":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       2,
      //       "days"
      //     );
      //     break;
      //   case "3 days":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       3,
      //       "days"
      //     );
      //     break;
      //   case "week":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       1,
      //       "week"
      //     );
      //
      //     break;
      //   case "2 weeks":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       2,
      //       "weeks"
      //     );
      //     break;
      //   case "month":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       1,
      //       "month"
      //     );
      //     break;
      //   case "2 month":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       2,
      //       "months"
      //     );
      //     break;
      //   case "3 month":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       3,
      //       "months"
      //     );
      //     break;
      //   case "Half a year":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       6,
      //       "months"
      //     );
      //     break;
      //   case "9 month":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       9,
      //       "months"
      //     );
      //
      //     break;
      //   case "Year":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       1,
      //       "year"
      //     );
      //     break;
      //   case "Year and half":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       1.5,
      //       "year"
      //     );
      //     break;
      //   case "2 years":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       2,
      //       "years"
      //     );
      //     break;
      //   case "3 years":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       3,
      //       "years"
      //     );
      //
      //     break;
      //   case "5 years":
      //     this.setEndTime(
      //       moment(this.taskDate.startDate)
      //         .hours(this.taskDate.startTime.slice(0, 2))
      //         .minutes(this.taskDate.startTime.slice(3, 5)),
      //       5,
      //       "years"
      //     );
      //
      //     break;
      //   default:
      //   // code block
      // }
      //
      // item.totalTime = moment
      //   .duration(item.totalTime)
      //   .add(moment.duration(resItem.time));
      // item.totalTime = moment
      //   .utc(item.totalTime.asMilliseconds())
      //   .format("HH:mm:ss");
    },

    changeActiveDateForCalendar(newActiveDate) {
      this.activeDate = newActiveDate;
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      this.requestUploadStatusBusy = true;
      if (file.size <= this.fileMaxSize) {
        if (file.type.indexOf("image") != -1) {
          let formData = new FormData();
          formData.append("image", file);
          apiClientCreator(`tasks/image`)
            .post("", formData)
            .then(result => {
              this.requestUploadStatusBusy = false;

              let url = result.data; // Get url from response

              Editor.insertEmbed(cursorLocation, "image", url);
              resetUploader();
              let images = document
                .getElementById("new-add-task-editor")
                .getElementsByTagName("IMG");
              images.forEach(img => {
                img.setAttribute("class", "img-editor");
                img.onclick = function() {
                  let modal = document.getElementById("imgModal");
                  let modalImg = document.getElementById("img01");
                  $("#imgModal").modal();
                  modalImg.src = this.src;
                  // let span = document.getElementsByClassName(
                  //   "close-img-modal"
                  // )[0];
                  let span = document.getElementsByClassName("close-img-modal");
                  for (let item of span) {
                    item.onclick = function() {
                      $("#imgModal").modal("hide");
                      modal.style.display = "none";
                    };
                  }
                };
              });
            })
            .catch(err => {});
        } else if (
          file.type.indexOf("pdf") != -1 ||
          file.type.indexOf("doc") != -1 ||
          file.type.indexOf("docx") != -1 ||
          file.type.indexOf("txt") != -1 ||
          file.type.indexOf("text") != -1 ||
          file.type == "" // NEED TO AVOID UPLOADING ALL TYPES OF FILES
        ) {
          let formData = new FormData();
          formData.append("file", file);

          apiClientCreator(`tasks/file`)
            .post("", formData)
            .then(result => {
              this.requestUploadStatusBusy = false;

              let url =
                "https://docs.google.com/viewer?url=" +
                result.data +
                "&embedded=true"; // Get url from response
              Editor.insertEmbed(
                cursorLocation,
                "video",
                url,
                "100",
                "100",
                "1"
              );
              let files = document.getElementsByTagName("IFRAME");
              files.forEach(file => {
                file.setAttribute("frameborder", "1");
                file.setAttribute("height", "320");
              });

              resetUploader();
            })
            .catch(err => {});
        } else if (file.type.indexOf("video") != -1) {
          // .insertEmbed(cursorLocation, "image", url);
          // Editor.clipboard.dangerouslyPasteHTML(5, `&nbsp;<video type="video/mp4" width="320" height="240" controls class="ql-video"src="https://crm-toolstrades.s3.eu-central-1.amazonaws.com/user_files/1597400214blob"></video>`);
          // '&nbsp;<video width="320" height="240" controls>\n' +
          // '  <source src="https://www.w3schools.com/tags/movie.mp4" type="video/mp4">\n' +
          // '  Your browser does not support the video tag.\n' +
          // '</video>'
        }
      } else {
        this.requestUploadStatusBusy = false;

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: `Error uploading file: Max size 4mb `,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
      }
    },
    setTimeToSend(sDate, sTime) {
      let timeAndDate = moment(sDate).add(moment.duration(sTime));
      return timeAndDate;
    },
    async addNewTask() {
      try {
        let errors = await this.validateNewTask();
        if (Object.keys(errors).length > 0) {
          throw errors;
        }
        // this.errors = errors
        // if (errors.length > 0){
        //   throw errors
        // }
        // this.saveTaskAndContinue();
        this.$store.commit("clients/setLoading", true);
        const addNewClientRequest = apiClientCreator(`tasks/new`);

        let ids = [];

        //let firstLevel = [];
        // this.insertEstTimeTagIntoEditor();

        this.newTask.taskUser.forEach(t => {
          ids.push(t.id);
        });

        // firstLevel.forEach(function(u) {
        //   ids.push(u.id);
        // });

        // firstLevel.forEach(function(u) {
        // ids.push(u.id);
        // });
        let idsGroup = [];
        this.newTask.taskGroup.forEach(function(item) {
          idsGroup.push(item.id);
        });

        // let categoryForinsertToContent = this.newTask.cat_arr[0].code.cat_type;
        await this.subTaskCatIds(this.subTasks);

        let cat_ids = [];
        this.newTask.cat_arr.forEach(cat => {
          if (cat["code"] != undefined) {
            cat_ids.push(cat["code"].id);
          }
        });
        if (this.newTask.taskType.id !== 7) {
          cat_ids.push(this.estTimeTag.id);
        }
        // cat_ids.push(this.estTimeTag.code.id);
        this.activeTimer.running = false; //  change running of timer to false when ends creating of new task
        // this.activeTimer.timeStopped = new Date(); //  adding time stop when ends creating of new task
        const newTask = {
          adding_task_spent_time: this.newTask.addingTaskSpentTime,
          assign_to: ids,
          assign_to_group: idsGroup,
          content: this.newTask.taskText,
          cat_arr: cat_ids,
          connected_task: this.newTask.selectedConnTaskId,
          end_time: this.ifTimeFrameDisabled
            ? moment(this.newTask.taskDateTime.startDate).add(
                moment.duration(this.newTask.taskDateTime.startTime)
              )
            : moment(this.newTask.taskDateTime.endDate).add(
                moment.duration(this.newTask.taskDateTime.endTime)
              ),
          // end_time: moment(this.newTask.taskDateTime.endDate).add(
          //   moment.duration(this.newTask.taskDateTime.endTime)
          // ),
          position: this.newTask.position,
          priority_id: this.newTask.taskPriority.id,
          subTasks: this.subTasks,
          start_time: moment(this.newTask.taskDateTime.startDate).add(
            moment.duration(this.newTask.taskDateTime.startTime)
          ),
          type_id: this.newTask.taskType.id,
          project_id: this.newTask.project_id,
          sub_type_id: this.newTask.taskSubType.id,
          time_quantity: this.ifTimeFrameDisabled
            ? 0
            : this.newTask.timeQuantity,
          // time_quantity: this.newTask.timeQuantity,
          task_read_only: this.taskReadOnly,
          timer: this.activeTimer,
          email: this.email,
          isPrivate: this.privateTask,
          repeat_task: this.repeatOptionsObj.option,
          task_location: this.newTask.location
        };
        let task_id;
        // console.log("5623", newTask); // kobi new task create
        await addNewClientRequest.post("", newTask).then(res => {
          if (this.newTask.taskType.id === 7) {
          }
          // if(this.newTask.taskType.id === 7){
          // const sendEmailReply = apiClientCreator(`client/email/send/${client.id}`);
          // sendEmailReply
          //         .post("", {
          //           client: client,
          //           presetId: this.dictionaries.activity.email_presets[6].id,
          //           tag: this.dictionaries.activity.email_presets[6].preset,
          //           email: client.emails[0].contact_value,
          //           clientFullName: client.full_name,
          //         })
          //         .then(() => {});
          // }
          task_id = res.data;
        });
        this.newTask.taskDateTime = null;
        this.isShowCalendar = false;

        this.cancelAddTask();

        // this.fetchTasks();
        this.$emit("fetchTasks");
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "New Task Added successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        if (this.newTask.taskType.id === 2) {
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg: "New Meeting Has Been Scheduled",
            type: "DONE",
            op: { type: "SYSTEM" }
          });

          const socketMeetingData = {
            assign_to: ids,
            assigned_by: this.auth.user.id,
            task_type: this.newTask.taskType.id,
            message: "New Task Receive",
            type: "TASK",
            options: {
              msg_type: "NEWMEETING",
              date: moment(newTask.start_time).toDate(),
              task_id: task_id
            }
          };
          this.msgSocket.emit("user_meeting_assignment", socketMeetingData);
        }

        if (this.newTask.taskType.id === 1) {
          const socketData = {
            assign_to: ids,
            assigned_by: this.auth.user.id,
            task_type: this.newTask.taskType.id,
            message: "New Task Receive",
            type: "TASK",
            options: {
              msg_type: "NEW",
              date: moment().toDate(),
              task_id: task_id
            }
          };
          this.msgSocket.emit("user_task_assignment", socketData);
        }
        this.$store.commit("clients/setLoading", false);
        // await this.setTaskTransfer();
        this.$emit("setTaskTransfer");

        await this.$store.dispatch("tasks/fetchActiveTasks", {});

        localStorage.removeItem("taskText"); // it will help in new Main task window

        //   this.selectedTab = "waiting";
        //    this.clearLocalStorage();

        this.$emit("closeMainTaskWindow");
        // this.$emit("changeToWaitingTabAfterCreatingATask");
      } catch (e) {
        let errorArray = Object.entries(e).map(e => e[1]);
        let errorMsg = ``;
        errorArray.forEach(error => {
          errorMsg += error.msg;
          errorMsg += " || ";
        });
        // document.getElementsByClassName("sys-chat-z-index")[0].style.zIndex = 2;
        // document.getElementsByClassName("user-select-container")[0].classList.add("alert-danger");

        if (e.hasOwnProperty("user_err")) {
          document.getElementsByClassName("search-user-input")[0].style.border =
            "thin solid red";
          document
            .getElementsByClassName("user-select-container")[0]
            .addEventListener("click", () => {
              document.getElementsByClassName(
                "search-user-input"
              )[0].style.border = "none";
            });
        }
        if (e.hasOwnProperty("category_err")) {
          document.getElementsByClassName("tagify__input")[1].style.border =
            "thin solid red";
        }
        if (e.hasOwnProperty("content_err")) {
          document.getElementById("new-task-editor").style.border =
            "thin solid red";
          document
            .getElementById("new-task-editor")
            .addEventListener("click", () => {
              document.getElementById("new-task-editor").style.border =
                "1px solid #ccc";
            });
        }
        // setTimeout(() => {
        //   document.getElementsByClassName(
        //     "sys-chat-z-index"
        //   )[0].style.zIndex = 1;
        //   this.$store.commit("main/setShowVikiMsg", {
        //     show: false,
        //     id: null,
        //     msg: "",
        //     type: "",
        //     op: {
        //       type: "",
        //       clientId: null,
        //       userId: null
        //     }
        //   });
        // }, 7000);
        this.clearLocalStorage();
        // localStorage.removeItem("crm-saved-task-text");
        // localStorage.removeItem("crm-saved-task-type");
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: `Error Adding Task: ${errorMsg} Error Status: `,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
      // this.newTask.showNewTaskTextEditor = false;
      // this.newTask.showNewTaskOptionsEditor = false;
      // this.newTask.showNewTaskUsersEditor = false;
    },
    validateNewTask() {
      let errors = {
        // user_err: {},
        // category_err:{}
      };
      if (this.newTask.taskUser.length < 1 && this.newTask.taskType.id !== 7) {
        errors.user_err = {
          err: true,
          msg: "Please select a user"
        };
      }
      if (this.newTask.cat_arr.length < 1) {
        errors.category_err = {
          err: true,
          msg: "Please select a category"
        };
      }
      if (this.newTask.taskText.length < 1) {
        errors.content_err = {
          err: true,
          msg: "Please fill the task content"
        };
      }
      return errors;
    },
    clearLocalStorage() {
      localStorage.removeItem("crm-saved-task-text");
      localStorage.removeItem("crm-saved-task-type");
      localStorage.removeItem("taskText");
      localStorage.removeItem("subTasks");
      localStorage.removeItem("mainTaskTags");
    },

    textValidation(editorContent) {
      this.badWordsArray.forEach(word => {
        if (editorContent.length > 0) {
          if (editorContent.includes(word)) {
            apiClientCreator(`tasks/bad-word`)
              .post("", {
                user_id: this.auth.user.id,
                word: word,
                task_id: this.task ? this.task.id : null
              })
              .then(res => {})
              .catch(err => {});
            let cleanText = this.badWordsArray.join("|");
            let res = editorContent.replace(
              // new RegExp("\\b(" + cleanText + ")\\b", "gi"),
              new RegExp("(" + cleanText + ")\\b", "gi"),
              " "
            );
            // this.replyTaskTextFromLocal = res;
            this.taskTextFromLocal = res;

            // subTask.subTaskContent
          }
        }
      });
      this.componentKeyEditor += 1;
      this.$nextTick(() => {
        this.$refs.editor.quill.focus("end");
      });
      this.$nextTick(() => {
        this.$refs.editor.quill.setSelection(editorContent.length, 0);
      });
    },
    // async getMyTasks() {
    //   let apiClient = apiClientCreator(`tasks/my`);
    //   const response = await apiClient.get("");
    //   this.newTask.myTasks = response.data;
    //   return (this.newTask.showAddTaskConn = true);
    //
    //   //this.$store.commit("clients/setLoading", false);
    // },
    // saveTaskAndContinue() {
    //   localStorage.setItem("crm-saved-task-text", this.newTask.taskText);
    //   localStorage.setItem(
    //     "crm-saved-task-type",
    //     JSON.stringify(this.newTask.taskType)
    //   );
    // },
    cancelAddTask() {
      this.newTask.taskText = "";
      // this.newTask.taskType = null;
      this.newTask.taskUser = [];
      this.newTask.taskGroup = [];
      // this.newTask.taskPriority = null; // FIRES ERROR WHEN ADDING SEVERAL TASKS IN ROAD WITHOUT LOADING
      this.newTask.taskDateTime = null;
      this.calendarButtonText = "Select date";
      this.newTask.timeQuantity = 24;
      this.newTask.selectedConnTaskId = null;
      this.newTask.cat_arr = [];
      this.userImgSrc = null;
      this.clearLocalStorage();
      // localStorage.removeItem("crm-saved-task-text");
      // localStorage.removeItem("crm-saved-task-type");
      // localStorage.removeItem("taskText");
    },
    changeTransferMode() {
      this.transferMode = !this.transferMode;
    },
    editWindowMode(event) {
      this.newTask.taskText = event.name;
      this.newTask.taskUser = event.user;
      this.editMode = true;
      this.addMode = false;
      this.replyMode = false;
    },
    editTask() {
      this.isEditorDisabled = false;
      this.editMode = true;
      this.ifTimeFrameDisabled = false;

      this.editorTabs.push({ id: 88, name: "Task", alias: "TASK" });
      this.selectedEditorTab = "TASK";

      // this.taskTextFromLocal = this.replyTaskTextFromLocal;
      // $("#user-select-container").removeClass("disabledUserSelect");
    },
    addToTask() {
      this.isEditorDisabled = false;
      this.editMode = true;
      this.editorTabs.push({
        id: 89,
        name: "Addition to task",
        alias: "ADD TO TASK"
      });
      this.selectedEditorTab = "ADD TO TASK";

      // this.taskTextFromLocal = this.replyTaskTextFromLocal;
      // $("#user-select-container").removeClass("disabledUserSelect");
    },
    cancelDelayTask() {
      this.saveDelayCondition = false;
      this.editorTabs = this.editorTabs.filter(tab => {
        return tab.id !== 99;
      });
    },
    delayTask() {
      this.isEditorDisabled = false;
      this.editMode = true;
      this.editorTabs.push({
        id: 99,
        name: "Calendar",
        alias: "CAL"
      });
      this.selectedEditorTab = "CAL";

      // this.taskTextFromLocal = this.replyTaskTextFromLocal;
      // $("#user-select-container").removeClass("disabledUserSelect");
    },
    cancelEditTask() {
      this.isEditorDisabled = true;
      this.editMode = false;
      this.ifTimeFrameDisabled = true;

      this.editorTabs = this.editorTabs.filter(tab => {
        return tab.id !== 88;
      });
      this.selectedEditorTab = "REPLY";
      this.updatedTask.taskUser = this.task.task_assignment;
      this.mainKey += 1;
    },
    saveEditedTask() {
      this.updateTask();
      // this.$refs.replyWindow.updateReply();

      // this.$emit("closeMainTaskWindow");
    },
    getNewCategories(newCatArr, oldCatArr) {
      let newCat_ids = [];
      newCatArr.forEach(cat => {
        if (cat["code"] != undefined) {
          newCat_ids.push(cat["code"].id);
        }
      });
      let oldCat_ids = [];
      oldCatArr.forEach(cat => {
        oldCat_ids.push(cat.cat_id);
      });
      // let userOut = www.txt.differenceBy(oldUsers, newUsers, "id");
      // let catIn = www.txt.differenceBy(newCatArr, oldCatArr, "id");
      let catIn = _.differenceWith(newCat_ids, oldCat_ids, _.isEqual);
      return catIn;
    },
    async saveAddons() {
      try {
        this.$store.commit("clients/setLoading", true);
        const saveAddonsTaskRequest = apiClientCreator(
          `tasks/update/content/${this.task.id}`
        );
        let newCat_ids = [];
        this.newTask.cat_arr.forEach(cat => {
          if (cat["code"] != undefined) {
            newCat_ids.push(cat["code"].id);
          }
        });
        const content = this.task.content + this.additionToTaskContent;
        const addon = this.additionToTaskContent;
        // const newCat = this.getNewCategories(this.newTask.cat_arr, this.task.categories)

        this.additionsToTask.push(this.additionToTaskContent);
        await saveAddonsTaskRequest.put("", {
          content: content,
          addon: addon,
          cat_arr: newCat_ids
        });
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Addition saved successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        this.editorTabs = this.editorTabs.filter(tab => {
          return tab.alias !== "ADD TO TASK";
        });
        this.selectedEditorTab = "REPLY";
        this.additionToTaskContent = `<span style="color: red">${moment().format(
          "DD/MM/YYYY HH:mm"
        )}</span><span style="color: red">Important addition:</span>&nbsp`;
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task reply " + " " + " Error Status: " + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },
    async saveDelay() {
      try {
        this.$store.commit("clients/setLoading", true);
        const saveDelayTaskRequest = apiClientCreator(
          `tasks/delay/${this.task.id}`
        );
        // let newCat_ids = [];
        // this.newTask.cat_arr.forEach(cat => {
        //   if (cat["code"] != undefined) {
        //     newCat_ids.push(cat["code"].id);
        //   }
        // });
        const content = this.replyTaskTextFromLocal;
        // const addon = this.additionToTaskContent;
        // const newCat = this.getNewCategories(this.newTask.cat_arr, this.task.categories)

        // this.additionsToTask.push(this.additionToTaskContent);
        await saveDelayTaskRequest.put("", {
          content: content,
          delay_date: moment(this.newTask.taskDateTime.startDate).add(
            moment.duration(this.newTask.taskDateTime.startTime)
          )
          // delay_date: this.newTask.taskDateTime
        });
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task delayed successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        this.$emit("closeMainTaskWindow");

        // this.editorTabs = this.editorTabs.filter(tab => {
        //   return tab.alias !== "ADD TO TASK";
        // });
        // this.selectedEditorTab = "REPLY";
        // this.additionToTaskContent = `<span style="color: red">${moment().format(
        //   "DD/MM/YYYY HH:mm"
        // )}</span><span style="color: red">Important addition:</span>&nbsp`;
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task delay " + " " + " Error Status: " + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },
    replyTaskFromMain() {
      this.$refs.replyWindow.replyTask();
      this.$emit("closeMainTaskWindow");
      // if (this.isEditorDisabled === false) {
      //   this.$refs.replyWindow.replyTask();
      //   this.$emit("closeMainTaskWindow");
      // } else if (this.isEditorDisabled === true) {
      //   this.isEditorDisabled = false;
      //   this.replyTaskTextFromLocal = "";
      // }
      // this.$refs.replyWindow.replyTask();
      // this.$emit("closeMainTaskWindow");
      // this.$refs.replyWindow.replyTask();
      // this.$emit("closeMainTaskWindow");
    },
    updateReplyTaskFromMain() {
      this.$refs.replyWindow.updateReply();
      // this.$emit("closeMainTaskWindow");
    },
    async renewTask() {
      try {
        this.$store.commit("clients/setLoading", true);
        //   const renewStatusClientRequest = apiClientCreator(
        //     `tasks/update/status/${this.task.id}`
        //   );
        // await renewStatusClientRequest.put("", { status_id: 3 });

        const renewTaskRequest = apiClientCreator(
          `tasks/renew/${this.task.id}`
        );

        let ids = [];
        this.newTask.taskUser.forEach(function(item) {
          ids.push(item.id);
        });

        let idsGroup = [];
        this.newTask.taskGroup.forEach(function(item) {
          idsGroup.push(item.id);
        });

        let cat_ids = [];
        this.newTask.cat_arr.forEach(cat => {
          if (cat["code"] != undefined) {
            cat_ids.push(cat["code"].id);
          }
        });

        const renewedTask = {
          cat_arr: cat_ids,
          type_id: this.newTask.taskType.id,
          assign_to: ids,
          assign_to_group: idsGroup,
          priority_id: this.newTask.taskPriority.id,
          // content: this.taskTextFromLocal,
          // content: this.newTask.taskText,
          content: this.task.content,

          start_time: moment(this.newTask.taskDateTime.startDate).add(
            moment.duration(this.newTask.taskDateTime.startTime)
          ),
          // start_time: this.newTask.taskDateTime.startDate,
          end_time: moment(this.newTask.taskDateTime.endDate).add(
            moment.duration(this.newTask.taskDateTime.endTime)
          ),
          // end_time: this.newTask.taskDateTime.endDate,
          time_quantity: this.newTask.timeQuantity,
          connected_task: this.newTask.selectedConnTaskId,
          task_read_only: this.taskReadOnly
        };

        await renewTaskRequest.put("", renewedTask);

        //this.$emit("updated");
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        // this.showEditTaskText = false;
        // this.showPencil = false;
        // this.inEditTaskOperation = false;
        // this.reply = "";
        // this.content = this.task.content;
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task renewed successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        localStorage.removeItem("taskText");
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task renew " + " " + " Error Status: " + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
      this.$emit("closeMainTaskWindow");
    },
    taskIsConfirmed() {
      this.$refs.replyWindow.iHaveSeenThatTaskIsConfirmed();
      this.$emit("closeMainTaskWindow");
    },
    replyEndTaskFromMain() {
      this.$refs.replyWindow.replyEndTask();
      this.$emit("closeMainTaskWindow");
    },
    async updateTask() {
      try {
        this.$store.commit("clients/setLoading", true);
        const UpdateTaskRequest = apiClientCreator(
          `tasks/update/${this.task.id}`
        );
        let ids = [];
        this.newTask.taskUser.forEach(function(item) {
          ids.push(item.id);
        });

        let idsGroup = [];
        this.newTask.taskGroup.forEach(function(item) {
          idsGroup.push(item.id);
        });

        let cat_ids = [];
        this.newTask.cat_arr.forEach(cat => {
          if (cat["code"] != undefined) {
            cat_ids.push(cat["code"].id);
          }
        });

        const updatedTask = {
          // cat_arr: cat_ids,
          cat_arr: _.uniq(cat_ids),
          type_id: this.updatedTask.taskType.id,
          assign_to: ids,
          assign_to_group: idsGroup,
          priority_id: this.updatedTask.taskPriority.id,
          // content: this.task.content,
          content: this.updatedTask.content,
          start_time: moment(this.newTask.taskDateTime.startDate).add(
            moment.duration(this.newTask.taskDateTime.startTime)
          ),
          // start_time: this.newTask.taskDateTime.startDate,
          end_time: moment(this.newTask.taskDateTime.endDate).add(
            moment.duration(this.newTask.taskDateTime.endTime)
          ),
          // end_time: this.newTask.taskDateTime.endDate,
          time_quantity: this.updatedTask.timeQuantity,
          connected_task: this.updatedTask.selectedConnTaskId,
          task_read_only: this.taskReadOnly,
          userIn: this.updatedTask.userIn,
          userOut: this.updatedTask.userOut,
          location: this.updatedTask.location
        };

        await UpdateTaskRequest.put("", updatedTask);

        //this.$emit("updated");
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        // this.showEditTaskText = false;
        // this.showPencil = false;
        // this.inEditTaskOperation = false;
        // this.reply = "";
        // this.content = this.task.content;
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task updated successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        localStorage.removeItem("taskText");
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task reply " + " " + " Error Status: " + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },

    async updateTaskDate(updatedDate) {
      try {
        this.$store.commit("clients/setLoading", true);
        const UpdateTaskDateRequest = apiClientCreator(
          `tasks/update/date/${this.task.id}`
        );

        const updatedTaskDate = {
          // start_time: moment(this.newTask.taskDateTime.startDate).add(
          //         moment.duration(this.newTask.taskDateTime.startTime)
          // ),
          end_time: updatedDate
        };

        await UpdateTaskDateRequest.put("", updatedTaskDate);

        this.$emit("updated");
        // this.showEditTaskText = false;
        // this.showPencil = false;
        // this.inEditTaskOperation = false;
        // this.reply = "";
        // this.content = this.task.content;
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task time updated successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        localStorage.removeItem("taskText");
        // this.$emit("closeMainTaskWindow");
        this.newTask.taskDateTime.endDate = updatedDate;
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task reply " + " " + " Error Status: " + e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },
    changeNewTaskPriority() {
      if (this.priority) {
        this.newTask.taskPriority.id = 1;
        this.newTask.taskPriority.type = "HIGH";
        this.newTask.taskPriority.title = "HIGH Priority";
      } else {
        this.newTask.taskPriority.id = 2;
        this.newTask.taskPriority.type = "LOW";
        this.newTask.taskPriority.title = "Low Priority";
      }
    },
    changeTaskPrivacy() {
      this.privateTask = !this.privateTask;
    },
    changeTaskType(newTaskType) {
      this.newTask.taskType = newTaskType;
    },

    addSubTaskTab() {
      let id = this.subTasks.length + 2;
      let suBTaskTab = {
        id: id,
        name: `ST # ${id - 1}`,
        alias: `ST-${id}`
      };

      // if (id < 7) {
      this.editorTabs.push(suBTaskTab);
      this.usersTabs.push(suBTaskTab);
      this.categoryTabs.push(suBTaskTab);
      this.timeDateTabs.push(suBTaskTab);

      // this.subTasks[`subTask_${id - 1}`] = {
      //   subTaskId: id - 1,
      //   subTaskContent: "Sub-task #" + (id - 1),
      //   subTaskUserAssignment: [],
      //   subTaskTab: "ST-" + (id - 1)
      // };

      this.subTasks.push({
        subTaskId: id,
        subTaskContent: "Sub-task #" + id - 1,
        subTaskUserAssignment: [],
        subTaskCategory: [],
        subTaskTab: "ST-" + id,
        subTaskDateTime: this.newTask.taskDateTime,
        subTaskEstTime: null,
        // subTaskDateTime: {
        //   startDate: moment().format("YYYY-MM-DD"),
        //   endDate: moment().format("YYYY-MM-DD"),
        //   startTime: moment().format("YYYY-MM-DD"),
        //   endTime: moment().format("YYYY-MM-DD")
        // },
        connectedTask: null
      });

      this.selectedEditorTab = "ST-" + id;
      this.selectedUserTab = "ST-" + id;
      this.selectedCategoryTab = "ST-" + id;
      this.selectedTimeDateTab = "ST-" + id;
      // }
      // this.showSubTaskSubMenu = false;
    },
    deleteEditorTab(tab) {
      this.editorTabs = this.editorTabs.filter(item => {
        return item.id !== tab.id;
      }); // use filter to delete tab from tab arr

      this.usersTabs = this.usersTabs.filter(item => {
        return item.id !== tab.id;
      });

      this.categoryTabs = this.categoryTabs.filter(item => {
        return item.id !== tab.id;
      });
      this.timeDateTabs = this.timeDateTabs.filter(item => {
        return item.id !== tab.id;
      }); // use filter to delete tab from tab arr

      // let tempConTask = this.subTasks.find(item=>{
      //   item.subTaskId ==tab.id
      // })
      let conTaskToDel = this.subTasks.find(task => task.subTaskId === tab.id);

      this.subTasks = this.subTasks.filter(item => {
        return item.subTaskId !== tab.id;
      });
      this.newTask.selectedConnTaskId = this.newTask.selectedConnTaskId.filter(
        item => {
          return item !== conTaskToDel.connectedTask;
        }
      );
      // this.$root.$emit("show_save_add_sub_tasks", false);

      this.selectedEditorTab = "MT";
      this.selectedCategoryTab = "MT";
      this.selectedTimeDateTab = "MT";
    },
    getCategoriesForMention() {
      this.categories.map(category => {
        // getting data from API to insert into the quiil-mention
        let categoryForView = {};
        categoryForView.value = category.cat_type;
        categoryForView.code = category;
        this.categoriesForMention.push(categoryForView);
        let categoryHash = {};
        categoryHash.id = category.id;
        categoryHash.value = category.cat_type;
        this.hashValues.push(categoryHash);
        // this.setInitialCategories(this.categories)
      });
      // this.categoriesForMention.forEach( (category, index) =>{
      //   let temp = {
      //     id: index,
      //
      //   }
      // })
      // this.hashValues = this.categoriesForMention
    },
    //  getCategoriesForMention() {
    //
    //   apiClientCreator(`tasks/category/`)
    //     .get("")
    //     .then(res => {
    //       this.categoriesForTopFiveFilter = res.data
    //       res.data.map(category => {
    //         // getting data from API to insert into the quiil-mention
    //         let categoryForView = {};
    //         categoryForView.value = category.cat_type;
    //         categoryForView.code = category;
    //         this.categoriesForMention.push(categoryForView);
    //         let categoryHash = {};
    //         categoryHash.id = category.id;
    //         categoryHash.value = category.cat_type;
    //         this.hashValues.push(categoryHash);
    //         // this.setInitialCategories(this.categories)
    //       });
    //       // this.categoriesForMention.forEach( (category, index) =>{
    //       //   let temp = {
    //       //     id: index,
    //       //
    //       //   }
    //       // })
    //       // this.hashValues = this.categoriesForMention
    //     })
    //     .catch(err => {});
    // },
    getUserssForMention() {
      this.salesPersonList.forEach(user => {
        let userMention = {};
        userMention.id = user.id;
        userMention.value = user.full_name;

        if (this.allowedUsersByRole(user.role)) this.atValues.push(userMention);
      });
    },
    allowedUsersByRole(role) {
      if (
        this.auth.user.role === 1 ||
        this.auth.user.role === 2 ||
        this.auth.user.role === 3 ||
        this.auth.user.role === 4 ||
        this.auth.user.role === 12
      ) {
        return true;
      } else if (this.auth.user.role === 4 || this.auth.user.role === 3) {
        if (role < 8) {
          return true;
        }
      } else if (this.auth.user.role > 4 && this.auth.user.role < 7) {
        if (
          this.auth.user.role === role + 1 ||
          this.auth.user.role === role ||
          (this.auth.user.role === role - 1 && role !== 12)
        ) {
          return true;
        }
      } else if (this.auth.user.role >= 7) {
        // if (this.auth.user.role === role + 1 || this.auth.user.role === role) {
        if (role > 3 || this.auth.user.role === role) {
          return true;
        }
      }
    },
    allowTimeFrameByUserRole() {
      if (
        this.mode == "reply" &&
        this.auth.user.id !== this.getOriginalCreator()
      ) {
        this.ifTimeFrameDisabled = true;
      }
      // else if(this.mode == "reply" &&
      //         this.auth.user.id === this.getOriginalCreator()){
      //   this.ifTimeFrameDisabled = false;
      // }
      else if (this.mode == "add") {
        if (this.auth.user.role === 1 || this.auth.user.role === 2) {
          this.ifTimeFrameDisabled = false;
        } else {
          this.ifTimeFrameDisabled = true;
        }
      }
    },
    allowTimeFrameByTaskUserRole() {
      if (
        this.mode == "reply" &&
        this.auth.user.id != this.getOriginalCreator()
      ) {
        this.ifTimeFrameDisabled = true;
      } else if (this.mode == "add") {
        if (this.auth.user.role === 1 || this.auth.user.role === 2) {
          this.ifTimeFrameDisabled = false;
        } else {
          this.ifTimeFrameDisabled = true;
        }
      }
    },

    changeActiveTaskTab(value) {
      // this.newTask.taskType = {
      //   id: 2,
      //   title: "Meeting",
      //   type: "MEETING"
      // };
      if (
        this.mode == "reply" &&
        this.getOriginalCreator() === this.auth.user.id
      ) {
        this.delayTask();
        this.saveDelayCondition = true;
      }
      this.selectedEditorTab = value.tab;
      // this.estTime = value.estTime;
      this.estTime = this.oldEstTime;
    },
    async addNewTagFromEditor(tempTag) {
      let ifCatExists = this.categories.find(category => {
        return category.cat_type == tempTag;
      });

      if (ifCatExists) {
        let newItem = {
          code: ifCatExists,
          value: tempTag
        };
        this.categoriesForMention.push(newItem);
      } else {
        await apiClientCreator(`tasks/category/`)
          .post("", { cat_type: tempTag })
          .then(res => {
            let newItem = {
              code: res.data,
              value: tempTag,

            };
            this.categoriesForMention.push(newItem);
          })
          .catch(err => {});
      }
    },

    extend25() {
      let updatedDate = moment(this.newTask.taskDateTime.endDate)
        .add(1, "day")
        .format("YYYY-MM-DD");
      this.updateTaskDate(updatedDate);
    },
    async updateTaskStatus(status, subStatus) {
      try {
        // this.statusUpdated = true
        this.$store.commit("clients/setLoading", true);
        const updateStatusRequest = apiClientCreator(
          `tasks/update/status/${this.task.id}`
        );
        await updateStatusRequest.put("", {
          status_id: status,
          sub_status_id: subStatus
        });
        // this.$emit("updated");
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Task status updated successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        this.forceStopTimer = true;
        this.$emit("closeMainTaskWindow");
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Error task status update " +
            " " +
            " Error Status: " +
            e.response.status,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        this.$emit("closeMainTaskWindow");
      }
    },
    // openSubTaskSubMenu() {
    //   this.showSubTaskSubMenu = !this.showSubTaskSubMenu;
    // },
    async setAddNewTaskTimeDuration(time) {
      this.newTask.addingTaskSpentTime = time;
    },

    // closeSubTaskSubMenu() {
    //   this.showSubTaskSubMenu = false;
    // },
    changeNewTaskPosition(position) {
      this.newTask.position = position;
    },
    subTaskCatIds(subTasks) {
      subTasks.forEach(subTask => {
        let cat_ids = [];

        subTask.subTaskCategory.forEach(cat => {
          if (cat["code"] != undefined) {
            cat_ids.push(cat["code"].id);
          }
        });
        subTask.subTaskCategory = cat_ids;
      });
    },
    getOriginalCreator() {
      let originalCreator = null;
      this.task.task_assignment.forEach(assign => {
        if (assign.assigned_to.id === assign.assigned_by.id) {
          originalCreator = assign.assigned_by.id;
        }
      });
      return originalCreator;
    },
    isTaskExecutor() {
      let isTaskExecutor = false;
      this.task.task_assignment.forEach(assign => {
        if (assign.assigned_to.id === this.auth.user.id) {
          isTaskExecutor = true;
        }
      });

      return isTaskExecutor;
    },
    ifTaskReadOnly() {
      return this.task.task_read_only.some(
        user => user.user_id === this.auth.user.id
      );
    },
    ifTaskTransferedByMe() {
      return this.task.transfer.some(
        user => user.transfer_by.id === this.auth.user.id
      );
    },
    checkUserPermissionForStartTimer() {
      if (
        this.auth.user.id === this.getOriginalCreator() ||
        this.ifTaskTransferedByMe()
      ) {
        return false;
      } else {
        if (this.ifTaskReadOnly()) {
          return false;
        } else {
          if (this.auth.user.role === 1 || this.auth.user.role === 2) {
            if (this.isTaskExecutor()) {
              return true;
            }
            return false;
          }
          return true;
        }
      }
    },
    getCategoryTabs() {
      if (this.mode === "reply") {
        this.categoryTabs = [
          {
            id: 0,
            name: "Select main task category",
            alias: "MT"
          }
        ];
      } else if (this.mode === "reply-email") {
        this.categoryTabs = [
          {
            id: 0,
            name: "Subject",
            alias: "MT"
          }
        ];
      } else if (this.mode === "add") {
        if (this.newTask.taskType.type == "EMAIL") {
          this.categoryTabs = [
            {
              id: 0,
              name: "Subject",
              alias: "MT"
            }
          ];
        } else {
          this.categoryTabs = [
            {
              id: 0,
              name: "Select main task category",
              alias: "MT"
            }
          ];
        }
      }
    },
    getEditorTabs() {
      if (this.mode === "reply") {
        if (this.task.task_type.type == "MEETING") {
          this.editorTabs = [
            {
              id: 0,
              name: "Calendar",
              alias: "CAL"
            },
            {
              id: 13,
              name: "Reply",
              alias: "REPLY"
            },
            {
              id: 14,
              name: "Log",
              alias: "LOG"
            }
          ];
        } else if (this.auth.user.id === this.getOriginalCreator()) {
          this.editorTabs = [
            // {
            //   id: 0,
            //   name: "Calendar",
            //   alias: "CAL"
            // },
            // {
            //   id: 1,
            //   name: "Task",
            //   alias: "TASK"
            // },
            {
              id: 13,
              name: "Reply",
              // name: this.transferUsers.length > 0 ? "Transfer" : "Reply",
              alias: "REPLY"
            },
            {
              id: 14,
              name: "Log",
              alias: "LOG"
            }
          ];
        } else if (this.auth.user.id !== this.getOriginalCreator()) {
          this.editorTabs = [
            {
              id: 13,
              name: "Reply",
              // name: this.transferUsers.length > 0 ? "Transfer" : "Reply",
              alias: "REPLY"
            },
            {
              id: 14,
              name: "Log",
              alias: "LOG"
            }
          ];
        }
      } else if (this.mode === "reply-email") {
        this.editorTabs = [
          {
            id: 1,
            name: "Email",
            alias: "TASK"
          },
          {
            id: 13,
            name: "Reply",
            alias: "REPLY"
          }
        ];
      } else if (this.mode === "add") {
        if (this.newTask.taskType.type == "EMAIL") {
          this.editorTabs = [
            {
              id: 0,
              name: "Calendar",
              alias: "CAL"
            },
            {
              id: 1,
              name: "Email",
              alias: "MT"
            }
          ];
        } else {
          this.editorTabs = [
            {
              id: 0,
              name: "Calendar",
              alias: "CAL"
            },
            {
              id: 1,
              // name: "Main task",
              name: this.newTask.taskType.id === 1 ? "Main task" : "Meeting",
              alias: "MT"
            }
          ];
        }
      }
    },
    setSubtasksFromLocal(subTasks) {
      subTasks.forEach(subTask => {
        let suBTaskTab = {
          id: subTask.subTaskId,
          name: `ST # ${subTask.subTaskId}`,
          alias: `ST-${subTask.subTaskId}`
        };
        this.editorTabs.push(suBTaskTab);
        this.usersTabs.push(suBTaskTab);
        this.categoryTabs.push(suBTaskTab);
        this.timeDateTabs.push(suBTaskTab);
      });
    },

    getDataFromLocal() {
      let tempText = localStorage.getItem("taskText");
      if (tempText) {
        this.taskTextFromLocal = tempText;
        this.newTask.taskText = tempText;
      }

      let tempCatArr = JSON.parse(localStorage.getItem("mainTaskTags"));
      if (tempCatArr) {
        this.newTask.cat_arr = tempCatArr;
        this.componentKeyTags += 1;
      }
      let subTasks = JSON.parse(localStorage.getItem("subTasks"));
      if (subTasks) {
        this.subTasks = subTasks;
        this.setSubtasksFromLocal(this.subTasks);
        // this.componentKeyTags += 1;
      }
    },
    saveDraft() {
      try {
        let errors = this.validateNewTask();
        if (Object.keys(errors).length > 0) {
          throw errors;
        }
        // this.errors = errors
        // if (errors.length > 0){
        //   throw errors
        // }
        // this.saveTaskAndContinue();
        this.$store.commit("clients/setLoading", true);
        const addNewClientRequest = apiClientCreator(`tasks/new`);

        let ids = [];

        //let firstLevel = [];

        this.newTask.taskUser.forEach(t => {
          ids.push(t.id);
        });

        // firstLevel.forEach(function(u) {
        //   ids.push(u.id);
        // });

        // firstLevel.forEach(function(u) {
        // ids.push(u.id);
        // });
        let idsGroup = [];
        this.newTask.taskGroup.forEach(function(item) {
          idsGroup.push(item.id);
        });

        // let categoryForinsertToContent = this.newTask.cat_arr[0].code.cat_type;
        this.subTaskCatIds(this.subTasks);
        let cat_ids = [];
        this.newTask.cat_arr.forEach(cat => {
          if (cat["code"] != undefined) {
            cat_ids.push(cat["code"].id);
          }
        });
        this.activeTimer.running = false; //  change running of timer to false when ends creating of new task
        // this.activeTimer.timeStopped = new Date(); //  adding time stop when ends creating of new task

        const newTask = {
          adding_task_spent_time: this.newTask.addingTaskSpentTime,
          assign_to: ids,
          assign_to_group: idsGroup,
          content: this.newTask.taskText,
          cat_arr: cat_ids,
          connected_task: this.newTask.selectedConnTaskId,
          end_time: moment(this.newTask.taskDateTime.endDate).add(
            moment.duration(this.newTask.taskDateTime.endTime)
          ),
          position: this.newTask.position,
          priority_id: this.newTask.taskPriority.id,
          subTasks: this.subTasks,
          start_time: moment(this.newTask.taskDateTime.startDate).add(
            moment.duration(this.newTask.taskDateTime.startTime)
          ),
          type_id: this.newTask.taskType.id,
          time_quantity: this.newTask.timeQuantity,
          task_read_only: this.taskReadOnly,
          timer: this.activeTimer,
          email: this.email,
          draft: true
        };
        addNewClientRequest.post("", newTask).then(res => {
          // if(this.newTask.taskType.id === 7){
          // const sendEmailReply = apiClientCreator(`client/email/send/${client.id}`);
          // sendEmailReply
          //         .post("", {
          //           client: client,
          //           presetId: this.dictionaries.activity.email_presets[6].id,
          //           tag: this.dictionaries.activity.email_presets[6].preset,
          //           email: client.emails[0].contact_value,
          //           clientFullName: client.full_name,
          //         })
          //         .then(() => {});
          // }
        });
        this.newTask.taskDateTime = null;
        this.isShowCalendar = false;

        this.cancelAddTask();

        // this.fetchTasks();
        this.$emit("fetchTasks");
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "E-Mail Draft saved successfully",
          type: "DONE",
          op: { type: "SYSTEM" }
        });

        this.$store.commit("clients/setLoading", false);
        // await this.setTaskTransfer();
        this.$emit("setTaskTransfer");

        this.$store.dispatch("tasks/fetchActiveTasks", {});

        localStorage.removeItem("taskText"); // it will help in new Main task window

        //   this.selectedTab = "waiting";
        //    this.clearLocalStorage();

        this.$emit("closeMainTaskWindow");
        this.$emit("changeToWaitingTabAfterCreatingATask");
      } catch (e) {
        let errorArray = Object.entries(e).map(e => e[1]);
        let errorMsg = ``;
        errorArray.forEach(error => {
          errorMsg += error.msg;
          errorMsg += " || ";
        });
        document.getElementsByClassName("sys-chat-z-index")[0].style.zIndex = 2;
        // document.getElementsByClassName("user-select-container")[0].classList.add("alert-danger");

        if (e.hasOwnProperty("user_err")) {
          document.getElementsByClassName("search-user-input")[0].style.border =
            "thin solid red";
          document
            .getElementsByClassName("user-select-container")[0]
            .addEventListener("click", () => {
              document.getElementsByClassName(
                "search-user-input"
              )[0].style.border = "none";
            });
        }

        if (e.hasOwnProperty("category_err")) {
          // document
          //   .getElementsByClassName("category-label")[0]
          //   .classList.add("alert-danger");
          document.getElementsByClassName("tagify__input")[1].style.border =
            "thin solid red";
        }

        setTimeout(() => {
          document.getElementsByClassName(
            "sys-chat-z-index"
          )[0].style.zIndex = 1;
          this.$store.commit("main/setShowVikiMsg", {
            show: false,
            id: null,
            msg: "",
            type: "",
            op: {
              type: "",
              clientId: null,
              userId: null
            }
          });
        }, 7000);
        this.clearLocalStorage();
        // localStorage.removeItem("crm-saved-task-text");
        // localStorage.removeItem("crm-saved-task-type");
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: `Error Adding Task: ${errorMsg} Error Status: `,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
      }
    },
    setSelectedEditorTab() {
      // this.selectedEditorTab = this.mode == "add" ? "MT" : "TASK"
      if (this.mode == "add") {
        this.selectedEditorTab = "MT";
      } else if (this.mode == "reply") {
        if (this.task.log.length > 0) {
          // this.selectedEditorTab = "TASK";
          this.selectedEditorTab = "REPLY";
        } else {
          // this.selectedEditorTab = "TASK";

          this.selectedEditorTab = "REPLY";
        }
      } else if (this.mode == "reply-email") {
        this.selectedEditorTab = "TASK";
      }
    },
    imgTaskPreview() {
      $(".task-preview img").css({ height: "200px", cursor: "pointer" });
      $(".task-preview img").on("click", () => {
        let modal = document.getElementById("imgModal");
        let modalImg = document.getElementById("img01");
        modal.style.display = "block";
        modalImg.src = event.target.getAttribute("src");
        let span = document.getElementsByClassName("close-img-modal");
        for (let item of span) {
          item.onclick = function() {
            modal.style.display = "none";
          };
        }
      });
    },
    clearTasksRootEvents() {
      this.$root.$off("task_opened_start_working");
      this.$root.$off("changeTaskTypeToEmail");
      this.$root.$off("change_tab_to_waiting");
      this.$root.$off("date_changed_from_calendar");
      this.$root.$off("emitAddNewSubTasks");
      this.$root.$off("active_date_changed");
      this.$root.$off("emitTransferAss");
      this.$root.$off("give_me_the_button");
      this.$root.$off("revertTaskTypeFromEmailToTask");
      this.$root.$off("show_reply_button");
      this.$root.$off("show_save_add_sub_tasks");
      this.$root.$off("task_check_timer_stop");
      this.$root.$off("task_opened_start_working");
      this.$root.$off("task_replied");
      this.$root.$off("task_transfer");
      this.$root.$off("time-clicked");
      this.$root.$off("time_changed_from_calendar");
      this.$root.$off("updateLiveStats");
      this.$root.$off("user_to_reply_is_selected");
      this.$root.$off("user_to_reply_is_selected");
    },
    checkIfTaskDelayed() {
      const subStat = this.task.taskSubStatus.find(
        user => user.user_id === 28
      );

      this.taskDelayed = (subStat && subStat.sub_status_id === 48);
    },
    async getNewTaskId() {
      let apiClient = apiClientCreator(`tasks/get_new__task_id`);
      await apiClient.get("").then(res => {
        this.newTaskId = res.data;
      });
    },
    removeActiveClass() {
      $("#task-preview").removeClass("is-active");
    },
    removeActiveClassReply() {
      $("#replies-preview").removeClass("is-active-reply");
    }
  },
  mounted() {
    this.centerImagesCss();
    this.getEditorTabs();
    this.allowTimeFrameByUserRole();
    this.getCategoryTabs();
    this.setSelectedEditorTab();
    this.getNewTaskId();
    if (this.task) {
      this.checkIfTaskDelayed();

      this.getReplyOpponent();
      this.getRepliesForAuthUser();
      this.getUserTaskSubStatus();
      if (this.task.sub_tasks.length > 0 || !!this.task.main_task_id) {
        this.addExistingSubTaskTab();
      }

      this.newTask.cat_arr = this.formatCategories(this.task.categories);
    }

    // this.taskSubTabs = this.getTabsForSubTask();
    let tor = () => {
      this.turnOnRec = !this.turnOnRec;
    };
    let x = $(".ql-video");
    if (x[0]) {
      x[0].onclick = event => {
        $(".ql-tooltip").css("display", "none");
        $(".ql-tooltip").on("click", tor());
        // document.getElementsByClassName('ql-tooltip').addEventListener('click', ()=>{
        //   this.turnOnRec = !this.turnOnRec
        //       }).bind(this);

        //   setTimeout(()=>{
        //
        // }, 100)
      };
    }

    this.imgTaskPreview();

    this.$root.$on("changeTaskTypeToEmail", () => {
      this.newTask.taskType.id = 7;
      this.newTask.taskType.title = "Email";
      this.newTask.taskType.type = "EMAIL";
    });
    // this.$root.$on("cancelTaskFromViki", () => {
    //   this.cancelTask();
    // });

    this.$root.$on("emitAddNewSubTasks", data => {
      // TODO: complete the functions
      this.addNewSubTasks();
    });

    // this.getDataFromLocal(); // TODO: need to return it after adding logic specific
    this.getCategoriesForMention();
    this.getTopFive();

    // this.checkIfTaskIsReadOnly();

    // let tempText = localStorage.getItem("taskText");
    // if (tempText) {
    //   this.taskTextFromLocal = tempText;
    //   this.newTask.taskText = tempText;
    // }
    if (this.mode === "reply") {
      setInterval(() => {
        this.copyTimer = this.activeTimer.time;
      }, 1000);
    }
    this.tabForReply = this.selectedTaskTab;
    this.taskTypesForShow = this.taskDictionaries.general.task_types;

    this.$root.$on("revertTaskTypeFromEmailToTask", () => {
      this.newTask.taskType.id = 1;
      this.newTask.taskType.title = "Task";
      this.newTask.taskType.type = "Task";
    });
    this.$root.$on("date_changed_from_calendar", data => {
      let tempDate = moment(data.date).format("YYYY-MM-DD");
      if (this.newTask.taskDateTime !== null) {
        this.newTask.taskDateTime.startDate = tempDate;
        this.newTask.taskDateTime.endDate = tempDate;
      }
    });
    this.$root.$on("time_changed_from_calendar", time => {
      if (this.newTask.taskDateTime !== null) {
        this.newTask.taskDateTime.startTime = moment(time.startTime).format(
          "HH:mm"
        );
        this.newTask.taskDateTime.endTime = moment(time.endTime).format(
          "HH:mm"
        );
      }
      if (this.mode == "add") {
        this.selectedEditorTab = "MT";
      } else if (this.mode == "reply") {
        this.selectedEditorTab = "REPLY";
      }

      // this.$refs['search'].focus();
      // $("#editor").focus()
      // this.Quill.focus()

      // this.Vue2Editor.focus()
      // Quill.focus()
    });
    this.$root.$on("time-clicked", () => {
      //When selecting from calendar, it is meeting.

      if (
        this.repeatOptionsObj.option !== 8 &&
        this.repeatOptionsObj.option !== 9 &&
        this.newTask.taskType.id !== 10
      ) {
        this.newTask.taskType.id = 2;
        this.newTask.taskType.title = "Meeting";
        this.newTask.taskType.type = "MEETING";
        this.newTask.taskSubType.id = 2;
        this.newTask.taskSubType.title = "Meeting";
        // this.repeatOptionsObj.option = null
        setTimeout(() => {
          this.taskTextFromLocal += `<span class="mention">The meeting will take place on ${moment(
            this.newTask.taskDateTime.startDate
          ).format("DD-MM-YYYY")} at ${
            this.newTask.taskDateTime.startTime
          }</span>`;
        }, 1000);
      }
    });

    this.$root.$on("changeTaskTypeToEmail", () => {
      this.newTask.taskType.id = 7;
      this.newTask.taskType.title = "Email";
      this.newTask.taskType.type = "EMAIL";
    });
    if (this.task) {
      this.checkIfTaskInCheckProgress();
    }
    this.getUserssForMention();
    this.getTopThreeUsersFromLast100(this.topThreeUsersFromLast100);
    this.getTopFiveTagsFromLast100(this.topFiveTagsFromLast100);
    $(document).ready(function() {
      $("#task-preview").click(function() {
        this.classList.toggle("is-active");
      });
      $("#replies-preview").click(function() {
        this.classList.toggle("is-active-reply");
      });
    });
    // this.clearTasksRootEvents()
  },
  watch: {
    // "this.newTask.taskType":function(){
    //   this.$root.$emit("globalTaskType", this.newTask.taskType);
    //  /// alert()
    // },
    "newTask.taskType.id"(){
      if(this.newTask.taskType.id === 11) this.newTask.taskSubType.id = 12;
    },

    outline() {
      this.taskIsOutline();
    },
    priority() {
      this.changeNewTaskPriority();
    },
    "newTask.taskUser"() {
      if (this.newTask.taskUser.length > 0) {
        if (this.auth.user.role < 5) {
          this.ifTimeFrameDisabled = false;
        } else {
          if (this.newTask.taskUser[0].role >= this.auth.user.role) {
            this.ifTimeFrameDisabled = false;
          } else {
            this.ifTimeFrameDisabled = true;
          }
        }
      } else {
        if (this.auth.user.role < 5) {
          this.ifTimeFrameDisabled = false;
        } else {
          this.ifTimeFrameDisabled = true;
        }
      }

      // Opens accordion
      if (this.newTask.taskUser.length > 0) {
        this.newTask.taskUser.forEach(user => {
          $(`#collapse-${user.role - 1}-MT`).collapse("show");
        });
      } else {
        $(".multi-collapse").collapse("hide");
      }
    },
    "newTask.userRelatedTasks"() {
      if (this.newTask.userRelatedTasks.length > 0 && !this.task) {
        let lastUserTask = this.newTask.userRelatedTasks[
          this.newTask.userRelatedTasks.length - 1
        ];
        let newEndDate = moment(lastUserTask.end_time).add(3, "hours");
        let tempTaskDate = {};
        tempTaskDate.startDate = moment(lastUserTask.end_time).format(
          "YYYY-MM-DD"
        );
        tempTaskDate.endDate = moment(newEndDate).format("YYYY-MM-DD");
        tempTaskDate.startTime = moment(lastUserTask.end_time)
          .add(5, "minutes")
          .format("HH:mm");
        tempTaskDate.endTime = moment(lastUserTask.end_time)
          .add(3, "hours")
          .add(5, "minutes")
          .format("HH:mm");
        this.setTaskDateFromSelectPosition(tempTaskDate);
      }
    },
    "newTask.taskType.type"() {
      //changes tabs when task type = email
      this.getEditorTabs();
      this.getCategoryTabs();
      // removes "#" when task type = email
      if (this.newTask.taskType.type == "EMAIL") {
        this.editorSettings.modules.mention.showDenotationChar = false;
      } else {
        this.editorSettings.modules.mention.showDenotationChar = true;
      }
      this.componentKeyEditor += 1;
    },
    taskTextFromLocal: function() {
      // localStorage.setItem("taskText", this.taskTextFromLocal);
      this.newTask.taskText = this.taskTextFromLocal;
      let content = this.removeHtml(this.newTask.taskText).replace(/[#@ ]/g,'');
      this.newTask.taskUser.forEach(user => {
        content = content.replace(user.full_name.replace(/ /g,''),'');
      });
      this.newTask.cat_arr.forEach(cat => {
        content = content.replace(cat.code.cat_type.replace(/ /g,''),'');
      });
      this.isTextContent = this.containsAlphaNumeric(content);
    },

    replyTaskTextFromLocal: function() {
      // localStorage.setItem("taskText", this.taskTextFromLocal);
      this.newTask.taskText = this.taskTextFromLocal;
    },
    "updatedTask.taskUser"() {
      // Opens accordion
      if (this.updatedTask.taskUser.length > 0) {
        this.updatedTask.taskUser.forEach(user => {
          $(`#collapse-${user.role - 1}-MT`).collapse("show");
        });
      } else {
        $(".multi-collapse").collapse("hide");
      }
    },

    subTasks: {
      handler(subTasks) {
        if (subTasks.length > 0) {
          if (
            this.task &&
            this.task.sub_tasks.length === this.subTasks.length
          ) {
            this.$root.$emit("show_save_add_sub_tasks", false);
          } else {
            if (this.task && this.task.main_id !== null) {
              this.$root.$emit("show_save_add_sub_tasks", true);
            }
          }
        } else {
          if (
            this.task &&
            this.task.sub_tasks.length === this.subTasks.length
          ) {
            this.$root.$emit("show_save_add_sub_tasks", false);
          }
        }

        // localStorage.setItem("subTasks", JSON.stringify(subTasks));
        // this.setTotalEstTime();
      },
      deep: true
    },

    // "repeatOptionsObj.option"() {
    //   if (this.repeatOptionsObj.option === null) {
    //     this.newTask.taskType = {
    //       id: 1,
    //       title: "Task",
    //       type: "TASK"
    //     };
    //   } else if (this.repeatOptionsObj.option !== null) {
    //     if (this.repeatOptionsObj.option === 1 && this.outline) {
    //       this.newTask.taskType = {
    //         id: 1,
    //         title: "Task",
    //         type: "TASK"
    //       };
    //     } else {
    //       this.newTask.taskType = {
    //         id: 2,
    //         title: "Meeting",
    //         type: "MEETING"
    //       };
    //     }
    //   }
    // },

    selectedEditorTab: function() {
      if (
        this.selectedEditorTab !== "REPLY" &&
        this.selectedEditorTab !== "LOG" &&
        this.selectedEditorTab !== "TASK" &&
        this.selectedEditorTab !== "CAL"
      ) {
        this.selectedCategoryTab = this.selectedEditorTab;
        this.selectedTimeDateTab = this.selectedEditorTab;
      } else {
        this.selectedCategoryTab = "MT";
        this.selectedTimeDateTab = "MT";
      }

      if (this.selectedEditorTab === "REPLY") {
        this.$root.$emit("show_reply_button", true);
      } else {
        this.$root.$emit("show_reply_button", false);
      }
    }
    //   errors: function () {
    // setTimeout(this.errors = null, 10000)
    //   }
  },
  beforeMount() {
    // this.getCategoriesForMention();

    if (this.task) {
      this.getTaskUsersTalking();
    }
  },
  beforeDestroy() {
    // this.$store.dispatch("tasks/fetchActiveTasks");
    this.$store.commit("tasks/setPreOpenMainTaskWindowFromHeader", false);
  },
  destroyed() {
    if (this.newTask.taskType.id === 7) {
      this.saveDraft();
    }
  }
};
</script>

<style scoped>
#main-task-window {
  padding-left: 0px;
  padding-right: 0px;
  /* margin-right: 30px; */
  /* position: absolute; */
  position: fixed;
  /*height: 884px;*/
  height: 750px;
  z-index: 667;
  /* top: 42px; */
  top: 0px;
  left: 4px;
  width: 818px;
  /* width: 945px; */
  /* background-color: #f7f7f7; */
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07),
    0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07),
    0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07);
}
#main-task-window-reply-new {
  padding-left: 0px;
  padding-right: 0px;
  /* margin-right: 30px; */
  /* position: absolute; */
  position: absolute;
  height: 936px;
  z-index: 1;
  /* top: 42px; */
  top: 0px;
  left: 4px;
  width: 894px;
  /* width: 945px; */
  /* background-color: #f7f7f7; */
  background-color: #fff;
  /*border-radius: 5px;*/
  /*box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07),*/
  /*  0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07),*/
  /*  0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07);*/
}
#main-task-window-add-new {
  padding-left: 0px;
  padding-right: 0px;
  /* margin-right: 30px; */
  /* position: absolute; */
  position: absolute;
  height: 936px;
  z-index: 1;
  /* top: 42px; */
  top: 0px;
  left: 4px;
  width: 894px;
  /* width: 945px; */
  /* background-color: #f7f7f7; */
  background-color: #fff;
  /*border-radius: 5px;*/
  /*box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07),*/
  /*  0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07),*/
  /*  0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07);*/
}
#main-task-window-reply-email-new {
  padding-left: 0px;
  padding-right: 0px;
  /* margin-right: 30px; */
  /* position: absolute; */
  position: absolute;
  /*height: 762px;*/
  z-index: 1;
  margin-left: 20px;
  margin-top: 20px;
  /* top: 42px; */
  top: 0px;
  left: 4px;
  width: 832px;
  /* width: 945px; */
  /* background-color: #f7f7f7; */
  /*background-color: #fff;*/
  /*border-radius: 5px;*/
  /*box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07),*/
  /*  0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07),*/
  /*  0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07);*/
}
.calendar-column {
  height: 100%;
  /*padding: 25px 10px;*/
}
.main-column {
  height: 100%;
  padding: 0px;
}
.main-row {
  height: 100%;
  margin: 5px;
  width: 107%;
}
.buttons-row {
  height: 4%;
  /*margin: 5px;*/
  width: 100%;
}
.first-row-left-side {
  /*height: 82%;*/
  height: 78%;
  /*height: 69%;*/
  margin-top: 13px;
}
.first-row-left-side-reply {
  /*height: 82%;*/
  /*height: 78%;*/
  height: 69%;
  margin-top: 13px;
}
.second-row-left-side {
  height: 10%;
}

.buttons-bar,
.editor-bar,
.users-select-bar,
.editor-col,
.categories-col,
timer-col,
tab-col {
  height: 100%;
}
.buttons-bar,
.editor-col,
.categories-col {
}
.categories-bar {
  /*height: 8%;*/
  height: max-content;
}
.date-bar {
  /*height: 10%;*/
  margin-left: -25px;
}
.categories-col {
  padding: 10px;
}
.text-editor-bar {
  /*height: 90%;*/
  height: 100%;
  width: 96%;
  /*margin-top: -38px;*/
}
.editor-col {
  /*padding: 10px;*/
  margin-top: -10px;
  margin-left: 12px;
}
.users-select-bar {
  padding: 0px;
  margin-top: 3px;
  height: 97%;
  overflow-y: auto;
  overflow-x: hidden;
  /*width: 22% !important;*/
  width: 26% !important;
}
.buttons-bar {
  padding: 10px;
  margin-left: 12px;
}
.ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 103%;
  margin: 0;
  position: relative;
  /*overflow: hidden!important;*/
}
.quillWrapper {
  height: 86%;
  /*margin: 9px;*/
  border-radius: 5px;
}
div.task-preview .quillWrapper {
  height: 100%;
  /*margin: 9px;*/
  border-radius: 5px;
  overflow: hidden;
}
/*.tagify {*/
/*  width: 100% !important;*/
/*  height: 100%;*/
/*}*/
.calendar-container {
  /*height: 98% !important;*/
  /*height: 100% !important;*/
}
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 2222222222222222222222222222222; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}
span.togglebutton {
  position: absolute;
  left: 0;
  top: 0;
  background-color: black;
  padding: 3px;
  color: white;
  font-size: 50px;
  z-index: 5555555555555555555555555555555555555555;
}
.img-column {
  padding: 0px 0px 0px 10px;
  width: 90px;
}
.user-img {
  height: 70px;
  margin-left: 35px;
  margin-top: 6px;
}
.tab-container {
  width: 100% !important;
}

/*.ql-editor {*/
/*  border: 1px solid #a3a3a3;*/
/*  border-radius: 6px;*/
/*}*/

/*.ql-editor-disabled {*/
/*  border-radius: 6px;*/
/*  background-color: rgba(124, 0, 0, 0.2);*/
/*  transition-duration: 0.5s;*/
/*}*/

.ql-editor:focus {
  border: 1px solid #025fae;
}
.ql-mention-list-container {
  width: 270px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(30, 30, 30, 0.08);
  z-index: 9001;
}

.ql-mention-list {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.ql-mention-list-item {
  cursor: pointer;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  padding: 0 20px;
  vertical-align: middle;
}

.ql-mention-list-item.selected {
  background-color: #d3e1eb;
  text-decoration: none;
}

.mention {
  height: 24px;
  width: 65px;
  border-radius: 6px;
  background-color: #d3e1eb;
  padding: 3px 0;
  margin-right: 2px;
  user-select: all;
}

.mention > span {
  margin: 0 3px;
}
.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  overflow: hidden;
  height: 200px;
  position: relative;
  font-family: Montserrat;
}
.styleCardContent {
  background: white;
  /*min-height: 12rem;*/
  /*height: 88%;*/
  width: 99%;
  height: 100%;
  border-radius: 5px;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
                  background: white;
                */
}
.style-nav.style2 li {
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  /*min-width: 172px;*/
  min-width: 15%;
  height: 25px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 10px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
  overflow: visible;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
  overflow: visible;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.padding {
  padding: 1rem;
}

.task-tab {
  /*width: 96%;*/
  width: 100%;
  /*height: 115%;*/
  height: 99%;
}

.reply-content {
  /*background-color: lightgrey;*/
  height: 473%;
  border: 1px solid grey;
  border-radius: 5px;
  padding: 20px;
}
.tabs-container {
  height: 99%;
  /*width: 90%;*/
  width: 96%;
}
.tabs-container-new {
  height: 100%;
  /*width: 90%;*/
  width: 100%;
}
.tabs-timedate-container {
  /*height: 40%;*/
  margin-left: -7px;
  width: 100%;
  /*margin-left: 7px;*/
  /*margin-bottom: 10px;*/
}
.task-types-bar {
  height: 4%;
}
.sub-task-nav {
  flex-wrap: wrap;
}
.sub-task-nav > li > span {
  font-size: 20px;
  display: none;
  cursor: pointer;
  position: absolute;
  right: 13px;
  top: -1px;
  color: red;
}
.sub-task-nav > li:hover > span {
  display: inline-block;
}
#editor.tab-pane.active {
  height: 114%;
}
.tab-pane.tab-pane-editor {
  /*height: 570px;*/
  height: 100%;
}
.first-row-editor-col {
  height: 6%;
  margin-right: -18px;
  margin-left: 6px;
  margin-top: 5px;
}
.second-row-editor-col {
  height: 94%;
  /*margin-left: -3px;*/
}
.prof-img {
  position: absolute;
  left: 876px;
  top: 179px;
  width: 100px;
}
.tab-col {
  height: 50%;
  margin-top: 34px;
  margin-bottom: 0px;
  width: 18%;
  font-weight: 500;
  padding: 4px;
  overflow: hidden;
  font-size: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.timer-col {
  height: 64%;
  margin-top: 25px;
  margin-bottom: -20px;
  width: 18%;
  font-weight: 500;
  padding: 23px;
  overflow: hidden;
  font-size: 12px;
  display: flex;
  align-items: center;
}
.sub-task-sub-menu {
  padding: 0px;
  width: max-content;
  /*margin-left: 25%;*/
}
.sub-task-sub-menu button.btn.btn-primary {
  border-radius: 0px;
  font-size: 9px;
}

.add-sub-task-li {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}
.btn:focus,
.btn:active {
  outline: none !important;
  box-shadow: none;
}
.alert-info {
  margin-top: 9px;
  margin-top: 22px;
  padding: 10px;
  font-size: 12px;
}
.timer-log-container {
  /*height: 130px !important;*/
  height: 178px !important;
  background-color: white;
  margin-left: 2px;
  margin-top: 5px;
  min-width: 200px;
}
.mb0mt10 {
  margin-bottom: 0;
}
.btn-sm {
  font-size: 10px;
}
.col-md-2.total-est-time {
  position: absolute;
  right: -23px;
  font-size: 11px;
}
.col-position {
  margin-right: 40px;
}
.forRec {
  left: 58%;
  position: absolute;
  top: 690px;
}
.loader {
  position: absolute;
  top: 760px;
  left: 600px;
  z-index: 100008080;
}
.loader-upload {
  position: absolute;
  top: -359px;
  left: -24%;
}
div#new-task-editor {
  overflow: hidden;
}
.mr8 {
  margin-right: 17px;
}
button.btn.btn-info.btn-bar-btn.btn-sm.btn-block {
  width: 97%;
}
ul.style-nav.style2.sub-task-category-nav {
  margin-left: 10px;
  width: 93%;
}
.second-row-editor-col {
  /*margin-left: 10px;*/
}
.editor-nav {
  margin-left: 20px;
  width: 94%;
}
.extend24 {
  /*margin-left: -59px;*/
  margin-left: -133px;
}
.form-control,
.btn {
  border-radius: 0px !important;
}
button.btn.btn-primary.dropdown-toggle.dropdown-toggle-split.estimated-time-button {
  border-radius: 0px !important;
}
.col-date {
  margin-left: 5px;
}
/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
  /*background-color: #44a2d2;*/
  background-color: #ff0000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  /*left: 17px;*/
  /*top: 7px;*/
  /*width: 5px;*/
  /*height: 21px;*/
  left: 9px;
  top: 3px;
  width: 12px;
  height: 19px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.task-content-preview {
  position: absolute;
  left: 818px;
  top: 339px;
  border-radius: 1px 3px 3px 3px;
  border: 1px solid #cfd8dc;
  border-top-color: #fff;
  background-color: #ebe8e5;
  background-color: #fff;
  padding: 18px;
  /* -webkit-box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.15); */
  /* box-shadow: 0px 0 0px -2px rgba(0, 0, 0, 0.15); */
  overflow: auto;
  /* width: 1026px; */
  max-width: 1083px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  /*max-width: 600px;*/
  height: 595px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding-left: 0px;
  padding-right: 0px;
  border-left-style: none;
}
.f-item {
  flex: 1;
  overflow-y: auto;
  min-width: 522px;
}
.col-md-9.main-column {
  width: 74%;
  margin-right: -63px;
  /*margin-right: -35px;*/
}
td.reply-content-td div.reply-content {
  display: inline-block;
  clear: both;
  padding: 10px 10px 0px;
  border-radius: 30px;
  margin-bottom: 2px;
  font-family: Helvetica, Arial, sans-serif;
}

.him {
  background: #eee;
  float: left;
}

.me {
  float: right;
  background: #0084ff;
  color: #fff;
}

.him + .me {
  border-bottom-right-radius: 5px;
}

.me + .me {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.me:last-of-type {
  border-bottom-right-radius: 30px;
}
thead {
  font-size: 12px;
  padding: 5px;
}
td {
  font-size: 12px;
  /*padding-left: 5px;*/
  padding: 5px;
}
.replies-table {
  width: 100%;
}

.table-bordered > thead > tr > td,
.table-bordered > thead > tr > th {
  border-bottom-width: 2px;
  padding: 4px;
}
.task-preview {
  height: calc(100% - 30px);

  /*border: 1px solid #cccccc;*/
  /*padding: 10px;*/
  background-color: #f1f1f1;
  margin-right: 10px;
  /*margin-left: 20px;*/
}
.replies-preview {
  margin-right: 20px;
}
.frozen {
  opacity: 0.5;
  pointer-events: none;
}
.vue__time-picker .controls > * {
  pointer-events: inherit;
}
.main-tab {
  margin-left: -15px;
  font-size: 9px;
}
.first-col-categories-bar {
  margin-right: -33px;
}
.log-tab {
  overflow: auto;
}
.log-tab-new {
  overflow: auto;
  max-height: 345px;
}
.add-task-timer {
  /*position: absolute;*/
  color: red;
  /*top: -15px;*/
  /*right: 57px;*/
}
/*.td-content {*/
/*  cursor: pointer;*/
/*}*/
.pointer {
  cursor: pointer;
}
.task-preview img {
  height: 200px;
}
.top-five-tags-btn,
.top-three-users-btn {
  margin-left: 3px;
  border-radius: 5px !important;
  border-radius: 4px;
  font-size: 10px;
  padding: 3px;
}
.addon-preview {
  background-color: #e9eae1;
  border: 1px solid #c1c1c1;
  padding: 10px;
  overflow: auto;
  max-height: 250px;
  margin-bottom: 5px;
  height: max-content;
}
.addon-separator {
  width: 100%;
  height: 8px;
  background-color: #c1c1c1;
  border-radius: 5px;
}
.addon-preview-wrapper {
  max-height: 250px;
  margin-bottom: 5px;
}
.top-buttons-row {
  width: 91%;
}
.top-buttons-row button {
  margin-bottom: 5px;
}
/*.td-content p img{*/
/*  width: 200px;*/
/*}*/
.new-reply-left-side-first-row {
  height: 10%;
}
.new-add-left-side-first-row {
  height: 10%;
}
.new-reply-email-left-side-first-row {
  width: 809px;
  height: 10%;
}
.new-reply-left-side-second-row {
  height: 624px;
  /*min-height: 80%;*/
  overflow: auto;
}
.new-add-left-side-second-row {
  /*height: 624px;*/
  height: 787px;
  /*min-height: 80%;*/
  overflow: auto;
}
.new-reply-left-side-third-row {
  height: 10%;
}
.new-add-left-side-third-row {
  padding: 15px;
  height: 10%;
}
.new-reply-right-side-first-row {
  height: 20%;
  max-height: 190px;
  overflow: auto;
  width: 100%;
  margin-top: 10px;
  height: 190px;
}
.new-reply-right-side-second-row {
  height: 45%;
  max-height: 600px;
}
.new-add-right-side-second-row {
  height: 100%;
  /*max-height: 600px;*/
}
.new-reply-right-side-third-row {
  height: 35%;
  max-height: 200px;
  overflow: auto;
  width: 100%;
  padding: 10px;
}
.top-btns-row-new {
  margin-top: 10px;
}
#task-preview.is-active {
  height: 665px;
  position: absolute;
  bottom: -157px;
  width: 573px;
  left: 0px;
  border: 1px solid #cccccc;
}

#replies-preview.is-active-reply {
  height: 643px;
  position: absolute;
  top: 10px;
  /* bottom: -157px; */
  /*width: 572px;*/
  left: 0px;
  z-index: 1;
  border: 1px solid #cccccc;
  background-color: white;
}
#replies-preview {
  transition: height 5000ms;
  width: 572px;
}
#task-preview,
#replies-preview {
  cursor: pointer;
}
.bg-light-gr {
  background-color: #efefef;
}
.modal-content {
  margin-top: 10% !important;
  transform: scale(2) !important;
}
.col-md-4 {
  z-index: 1;
}
/*.ql-editor{*/
/*  background-color: red !important;*/
/*  height: 10000px !important;*/
/*}*/

.img-editor{
  margin-left: 30%;
}
.events_group{
  padding: 20px;
}

.copy-button{
  border-radius: 25px !important;
}
.copy-button:active{
  background-color: #cccccc;
}

</style>
